[
  {
    "id": 310,
    "uuid": "2ccf0532-9f1f-418f-a778-d097b4a1fcbf",
    "hitokoto": "阳光灼热，数不尽夏日繁华；蝉鸣幽幽，道不完苦辣酸甜。",
    "type": "d",
    "from": "危险同居人",
    "from_who": null,
    "creator": "qq745840496",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949194",
    "length": 26
  },
  {
    "id": 311,
    "uuid": "a0a3bf4d-3f48-4a31-b3f7-486c0b5788df",
    "hitokoto": "控兄是我的个性的同时，也是勋章！",
    "type": "d",
    "from": "就算是哥只要有爱就没问题吧",
    "from_who": null,
    "creator": "萧",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949194",
    "length": 16
  },
  {
    "id": 312,
    "uuid": "6565dfd9-63a7-47a1-9ccd-049906426fcf",
    "hitokoto": "想要成为无论多么悲伤的时候，也能够漂亮微笑的人吧。",
    "type": "d",
    "from": "文学少女",
    "from_who": null,
    "creator": "砕月",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949194",
    "length": 25
  },
  {
    "id": 313,
    "uuid": "305b213a-d90b-4405-b557-d34912d4000d",
    "hitokoto": "但是，这一次你将不再孤独。",
    "type": "d",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "liyulong729",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949195",
    "length": 13
  },
  {
    "id": 314,
    "uuid": "b6444c28-2785-4768-9744-2c4133d53696",
    "hitokoto": "会长和往常一样挺着小小的胸部一副自以为了不起的样子套用某本书的内容说道……",
    "type": "d",
    "from": "学生会的一己之见",
    "from_who": null,
    "creator": "SD影",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949195",
    "length": 37
  },
  {
    "id": 315,
    "uuid": "1d4d1994-93dc-4c7d-919d-d6efc01cc494",
    "hitokoto": "我一直以为人是慢慢变老的，其实不是，人是一瞬间变老的。",
    "type": "d",
    "from": "舞！舞！舞！",
    "from_who": null,
    "creator": "優しさの猫",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949195",
    "length": 27
  },
  {
    "id": 316,
    "uuid": "b528c24f-13fd-4994-82a0-ff0b08db789e",
    "hitokoto": "情深不寿，强极则辱，谦谦君子，温润如玉。",
    "type": "d",
    "from": "书剑恩仇录",
    "from_who": null,
    "creator": "Hubert",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949195",
    "length": 20
  },
  {
    "id": 317,
    "uuid": "3bd38b47-a29a-437e-bd53-0a8c7e715802",
    "hitokoto": "救救我啊奥特曼，哪怕你只能撑三分钟……",
    "type": "d",
    "from": "肯普法",
    "from_who": null,
    "creator": "E聋魍魉",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949195",
    "length": 19
  },
  {
    "id": 318,
    "uuid": "64f627b9-ddec-4071-b271-12ca4a46c816",
    "hitokoto": "正义不会因为无人歌颂而变成非议。",
    "type": "d",
    "from": "阿亚罗克年代记",
    "from_who": null,
    "creator": "苍之轨迹",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949196",
    "length": 16
  },
  {
    "id": 319,
    "uuid": "be0d8916-f5a2-4310-96e1-4380fff9d0df",
    "hitokoto": "夹在我女友与前女友与青梅竹马间的果然是修罗场！",
    "type": "d",
    "from": "夹在我女友与青梅竹马间的各种修罗场",
    "from_who": null,
    "creator": "萧",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949196",
    "length": 23
  },
  {
    "id": 320,
    "uuid": "89067daa-a146-4b5a-98f7-4107afe4a359",
    "hitokoto": "树大必有枯枝，人多必有白痴。",
    "type": "d",
    "from": "谢谢你！坏运",
    "from_who": null,
    "creator": "hsk",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949196",
    "length": 14
  },
  {
    "id": 321,
    "uuid": "fa0da4a8-e625-45ce-bce8-98ebe3a2471c",
    "hitokoto": "用我一生，换你十年天真无邪。",
    "type": "d",
    "from": "盗墓笔记",
    "from_who": null,
    "creator": "秦木",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949196",
    "length": 14
  },
  {
    "id": 322,
    "uuid": "1d66c8ba-aee6-4fd6-9523-f7978478b14f",
    "hitokoto": "这是傻瓜的血脉使然啊。",
    "type": "d",
    "from": "有顶天家族",
    "from_who": null,
    "creator": "Sumire",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949197",
    "length": 11
  },
  {
    "id": 323,
    "uuid": "a3b628aa-89e7-4102-9a53-390764f8e944",
    "hitokoto": "想了解喜欢的人，可是，却不能理解。",
    "type": "d",
    "from": "文学少女",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949198",
    "length": 17
  },
  {
    "id": 324,
    "uuid": "af392f97-ef3a-4efe-a3dd-c9e4f69e348f",
    "hitokoto": "不会停的雨的确存在，但是撑起伞来就行了，接下来抬起头前进，这样一来，偶尔会出现下着太阳雨的日子，经过阳光的反射闪闪发亮的雨滴，一定非常美丽。",
    "type": "d",
    "from": "秋之回忆Memories Off",
    "from_who": null,
    "creator": "青熊兽真烦人",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949198",
    "length": 70
  },
  {
    "id": 325,
    "uuid": "111d811f-bc88-41a0-96db-931dcb14ee65",
    "hitokoto": "不能哭！唱歌吧！继续唱下去吧！不是为了赞美神，是为了向神挑战而唱！",
    "type": "d",
    "from": "文学少女",
    "from_who": null,
    "creator": "库腐腐",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949199",
    "length": 33
  },
  {
    "id": 326,
    "uuid": "40fbb8b9-a3c8-4aea-9c4d-80d1439971f5",
    "hitokoto": "生我何用？不能欢笑。灭我何用？不减狂骄。",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "kaomao",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949199",
    "length": 20
  },
  {
    "id": 327,
    "uuid": "5a97c2b3-123c-4e7c-8f3a-4b38442496b9",
    "hitokoto": "要让一群人团结起来，需要的不是英明的领导，而是共同的敌人。",
    "type": "d",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "当歌",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949202",
    "length": 29
  },
  {
    "id": 328,
    "uuid": "899dc4eb-9f1a-4d2b-ab19-480ff0c4af6d",
    "hitokoto": "风停之后再扬帆，船绝不会前行。",
    "type": "d",
    "from": "分身",
    "from_who": null,
    "creator": "c7318418",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949203",
    "length": 15
  },
  {
    "id": 329,
    "uuid": "33414acf-542c-4842-80c2-4b5fe44ecab5",
    "hitokoto": "我发过誓，再也不装作没察觉，再也不逃避。",
    "type": "d",
    "from": "文学少女",
    "from_who": null,
    "creator": "阎罗小菲",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949203",
    "length": 20
  },
  {
    "id": 330,
    "uuid": "d37d78e1-d78b-477d-9a8b-f9060d0edb3c",
    "hitokoto": "桑丘，让他们管我叫疯子吧，我还疯得不够，所以得不到他们的赞许。",
    "type": "d",
    "from": "堂吉诃德",
    "from_who": null,
    "creator": "l863921044",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949204",
    "length": 31
  },
  {
    "id": 331,
    "uuid": "23413edd-80ec-4b1c-a0a2-1f1053ad1a1f",
    "hitokoto": "就算是沉落地面的太阳，只要夜晚过了一定会再度升起，不管有什么痛苦或难过的事，跟今天截然不同的明天也一定会到来。",
    "type": "d",
    "from": "文学少女",
    "from_who": null,
    "creator": "三酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949205",
    "length": 55
  },
  {
    "id": 332,
    "uuid": "3bf47268-0ad6-4bee-b8f6-1d88a825869d",
    "hitokoto": "只是，想要做些什么而已。 觉得不做些什么就会死掉而已。",
    "type": "d",
    "from": "戏言",
    "from_who": null,
    "creator": "苦橙の种",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949206",
    "length": 27
  },
  {
    "id": 333,
    "uuid": "ef07c3ef-caed-451b-9f49-eecd4f4fc2b5",
    "hitokoto": "你永远是我唯爱旅行中名为秘密的起点站。",
    "type": "d",
    "from": "绘心",
    "from_who": null,
    "creator": "Samurai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949207",
    "length": 19
  },
  {
    "id": 334,
    "uuid": "e2dbfba1-5b44-4da0-8a2b-f66913b2d654",
    "hitokoto": "我如朝露降人间，和风樱花随春谢。四十九年一朝梦，一期荣华一杯酒。",
    "type": "d",
    "from": "上杉谦信",
    "from_who": null,
    "creator": "缩叶子",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949209",
    "length": 32
  },
  {
    "id": 335,
    "uuid": "49182cd8-0022-43b9-a44b-b6a06c36d7ab",
    "hitokoto": "安心地睡吧，就算你将遗忘一切，我也会永远记得。我将为你而生、为你而死。",
    "type": "d",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "icecai123",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949211",
    "length": 35
  },
  {
    "id": 336,
    "uuid": "08da9f0f-ba4c-4be5-a9ad-3bc8304153b8",
    "hitokoto": "愿我等之誓言，超越姓名与身份而永存。",
    "type": "d",
    "from": "风姿物语",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949215",
    "length": 18
  },
  {
    "id": 337,
    "uuid": "44c8dfa7-8228-41d9-98fb-98a8b8da1f77",
    "hitokoto": "江湖可能因为少了谁而失色，却不会因为少了谁后就不再是江湖。",
    "type": "d",
    "from": "高手寂寞",
    "from_who": null,
    "creator": "依韵",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949218",
    "length": 29
  },
  {
    "id": 338,
    "uuid": "85a9d763-9b6e-4cbf-8220-d4ac07c13741",
    "hitokoto": "你有学校也有朋友，但对我来说，我的生活中就只有你。",
    "type": "d",
    "from": "我与狗狗的十个约定",
    "from_who": null,
    "creator": "Natsume_rin",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949230",
    "length": 25
  },
  {
    "id": 339,
    "uuid": "4172e509-58dd-4a29-8e85-8a6dcfc8c2d0",
    "hitokoto": "日子过的象流水一般。它静静的从我们身边缓缓流过，不带半分声响。那些我们当年执着的人，执着的事，执着之后，却变成一种负担。",
    "type": "d",
    "from": "凑合活着",
    "from_who": null,
    "creator": "占星术杀人魔法",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949242",
    "length": 60
  },
  {
    "id": 340,
    "uuid": "bbe62848-6bae-4ae0-ba57-6f04ddf700a9",
    "hitokoto": "比起有一百个朋友，不如有个比一百人还要重要的真心朋友。",
    "type": "d",
    "from": "我的朋友很少",
    "from_who": null,
    "creator": "Ntsume_rin",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949266",
    "length": 27
  },
  {
    "id": 568,
    "uuid": "7bd3536a-d8d5-4962-953f-806cea56afd9",
    "hitokoto": "我希望你可以找到真正的自己，不是明年，不是明日，而是现在。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562573",
    "length": 29
  },
  {
    "id": 569,
    "uuid": "e73b77e8-298b-414d-849a-29ecd218b4da",
    "hitokoto": "杂耍和唱歌的才需要掌声。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562633",
    "length": 12
  },
  {
    "id": 570,
    "uuid": "31608d22-da0d-43e2-ac98-7d18589ccfe2",
    "hitokoto": "世间本无公平可言，除非公平掌握在自己手中。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562680",
    "length": 21
  },
  {
    "id": 571,
    "uuid": "67cdbade-ae23-40d6-a45c-077072fed1e2",
    "hitokoto": "死亡过于绝对，而活着，则有无限的可能。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562817",
    "length": 19
  },
  {
    "id": 572,
    "uuid": "8ad8fc83-da2d-4182-a844-f50e91662a98",
    "hitokoto": "当一切都消失的时候，你会明白生命究竟有何价值。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563020",
    "length": 23
  },
  {
    "id": 573,
    "uuid": "616032f8-21bb-42cb-94db-e6dbd5748d60",
    "hitokoto": "我们都是阴沟里的虫子,但总还是得有人仰望星空。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563096",
    "length": 23
  },
  {
    "id": 574,
    "uuid": "96237aae-7fe5-49f4-b5c9-03b285a29611",
    "hitokoto": "弱小和无知，都不是生存的障碍，傲慢才是。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563139",
    "length": 20
  },
  {
    "id": 575,
    "uuid": "3e498b17-5036-4981-a75d-9348fa79f5c2",
    "hitokoto": "活着本身就很美妙，如果连这道理都不懂，怎么去探索更深的东西呢？",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563336",
    "length": 31
  },
  {
    "id": 576,
    "uuid": "743e535e-4b5d-4ac0-92fb-0909c4722218",
    "hitokoto": "“哦,要进画里了,孩子们,走好。”——将被二维化的罗辑",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563523",
    "length": 27
  },
  {
    "id": 579,
    "uuid": "7213e295-50ca-487c-8b83-e692f70ea100",
    "hitokoto": "女人应该像水一样的，什么样的地方都能淌得过去啊。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563765",
    "length": 24
  },
  {
    "id": 580,
    "uuid": "a4b190a0-f9fd-404a-adf9-25a03b3fb735",
    "hitokoto": "人只有在害怕的时候才会变勇敢。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473508137",
    "length": 15
  },
  {
    "id": 581,
    "uuid": "0970b877-e45e-4935-b31a-a57c56093363",
    "hitokoto": "我更喜欢死的历史。死的历史用墨水书写，活的历史则用鲜血。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473508085",
    "length": 28
  },
  {
    "id": 582,
    "uuid": "915d96c4-ab1d-488b-b0f4-de95991b00a8",
    "hitokoto": "吾念所归，无惧无退！",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473508012",
    "length": 10
  },
  {
    "id": 583,
    "uuid": "5720c0c1-6a41-4d75-b949-bcb2d69b2693",
    "hitokoto": "很多人宁可否认事实，也不愿面对真相。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473507942",
    "length": 18
  },
  {
    "id": 584,
    "uuid": "c1f53e9c-5090-45bd-8177-8109b33e2187",
    "hitokoto": "飞，都是从堕落开始的。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473507873",
    "length": 11
  },
  {
    "id": 585,
    "uuid": "269a9455-5da0-4855-8688-8475fee28d05",
    "hitokoto": "凡人皆有一死，凡人皆需供奉。",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473507614",
    "length": 14
  },
  {
    "id": 586,
    "uuid": "a7f0a669-1562-4707-a361-75f3a2a4f9ab",
    "hitokoto": "凛冬将至",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473507532",
    "length": 4
  },
  {
    "id": 587,
    "uuid": "aa46c6d9-e9f5-4413-b69d-a535f079536b",
    "hitokoto": "唯一不可阻挡的是时间，它像一把利刃，无声地切开了坚硬和柔软的一切，恒定地向前推进着，没有任何东西能够使它的行进产生丝毫颠簸，它却改变着一切。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473559639",
    "length": 70
  },
  {
    "id": 588,
    "uuid": "05de576f-2b6c-434e-a743-b860e59455d2",
    "hitokoto": "“斩尽杀绝，这是对一个文明最高的重视。”",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473559436",
    "length": 20
  },
  {
    "id": 589,
    "uuid": "c2db0892-f1b1-4567-9101-4371649f6206",
    "hitokoto": "不要回答！不要回答！不要回答！",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473559353",
    "length": 15
  },
  {
    "id": 591,
    "uuid": "5c983ebe-b83a-4e2c-8720-6c11826f13fa",
    "hitokoto": "“妈妈，我将变成萤火虫。”",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473559804",
    "length": 13
  },
  {
    "id": 592,
    "uuid": "29d66fe2-701e-4233-9aac-2ea9ba265a17",
    "hitokoto": "如果命运是一条孤独的河流，谁会是你灵魂的摆渡人？",
    "type": "d",
    "from": "摆渡人",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473560422",
    "length": 24
  },
  {
    "id": 593,
    "uuid": "aebdeb57-e2e3-4aad-b54b-8edd9adb1918",
    "hitokoto": "给岁月以文明，而不是给文明以岁月。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473560328",
    "length": 17
  },
  {
    "id": 594,
    "uuid": "08e41199-6eac-4d8c-8a7e-f875911af003",
    "hitokoto": "如果我真的存在，也是因为你需要我。",
    "type": "d",
    "from": "摆渡人",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473560447",
    "length": 17
  },
  {
    "id": 599,
    "uuid": "af474229-af4d-45f5-9663-cb9dbee3f41a",
    "hitokoto": "生命的本质就是在关系中寻找自己，并成为真正的自己;在关系中寻找爱，并成为爱。",
    "type": "d",
    "from": "le petit prince",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473560752",
    "length": 38
  },
  {
    "id": 603,
    "uuid": "73515609-af62-4acc-a9b8-82c6a9430afd",
    "hitokoto": "生命从无中来，到无中去，每个人都处于“上场——谢幕”这样一个循环中。这个循环不是悲伤，不是无意义，意义就在这过程中;生命之所以有趣，就在于过程中的体验和收获。",
    "type": "d",
    "from": "le petit prince",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473560891",
    "length": 79
  },
  {
    "id": 604,
    "uuid": "6193fdd3-8233-445c-97c4-c93a501af6a1",
    "hitokoto": "1379号监听员对元首说：我是个小人物，生活在社会最底层，没有人会注意到我，孤独一生，没有地位没有爱情，也没有希望。如果我能够拯救一个自己爱上的遥远的美丽世界，那这一辈子至少没有白活。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473563689",
    "length": 92
  },
  {
    "id": 679,
    "uuid": "b36152ba-5740-41c1-a965-2b9c628d3135",
    "hitokoto": "“人，是会思考的芦苇。”",
    "type": "d",
    "from": "帕斯卡，《思想录》",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476023406",
    "length": 12
  },
  {
    "id": 713,
    "uuid": "0ca485e1-70e3-4904-8017-0492bb5cac41",
    "hitokoto": "我们往往把自己的性格和人品说得言过其实了。如果真理被冷酷无情地揭示出来时，我们反倒不能明辨是非了。",
    "type": "d",
    "from": "三幕悲剧",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 49
  },
  {
    "id": 717,
    "uuid": "376eed36-b5bf-468e-a80d-e0b33521eb9f",
    "hitokoto": "荒诞也好，愚笨也好，总会过去的。",
    "type": "d",
    "from": "一瞬的光和永远",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 729,
    "uuid": "9a3b5a7c-c34b-41cf-96a4-a03f151b052a",
    "hitokoto": "有时你飞到了头，却发现还不如中间掉下来",
    "type": "d",
    "from": "球状闪电",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 744,
    "uuid": "2dfdd733-2f83-427a-8a6f-8afe440da692",
    "hitokoto": "这是计划的一部分。",
    "type": "d",
    "from": "三体II",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 9
  },
  {
    "id": 753,
    "uuid": "e4c6b54c-9879-455f-b079-5acd77c31397",
    "hitokoto": "叹飘渺，莫过春樱转瞬逝；怜世间,万千繁华始归尘。",
    "type": "d",
    "from": "绯弹的亚里亚",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 24
  },
  {
    "id": 756,
    "uuid": "09b6aa0d-0f18-4bc1-943a-335914fa56ef",
    "hitokoto": "一直向别人撒娇是不允许的 即使想从雨中获得慰藉也不可以 因为 这个国家 很少下雨",
    "type": "d",
    "from": "死后文",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 40
  },
  {
    "id": 808,
    "uuid": "83a91e89-4197-43cb-b915-f8a30c45693f",
    "hitokoto": "遗憾的是我们生活在两条平行直线永远不会相交的世界里。",
    "type": "d",
    "from": "刺青杀人事件",
    "from_who": "早川博士",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 813,
    "uuid": "9e75170f-03b6-464e-b8a3-2aaabc27938f",
    "hitokoto": "要记住伟大的探知可逆定律:如果你能看到一个低墒世界,那个低嫡世界迟早也能看到你,只是时间问题。所以,什么事情都等别人做是危险的。",
    "type": "d",
    "from": "三体III",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 64
  },
  {
    "id": 816,
    "uuid": "1afbb808-2234-4b85-b44c-1666424263ed",
    "hitokoto": "十年前,你爱我,我逃避不见,十年后,我爱你,你不在身边.",
    "type": "d",
    "from": "你若盛开，清风自来",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 28
  },
  {
    "id": 819,
    "uuid": "c410f2e9-b80c-4ae2-8446-06e81c78769d",
    "hitokoto": "“太阳快落下去了，你们的孩子居然不害怕？”“当然不害怕，她知道明天太阳还会升起来的。”",
    "type": "d",
    "from": "三体II",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 43
  },
  {
    "id": 831,
    "uuid": "9941d176-0724-4c44-8100-d209019b32d3",
    "hitokoto": "救救我啊奥特曼，哪怕你只能撑三分钟…",
    "type": "d",
    "from": "肯普法",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 832,
    "uuid": "915bb21b-6c64-4263-b76b-ecdc5db40ec8",
    "hitokoto": "你认为是自己的错误毁灭了太阳系那是很可笑的,这样想实在是太自命不凡了,就像你在地面上做一个倒立,就认为自己举起了地球一样。",
    "type": "d",
    "from": "三体III",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 61
  },
  {
    "id": 844,
    "uuid": "716386f7-0d82-47d5-81c8-1f986c9544ea",
    "hitokoto": "愿人们的爱恨为你加冕",
    "type": "d",
    "from": "郭敬明",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 861,
    "uuid": "191dd6d2-f73e-4db9-86ad-6539c7f885ba",
    "hitokoto": "是啊你是小怪兽，可小怪兽也有小怪兽的好朋友，孤独的小怪兽们害怕得靠在一起，但如果正义的奥特曼要来杀你，我就帮你把正义的奥特曼杀死。可我答应了，却没有做到。",
    "type": "d",
    "from": "龙族3黑月之潮",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 77
  },
  {
    "id": 873,
    "uuid": "66550aa8-29ec-48cc-8164-75802c3d0eec",
    "hitokoto": "无尽虚空，无双幻术，沉沦国度，永世沉沦",
    "type": "d",
    "from": "六道众生",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 884,
    "uuid": "cf631be1-15cf-47d1-8905-0d685b1c458e",
    "hitokoto": "这样的日子，居然一过就是一年多，他们和所有正常的不正常的恋人一样，相爱着，伤害着。 　好像彼此已经在一起很多年了，那种感情，慢慢变成一种习惯。",
    "type": "d",
    "from": "凑合活着",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 71
  },
  {
    "id": 898,
    "uuid": "e4b0210d-ddda-4bea-b206-63a36d5ebcbc",
    "hitokoto": "没有脚踏实地建立起来的东西，就无法形成精神和物质上的支撑。",
    "type": "d",
    "from": "时生",
    "from_who": "东野圭吾",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 29
  },
  {
    "id": 901,
    "uuid": "683b08d7-7373-40a6-bb38-9e8a89a5adf3",
    "hitokoto": "观察的实质是：“不赞美，不责难，甚至也不惋惜，但求了解认识而已。”",
    "type": "d",
    "from": "柴静",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 33
  },
  {
    "id": 903,
    "uuid": "1c4263a4-cc5b-4ea0-836d-ff828c813407",
    "hitokoto": "他们不知道我们是怎样想他们怎样想我们怎样想他们怎样想我们怎样...",
    "type": "d",
    "from": "三体II",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 33
  },
  {
    "id": 912,
    "uuid": "c6a76262-81b6-4b8b-b70e-100298ed2360",
    "hitokoto": "朋友之交，宜得删繁就简。",
    "type": "d",
    "from": "白鹿原",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 915,
    "uuid": "b22be414-164a-495e-a2be-0e78e1e88fee",
    "hitokoto": "我告诉你，我也有我的禁忌，如果你敢那样做，不管用上任何手段，我都会杀了你。",
    "type": "d",
    "from": "幽游白书",
    "from_who": "藏",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 37
  },
  {
    "id": 928,
    "uuid": "20e374c5-d8b9-4749-b448-aba5177cd841",
    "hitokoto": "我需要一块二向箔,清理用。",
    "type": "d",
    "from": "三体III",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 946,
    "uuid": "5482416f-6aca-4940-8f3d-ebf7693b9e99",
    "hitokoto": "每天笑一笑对一个皇帝来说很重要，因为这有助于消化。",
    "type": "d",
    "from": "异人傲世录",
    "from_who": "科恩凯达",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 25
  },
  {
    "id": 949,
    "uuid": "9ce89b87-3dd8-4ddd-abdd-2140112b8426",
    "hitokoto": "整个物理学就像是一个大谜，走到它的尽头，连整个世界是否存在都成了问题。",
    "type": "d",
    "from": "球状闪电",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 35
  },
  {
    "id": 953,
    "uuid": "08d8d22c-2ca9-4562-bbad-84adcbb9c1d0",
    "hitokoto": "生命中曾经有过的所有灿烂，终究都需要用寂寞来偿还。",
    "type": "d",
    "from": "百年孤独",
    "from_who": null,
    "creator": "Hex Lee",
    "creator_uid": 107,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478852919",
    "length": 25
  },
  {
    "id": 955,
    "uuid": "8ff96d3a-2a42-43c5-bf64-b550f1351683",
    "hitokoto": "最孤独的人最亲切，受过伤的人总是笑的最灿烂。",
    "type": "d",
    "from": "素媛",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479435906",
    "length": 22
  },
  {
    "id": 958,
    "uuid": "e3df9693-a102-4644-902e-fa7a948b95a8",
    "hitokoto": "这个房间里只有一个人和一个人，而非两个人，不是吗？",
    "type": "d",
    "from": "戏言系列",
    "from_who": null,
    "creator": "kuro999",
    "creator_uid": 104,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479298058",
    "length": 25
  },
  {
    "id": 959,
    "uuid": "62967bbd-16b5-4b18-90d0-afda4044758a",
    "hitokoto": "大人是不会作梦的。大人呀，是会实现梦想的。",
    "type": "d",
    "from": "戏言系列",
    "from_who": null,
    "creator": "kuro999",
    "creator_uid": 104,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479298036",
    "length": 21
  },
  {
    "id": 963,
    "uuid": "2675bda7-4a16-4999-821e-e3acdbc8967c",
    "hitokoto": "问:相信是什么意思? 答:觉得被人背叛也无所谓，就算被人背叛也不后悔。",
    "type": "d",
    "from": "戏言系列",
    "from_who": null,
    "creator": "kuro999",
    "creator_uid": 104,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479297980",
    "length": 35
  },
  {
    "id": 964,
    "uuid": "5ab54a0d-8be5-4e5f-9c1b-b571718e02a4",
    "hitokoto": "我是个偶尔会发疯的人啊！",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "kuro999",
    "creator_uid": 104,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479720661",
    "length": 12
  },
  {
    "id": 965,
    "uuid": "4f9937ff-7655-4ddc-b292-9af5f2e68975",
    "hitokoto": "如果这个世界不喜欢你，那它就是我的敌人了。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "kuro999",
    "creator_uid": 104,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479720766",
    "length": 21
  },
  {
    "id": 999,
    "uuid": "c6f16d1a-239e-4a7b-82a6-93352eb5e945",
    "hitokoto": "一生中会遇上很多人，真正能停留驻足的又有几个，生命是终将荒芜的渡口，连我们自己都是过客。",
    "type": "d",
    "from": "人生若只如初见",
    "from_who": "安如意",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 44
  },
  {
    "id": 1011,
    "uuid": "d7878c68-6802-49c7-9578-50226480819d",
    "hitokoto": "得来不易的机会，会让所有的动物去做原来不喜欢做的事。",
    "type": "d",
    "from": "我是猫",
    "from_who": "夏目漱石",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 26
  },
  {
    "id": 1018,
    "uuid": "e81f55f5-a7a5-499e-858f-c639acffd051",
    "hitokoto": "如果你掉进了黑暗里，你能做的，不过是静心等待，直到你的双眼适应黑暗。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": "村上春树",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 34
  },
  {
    "id": 1024,
    "uuid": "41998a60-0a18-4a3e-8738-f866e819756c",
    "hitokoto": "你永远也看不到我最寂寞时候的样子，因为只有你不在我身边的时候，我才最寂寞。",
    "type": "d",
    "from": "爱与痛的边缘",
    "from_who": "郭敬明",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 37
  },
  {
    "id": 1025,
    "uuid": "eaf4cbd0-55d7-4c0c-bf52-d56570965bce",
    "hitokoto": "希望你可以记住我，记住我这样活过，这样在你身边呆过。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": "村上春树",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 26
  },
  {
    "id": 1032,
    "uuid": "5a66d868-7d34-4785-83c5-e8e0424cdd82",
    "hitokoto": "到底要被救多少次，才会甘心啊！？",
    "type": "d",
    "from": "在地下城寻找邂逅是否搞错了什么",
    "from_who": "贝尔",
    "creator": "1277326952",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 16
  },
  {
    "id": 1057,
    "uuid": "d12b0d30-4139-4756-ab40-8989b45fdc8a",
    "hitokoto": "真正的惩罚是会留在心和记忆里面的。",
    "type": "d",
    "from": "白夜行",
    "from_who": "东野圭吾",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1059,
    "uuid": "1c7e8945-9892-4610-89af-38ba21bc1430",
    "hitokoto": "自以为是永远都是大敌，因为本可看到的东西也会视而不见。",
    "type": "d",
    "from": "嫌疑人x的献身",
    "from_who": "汤川",
    "creator": "953808400",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 27
  },
  {
    "id": 1060,
    "uuid": "e3696449-4b9f-425e-9772-b455da2c0b35",
    "hitokoto": "人与人之间情断义绝，并不需要什么具体理由，就算表面上有，也很可能只是心已经离开的结果，事后才编造出的借口而已。",
    "type": "d",
    "from": "解忧杂货铺",
    "from_who": "东野圭吾",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 55
  },
  {
    "id": 1068,
    "uuid": "4cb45bec-1e14-44b3-982c-ea02df3159f7",
    "hitokoto": "友情其实和爱情一样，很多的时候，距离才可以让彼此更懂得彼此。",
    "type": "d",
    "from": "左手倒影右手年华",
    "from_who": "郭敬明",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 30
  },
  {
    "id": 1071,
    "uuid": "23b82473-e96f-47ba-a4f7-3e8546088805",
    "hitokoto": "只要是亲生父母，除非你去犯罪，否则你干什么他们不支持你呢。",
    "type": "d",
    "from": "解忧杂货店",
    "from_who": "东野圭吾",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 29
  },
  {
    "id": 1096,
    "uuid": "302f2ec6-c2ea-4843-946e-5b16cfcfe9b8",
    "hitokoto": "一个人之所以幸福，并不是他得天独厚，只是那个人心想着幸福，为忘记痛苦而努力，为变得幸福而努力。",
    "type": "d",
    "from": "十二国记",
    "from_who": null,
    "creator": "2241448500",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 47
  },
  {
    "id": 1115,
    "uuid": "57533f23-c3c3-4ee0-a3ea-93de7358cf37",
    "hitokoto": "他们只是想保护自己的灵魂，结果，雪穗从不以真面目示人，亮司则至今仍在黑暗的通风管中徘徊。",
    "type": "d",
    "from": "白夜行",
    "from_who": "东野圭吾",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 44
  },
  {
    "id": 1130,
    "uuid": "65471b8a-9bb9-4440-8ac9-2d9892f98e27",
    "hitokoto": "书是好东西啊，打开时能触动心灵，合上时能触动敌人的脑袋，这样好的东西真是令人喜欢啊",
    "type": "d",
    "from": "希灵帝国",
    "from_who": null,
    "creator": "kiseopt",
    "creator_uid": 202,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1484044550",
    "length": 41
  },
  {
    "id": 1145,
    "uuid": "b67ad065-09b6-4e90-9078-7564d55e7962",
    "hitokoto": "当欲望失去了枷锁，向左是地狱，向右也是地狱。",
    "type": "d",
    "from": "尘缘",
    "from_who": null,
    "creator": "小兵的回忆",
    "creator_uid": 245,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1487730924",
    "length": 22
  },
  {
    "id": 1233,
    "uuid": "f8ab9e48-a6a8-4a3d-9502-047455ecf39f",
    "hitokoto": "目的虽有，却无路可循；我们称之为路的，无非是踌躇。",
    "type": "d",
    "from": "误入世界",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502781382",
    "length": 25
  },
  {
    "id": 1237,
    "uuid": "553e1231-7711-4b28-950d-26386bd39bf9",
    "hitokoto": "胆小鬼连幸福都害怕，碰到棉花都会受伤。",
    "type": "d",
    "from": "人间失格",
    "from_who": null,
    "creator": "zetar",
    "creator_uid": 504,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502952944",
    "length": 19
  },
  {
    "id": 1243,
    "uuid": "10475cb0-a168-47ab-87fa-eef8ee69b68f",
    "hitokoto": "怎样都好，只要能让他们发笑就好。",
    "type": "d",
    "from": "人间失格",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505309892",
    "length": 16
  },
  {
    "id": 1250,
    "uuid": "22cafbd5-970e-4ce7-96e5-faa2136a474a",
    "hitokoto": "人类的智慧就如同孔雀的羽毛。极尽炫耀，只是为了吸引异性。",
    "type": "d",
    "from": "西部世界",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505899495",
    "length": 28
  },
  {
    "id": 1279,
    "uuid": "d0204ced-b80b-4c2f-a1ec-cb9865455c68",
    "hitokoto": "只有坦然接受命运的不公，才能安然享受生命的平等。",
    "type": "d",
    "from": "站在两个世界的边缘",
    "from_who": null,
    "creator": "肖白开",
    "creator_uid": 673,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509604582",
    "length": 24
  },
  {
    "id": 1280,
    "uuid": "e4936f14-05c7-4c8b-83ef-47154aec2f28",
    "hitokoto": "我们一路奋战，不是为了改变世界，而是为了不让世界改变我们。",
    "type": "d",
    "from": "熔炉",
    "from_who": null,
    "creator": "肖白开",
    "creator_uid": 673,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509604001",
    "length": 29
  },
  {
    "id": 1281,
    "uuid": "d235e92e-342d-4ba2-8a87-6a9ef33d911b",
    "hitokoto": "公民们，庇护所即将关闭，感谢所有人，再见。",
    "type": "d",
    "from": "异常生物见闻录",
    "from_who": null,
    "creator": "mahoroshi",
    "creator_uid": 684,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509676200",
    "length": 21
  },
  {
    "id": 1285,
    "uuid": "6bba3f9d-c6e6-41df-b27d-25e96dc6ad55",
    "hitokoto": "太想伸手摘取星星的人，常常忘记脚下的鲜花。",
    "type": "d",
    "from": "杰里米·边沁",
    "from_who": null,
    "creator": "默念。",
    "creator_uid": 694,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509737856",
    "length": 21
  },
  {
    "id": 1286,
    "uuid": "d625b1f2-014a-4bc9-9c6b-76a47e43c8f4",
    "hitokoto": "反正不要钱，多少信一点",
    "type": "d",
    "from": "异常生物见闻录",
    "from_who": null,
    "creator": "mahoroshi",
    "creator_uid": 684,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509675031",
    "length": 11
  },
  {
    "id": 1290,
    "uuid": "5b247515-0473-413c-8be9-938726fc7491",
    "hitokoto": "我发现一个人在放弃给别人留好印象的负担之后，原来心里会如此踏实。一个人不必再讨人欢喜，就可以像我此刻这样，停止受累。",
    "type": "d",
    "from": "无出路咖啡馆",
    "from_who": null,
    "creator": "Lion",
    "creator_uid": 679,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509619093",
    "length": 58
  },
  {
    "id": 1293,
    "uuid": "2602e0e6-155b-45da-a8e1-3ab0fcd26554",
    "hitokoto": "我爱你是一连串夹七缠八永远说不清楚很难明白可能最好就不要懂了的爱你。",
    "type": "d",
    "from": "无题之二",
    "from_who": null,
    "creator": "Lion",
    "creator_uid": 679,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509619061",
    "length": 34
  },
  {
    "id": 1302,
    "uuid": "a9229811-04d4-4c9f-968f-d427635d1cdf",
    "hitokoto": "得到了再失去，总是比从来就没有得到更伤人。",
    "type": "d",
    "from": "追风筝的人",
    "from_who": null,
    "creator": "知你分子",
    "creator_uid": 830,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512005349",
    "length": 21
  },
  {
    "id": 1303,
    "uuid": "914c0b50-8909-4625-86d6-7b53b9319a2b",
    "hitokoto": "你最可爱,我说时来不及思索,但思索过后,还是这样说",
    "type": "d",
    "from": "普希金",
    "from_who": null,
    "creator": "知你分子",
    "creator_uid": 830,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512005379",
    "length": 25
  },
  {
    "id": 1309,
    "uuid": "1a2009fa-e2f1-4771-8024-c70ed28d8e33",
    "hitokoto": "能诚实地承认穷，诚恳地表达对于钱的兴趣，就是穷者的尊严。",
    "type": "d",
    "from": "无出路咖啡馆",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512632188",
    "length": 28
  },
  {
    "id": 1310,
    "uuid": "6f805b07-b112-4e5c-b706-db84b0f77932",
    "hitokoto": "如果到了一个遥远陌生的国度，还不去改变或者推翻自己的曾经，那这远走高飞还有什么飞头？",
    "type": "d",
    "from": "无出路咖啡馆",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512632105",
    "length": 42
  },
  {
    "id": 1311,
    "uuid": "19c43133-88b6-4c46-bf21-9c8941ba150f",
    "hitokoto": "流浪汉最受不了的或许不是吃不饱喝不足，而是他们终日终年的沉默。人们会赏他们一两个角子，但从来不赏个面子站下脚，听他们说句话",
    "type": "d",
    "from": "无出路咖啡馆",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512632156",
    "length": 61
  },
  {
    "id": 1313,
    "uuid": "a5088b8d-ac04-4544-88a8-43e11269045b",
    "hitokoto": "人总是健忘的，所以在行走一段人生旅途后，总要不自觉地停下来，整理一下前段时间的得与失，得大于失证明这段时间没有浪费，欣喜若狂的准备下一段旅途。",
    "type": "d",
    "from": "唐砖",
    "from_who": null,
    "creator": "宝宝洗头爱飘柔",
    "creator_uid": 898,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512718148",
    "length": 71
  },
  {
    "id": 1331,
    "uuid": "bea100c9-91dd-48d4-a2fe-92c032656985",
    "hitokoto": "这个世界没有公平也从来没有公平过，我们，我们的血，并非是我们选择了命运，而是命运选择了我们。",
    "type": "d",
    "from": "凤凰",
    "from_who": null,
    "creator": "kyr",
    "creator_uid": 943,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513434042",
    "length": 46
  },
  {
    "id": 1339,
    "uuid": "b1c35f99-11b8-41d3-8ca9-39ed95242ecc",
    "hitokoto": "上帝给了人类有限的力量，但是却给了他们无限的欲望。",
    "type": "d",
    "from": "基督山伯爵",
    "from_who": null,
    "creator": "Mockaven",
    "creator_uid": 701,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514635611",
    "length": 25
  },
  {
    "id": 1340,
    "uuid": "062e8ca2-3b9a-4db5-850d-1072c322050d",
    "hitokoto": "请你,驯养我吧",
    "type": "d",
    "from": "小王子",
    "from_who": null,
    "creator": "玉狐",
    "creator_uid": 1000,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514703719",
    "length": 7
  },
  {
    "id": 1343,
    "uuid": "30a4cef2-ff9b-49ca-9842-da9d99975de7",
    "hitokoto": "永远不要忘记,直至天主垂允为人类揭示未来图景的那一天来到之前,人类的全部智慧就包含在这五个字里面：等待和希望.",
    "type": "d",
    "from": "基督山伯爵",
    "from_who": null,
    "creator": "Mockaven",
    "creator_uid": 701,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514635450",
    "length": 55
  },
  {
    "id": 1357,
    "uuid": "e4b6afc6-a550-45f2-b1da-ccfbff67dec9",
    "hitokoto": "终有一天你会跨过静谧无声的洗墨江，离开群山环抱的旧桃源，来到无边阴霾的夜空之下。你要记得，命运悬在刀尖上，而刀尖须得永远向前。愿你在冷铁卷刃前，得以窥见天光。",
    "type": "d",
    "from": "有匪",
    "from_who": null,
    "creator": "一顿吃三斤",
    "creator_uid": 1132,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1517886880",
    "length": 79
  },
  {
    "id": 1358,
    "uuid": "dc8b29d0-0971-4974-b395-728b77d2a56c",
    "hitokoto": "所有的漩涡与波浪都痛苦而急切地奔向自己的目标——许许多多不同的目标：奔向瀑布，奔向大海，奔向河流，直至百川汇集的大洋。",
    "type": "d",
    "from": "悉达多",
    "from_who": null,
    "creator": "EntropyIncreaser",
    "creator_uid": 1153,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1518501692",
    "length": 59
  },
  {
    "id": 1376,
    "uuid": "aac4ec9d-93d1-4ee8-807d-1a645b51483c",
    "hitokoto": "无论发生什么事情，哪怕是一个人成了一个没有了灵魂的躯体，那另一个人也还是要努力地工作下去。",
    "type": "d",
    "from": "居里夫人传",
    "from_who": null,
    "creator": "yemaster",
    "creator_uid": 1159,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1518611329",
    "length": 45
  },
  {
    "id": 1383,
    "uuid": "58423aa0-9ab1-4d6d-9bab-086a643e2545",
    "hitokoto": "宇宙很大，生活更大也许以后有缘再相见",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "焱影",
    "creator_uid": 1181,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1519211922",
    "length": 18
  },
  {
    "id": 3587,
    "uuid": "5ff834c6-0a4d-48b5-92d3-2e1732918ae4",
    "hitokoto": "黑，真他妈黑啊",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521446394",
    "length": 7
  },
  {
    "id": 3598,
    "uuid": "e6e4051b-f447-4525-b6f7-12d6626f7e1a",
    "hitokoto": "我要这天，再遮不住我眼，要这地，再埋不了我心，要这众生，都明白我意，要那诸佛，都烟消云散!",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579110",
    "length": 45
  },
  {
    "id": 3599,
    "uuid": "aa5e17a9-d8c9-4db0-a593-87fc06af438a",
    "hitokoto": "生我何用？不能欢笑。灭我何用？不减狂骄。",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579163",
    "length": 20
  },
  {
    "id": 3600,
    "uuid": "3c9a92a4-0feb-4f9b-884d-4d04034d72ac",
    "hitokoto": "这个天地，我来过，我奋战过，我深爱过，我不在乎结局。",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579250",
    "length": 26
  },
  {
    "id": 3601,
    "uuid": "92603b75-9c68-4776-97b8-1221843dfb24",
    "hitokoto": "若天压我，劈开那天，若地拘我，踏碎那地，我等生来自由身，谁敢高高在上。",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579284",
    "length": 35
  },
  {
    "id": 3603,
    "uuid": "757af010-dadd-40a2-adef-e25233243f9f",
    "hitokoto": "神不贪，为何容不得一点对其不敬?神不恶，为何要将地上千万生灵命运，握于手中？",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579369",
    "length": 38
  },
  {
    "id": 3605,
    "uuid": "283af4ee-3796-4989-9895-3bb3120ab266",
    "hitokoto": "你心中无爱，怎会懂珍惜二字。",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579478",
    "length": 14
  },
  {
    "id": 3606,
    "uuid": "48ef1cf6-5882-4cb7-bdba-43de4afff52f",
    "hitokoto": "当恶梦展开，所有的一切都开始失序了。人类，可以为了所爱的人，变成天使，也可以为了所爱的人，变成魔鬼。这个世界上，所有的事物都是相对应的，有人得到，就代表有人会失去",
    "type": "d",
    "from": "终极恶女",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579615",
    "length": 81
  },
  {
    "id": 3630,
    "uuid": "ec18a2fd-0e19-4171-9179-72e82f64c814",
    "hitokoto": "After all,tomorrow is another day!",
    "type": "d",
    "from": "费雯·丽",
    "from_who": null,
    "creator": "k1263",
    "creator_uid": 1496,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1526042097",
    "length": 34
  },
  {
    "id": 3666,
    "uuid": "c33aa985-a48a-4627-bcf6-48e41a0197b3",
    "hitokoto": "不值得，但是，痛快。",
    "type": "d",
    "from": "黑瞳的圣杯跑团战争",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530013787",
    "length": 10
  },
  {
    "id": 3668,
    "uuid": "afd9a5f5-2e01-4964-b050-c6ea06f2dc83",
    "hitokoto": "怎样都好，只要能让他们发笑就好。",
    "type": "d",
    "from": "人间失格",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014377",
    "length": 16
  },
  {
    "id": 3682,
    "uuid": "a2f5a3d4-a0eb-42fa-9ccb-a7feca45a85a",
    "hitokoto": "君看双眼色，不语似无忧",
    "type": "d",
    "from": "俳句  罗生门",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014153",
    "length": 11
  },
  {
    "id": 3692,
    "uuid": "dc521a9b-5f9b-4751-b98f-6dda033fce17",
    "hitokoto": "那些过去，从未过去。",
    "type": "d",
    "from": "毕业了，我们一无所有",
    "from_who": null,
    "creator": "萌阳~",
    "creator_uid": 1741,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530696382",
    "length": 10
  },
  {
    "id": 3702,
    "uuid": "efa5519e-b9a2-4214-adea-f23a01735316",
    "hitokoto": "“一个真正想死的人 不会再计较人们说什么 一个拿死说来说去的人 以我的经验来看 并不是真的想死 而是……” “而是什么？” “而是还在……还在渴望爱”",
    "type": "d",
    "from": "务虚笔记",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014833",
    "length": 75
  },
  {
    "id": 3741,
    "uuid": "eb73f597-f70d-45d4-a7f1-b30f8f1621b0",
    "hitokoto": "天要你走，我要你留",
    "type": "d",
    "from": "一本蛮不错的电子书",
    "from_who": null,
    "creator": "铭CC",
    "creator_uid": 1802,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532181122",
    "length": 9
  },
  {
    "id": 3761,
    "uuid": "083005e8-af81-4a8c-a492-6d9622554785",
    "hitokoto": "我要这天再遮不住我眼,要这地再埋不了我心.",
    "type": "d",
    "from": "悟空传",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533025547",
    "length": 21
  },
  {
    "id": 3764,
    "uuid": "f083fad0-85ba-4191-84ed-c89398d11a96",
    "hitokoto": "我们都做了自己的选择，我们都许下了自己的誓言。我们每个人都要在黑暗中死去。认命。",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533825053",
    "length": 40
  },
  {
    "id": 3765,
    "uuid": "de414926-5c9d-4e69-a043-c345e62a65c2",
    "hitokoto": "我很累，想停下了。就让我停下吧。",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533825097",
    "length": 16
  },
  {
    "id": 3766,
    "uuid": "9b7311c7-7329-4d7f-b4a3-43452bc46538",
    "hitokoto": "我为自己而死，并且，在最后的最后，为自己而活。",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533825205",
    "length": 23
  },
  {
    "id": 3767,
    "uuid": "5de17297-05f5-488a-8838-11125fe772a4",
    "hitokoto": "天不生我李淳罡，剑道万古长如夜。",
    "type": "d",
    "from": "烽火戏诸侯",
    "from_who": null,
    "creator": "曾经小胖纸",
    "creator_uid": 1907,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533899795",
    "length": 16
  },
  {
    "id": 3768,
    "uuid": "205d6357-2b1e-45c2-9dbf-264c534c4f6f",
    "hitokoto": "数一个豆荚之中所有的豆子，或许为它们命名更好，这样它们就不会无名成长了。",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533824968",
    "length": 36
  },
  {
    "id": 3769,
    "uuid": "ddb33c23-c65a-46cf-a30d-7b9f227d7ca1",
    "hitokoto": "我恨自己。我爱自己。",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533824626",
    "length": 10
  },
  {
    "id": 3770,
    "uuid": "24dee96c-d84c-45ed-9ae4-c81b0bd5257a",
    "hitokoto": "今日，吾爱，我们融为一体。",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533824592",
    "length": 13
  },
  {
    "id": 3773,
    "uuid": "62c12303-b3fa-4720-a7c5-2985bf049e60",
    "hitokoto": "过去都是假的，回忆是一条没有归途的路，以往的一切春天都无法复原，即使最狂热最坚贞的爱情，归根结底也不过是一种瞬息即逝的现实，唯有孤独永恒。",
    "type": "d",
    "from": "百年孤独",
    "from_who": null,
    "creator": "戎歌",
    "creator_uid": 1195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532672964",
    "length": 69
  },
  {
    "id": 3785,
    "uuid": "e599c9ae-979a-4c73-b8e3-e5da69108439",
    "hitokoto": "一旦你驯服了什么，就要对她负责，永远的负责。",
    "type": "d",
    "from": "小王子",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106863",
    "length": 22
  },
  {
    "id": 3786,
    "uuid": "8c4a16c0-a000-479d-aea2-1464d921e6c2",
    "hitokoto": "只有用心灵才能看得清事物本质，真正重要的东西是肉眼无法看见的",
    "type": "d",
    "from": "小王子",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106876",
    "length": 30
  },
  {
    "id": 3787,
    "uuid": "ac93f65d-6932-4057-9338-655a7ef30bcb",
    "hitokoto": "我太年轻了，甚至不懂怎么去爱她。",
    "type": "d",
    "from": "小王子",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106886",
    "length": 16
  },
  {
    "id": 3788,
    "uuid": "cca4d590-4bab-4c75-86a4-9e9e3a678ad5",
    "hitokoto": "如果你爱上了某个星球的一朵花。那么，只要在夜晚仰望星空，就会觉得漫天的繁星就像一朵朵盛开的花。",
    "type": "d",
    "from": "小王子",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106897",
    "length": 47
  },
  {
    "id": 3791,
    "uuid": "d0503101-562e-4366-b554-39274346a669",
    "hitokoto": "我们终此一生，就是要摆脱他人的期待，找到真正的自己。",
    "type": "d",
    "from": "无声告白",
    "from_who": null,
    "creator": "unlala",
    "creator_uid": 1894,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533659451",
    "length": 26
  },
  {
    "id": 3795,
    "uuid": "4c399a78-ad5c-4bcf-a51a-d1b1a9aae6cf",
    "hitokoto": "那年的春天，那年的三月。你给我一个承诺，我就哭了。你给我一段爱情，我就真的站在这里舍不得走了。",
    "type": "d",
    "from": "深海里的星星",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106740",
    "length": 47
  },
  {
    "id": 3798,
    "uuid": "5c75c9ba-a753-43a2-90ef-c83afc37c0b7",
    "hitokoto": "得到了再失去，总是比从来就没有得到更伤人。",
    "type": "d",
    "from": "追风筝的人",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106913",
    "length": 21
  },
  {
    "id": 3799,
    "uuid": "72092a5c-88f6-478a-838c-01013c4cd543",
    "hitokoto": "风里有花香，身边有最爱的人。",
    "type": "d",
    "from": "七月与安生",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106952",
    "length": 14
  },
  {
    "id": 3800,
    "uuid": "4c8f6bd2-89f3-46bd-917a-c0290d6145b6",
    "hitokoto": "对不爱我们的人，一旦付出，就罪孽深重",
    "type": "d",
    "from": "八月未央",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106965",
    "length": 18
  },
  {
    "id": 3809,
    "uuid": "a89e1399-5cec-446d-ac18-1b3a5dc91fe2",
    "hitokoto": "Something……for nothing！用什么珍贵的东西，换回了空白。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "ash",
    "creator_uid": 1872,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533187051",
    "length": 38
  },
  {
    "id": 3810,
    "uuid": "c30e1695-7e1d-4ec2-8cb1-e77f9db0d0af",
    "hitokoto": "全世界会有两万个人是你一见到她就会爱上她的，可你也许一辈子都遇不到一个。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "Barry",
    "creator_uid": 854,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533982314",
    "length": 36
  },
  {
    "id": 3815,
    "uuid": "92d3e9aa-62af-4f4a-a7b7-da9390df68c5",
    "hitokoto": "凡心所向，素履可往，生如逆旅，一苇以航。",
    "type": "d",
    "from": "尘曲",
    "from_who": null,
    "creator": "星夜的蓝天",
    "creator_uid": 1945,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534866290",
    "length": 20
  },
  {
    "id": 3826,
    "uuid": "0a2a5e35-972b-4114-9381-bbcf947e9d37",
    "hitokoto": "理智不是一个统计学概念。",
    "type": "d",
    "from": "1984",
    "from_who": null,
    "creator": "acht",
    "creator_uid": 1598,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535250164",
    "length": 12
  },
  {
    "id": 3827,
    "uuid": "2188db89-4afa-45ff-b817-24cb725f01f9",
    "hitokoto": "自由就是说二加二等于四的自由，如此成立，一切同理。",
    "type": "d",
    "from": "1984",
    "from_who": null,
    "creator": "acht",
    "creator_uid": 1598,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535250249",
    "length": 25
  },
  {
    "id": 3828,
    "uuid": "7cd369b1-ab89-4783-92e5-eb635b096ef6",
    "hitokoto": "有一种东西不能遵循从众原则，那就是人的良心。",
    "type": "d",
    "from": "杀死一只知更鸟",
    "from_who": null,
    "creator": "acht",
    "creator_uid": 1598,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535250345",
    "length": 22
  },
  {
    "id": 3838,
    "uuid": "4cdcb583-bce0-4721-9d8a-448044b4e10c",
    "hitokoto": "秩序是恶棍们的通行证，真正的美好应如无形的虚空，你是否仍感幸福？",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231628",
    "length": 32
  },
  {
    "id": 3846,
    "uuid": "ce2b20f0-3bf2-42eb-8a9d-dfb99e85302c",
    "hitokoto": "许多年以后,面对行刑队的时候,奥雷良诺·布恩迪亚上校一定会想起父亲带他去看冰块的那个遥远的下午。",
    "type": "d",
    "from": "百年孤独",
    "from_who": null,
    "creator": "Ade",
    "creator_uid": 2015,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536161027",
    "length": 48
  },
  {
    "id": 3847,
    "uuid": "5bbba145-e0ee-40bc-b3d7-18a3415cb755",
    "hitokoto": "你...真是本末倒置，罔顾人伦！",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446555",
    "length": 16
  },
  {
    "id": 3848,
    "uuid": "77c2ef62-057b-4a61-ac43-4a06f14f99b3",
    "hitokoto": "前尘种种，似烟似幻，惟有此人教我深感不负大好春光。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446503",
    "length": 25
  },
  {
    "id": 3849,
    "uuid": "d1b5d0f6-23f0-49fa-96d9-16a4dd597d56",
    "hitokoto": "天子坛中寻一笑，枕月云深魏无羡。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446492",
    "length": 16
  },
  {
    "id": 3850,
    "uuid": "ce15ddf5-d55c-423d-9838-508612c74796",
    "hitokoto": "你欺他眼盲，骗得他好苦！",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446361",
    "length": 12
  },
  {
    "id": 3851,
    "uuid": "6f7a3baf-9285-4424-94e8-682fc61d1aec",
    "hitokoto": "生来一人，去时孤身，便是江澄其人",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446347",
    "length": 16
  },
  {
    "id": 3852,
    "uuid": "d4d7d631-0bd9-4d82-a641-610d35d74d1c",
    "hitokoto": "义城有三盲，真盲，假盲，心盲。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446318",
    "length": 15
  },
  {
    "id": 3853,
    "uuid": "4734f715-0d22-49f5-99ac-008933758fa2",
    "hitokoto": "愿来世，你晓天，晓地，晓星尘。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446326",
    "length": 15
  },
  {
    "id": 3854,
    "uuid": "28db4510-9dd8-43d5-8cca-aaa932223cf0",
    "hitokoto": "忘羡一曲心系君，瀚海百重长相忆。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446304",
    "length": 16
  },
  {
    "id": 3855,
    "uuid": "76302235-51d3-45c9-83c8-1c5dfa10c97b",
    "hitokoto": "为遇一人而入红尘，人去我亦去，此生不留尘。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446251",
    "length": 21
  },
  {
    "id": 3857,
    "uuid": "3b3be604-1572-4913-98df-e677f50ec956",
    "hitokoto": "负霜华，行世路。一同星尘，除魔歼邪",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446207",
    "length": 17
  },
  {
    "id": 3858,
    "uuid": "bdf47702-577a-44b1-b904-40ae81a6e38a",
    "hitokoto": "明月清风晓星尘，傲雪凌霜宋子琛",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445940",
    "length": 15
  },
  {
    "id": 3859,
    "uuid": "561d1ce0-8d62-40f3-9d14-6781f52a7786",
    "hitokoto": "别师犹染凡心 剑端新雪霁 独恨无留迹",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445870",
    "length": 18
  },
  {
    "id": 3865,
    "uuid": "46277580-7db8-45ae-a345-9e6a3864b79e",
    "hitokoto": "——你是不是喜欢我？——好好学习，天天向上呢。你这问法可真不单纯。",
    "type": "d",
    "from": "他的小初恋",
    "from_who": null,
    "creator": "青衫酒",
    "creator_uid": 1957,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535076859",
    "length": 33
  },
  {
    "id": 3872,
    "uuid": "ac44c044-1915-428a-99b0-36884f893792",
    "hitokoto": "世间哪有恋爱？压根儿是生殖冲动。",
    "type": "d",
    "from": "围城",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536157111",
    "length": 16
  },
  {
    "id": 3875,
    "uuid": "1b458768-87b5-43f2-893c-c6024941fe1d",
    "hitokoto": "心系一处，守口如瓶",
    "type": "d",
    "from": "莫言",
    "from_who": null,
    "creator": "lilywoong",
    "creator_uid": 2045,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536524213",
    "length": 9
  },
  {
    "id": 3889,
    "uuid": "22e77eb4-8c88-4bf7-9ff2-1c96fb45de4c",
    "hitokoto": "“没有期望，就没有失望”，从此之后，再没受过伤害，因为从一开始，就不抱有什么希望。",
    "type": "d",
    "from": "心动可乐",
    "from_who": null,
    "creator": "只会HelloWord的萌新",
    "creator_uid": 2080,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537429381",
    "length": 41
  },
  {
    "id": 3893,
    "uuid": "51e5a0f8-56ab-44de-8dc4-6c0f67b7bb48",
    "hitokoto": "天自撰我命 唤魂为逆 肆酒行 削竹横笛借音",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445773",
    "length": 21
  },
  {
    "id": 3894,
    "uuid": "387a705a-8e67-40e6-800d-0c0a9e17570d",
    "hitokoto": "月濯云深里 留雪拥襟 持琴问灵 拂剑承天地",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445802",
    "length": 21
  },
  {
    "id": 3895,
    "uuid": "df4fa461-5764-45d5-b1d3-c1b6da027b97",
    "hitokoto": "傲骨几锉尽 惟立仇心 十方雷霆乍起 振紫衣",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445823",
    "length": 21
  },
  {
    "id": 3896,
    "uuid": "eec692dc-5efe-473e-b4d3-97800ea1616a",
    "hitokoto": "清风策萍影 远夜如移 纵入冥泥 明镜仍为寄",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445839",
    "length": 21
  },
  {
    "id": 3897,
    "uuid": "867a321b-0cc2-456c-b892-fee3946480d5",
    "hitokoto": "掌覆道左阴翳 妄握天格命理",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445856",
    "length": 13
  },
  {
    "id": 3898,
    "uuid": "db7d29bc-7906-460e-bb4d-d320d95c3161",
    "hitokoto": "度履孤霜千里 凭樽还如对知己 皓月清风长系思与荒城忆",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445882",
    "length": 26
  },
  {
    "id": 3899,
    "uuid": "e56ab54a-4d95-401b-82d8-7e550ad27c5a",
    "hitokoto": "我放着好好的阳关大道不走，走这阴沟里的独木桥干什么。真这么好走早就有人走了。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445916",
    "length": 38
  },
  {
    "id": 3900,
    "uuid": "c810b98e-8468-4139-b1d0-314ba96d8a22",
    "hitokoto": "忘羡一曲远，曲终人不散。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537445980",
    "length": 12
  },
  {
    "id": 3901,
    "uuid": "9adbbb7e-417d-4123-8b11-cd0e1ea61d8c",
    "hitokoto": "这颗糖微微发黑，一定不能吃了。被握的太紧，已经有点碎了。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446008",
    "length": 28
  },
  {
    "id": 3902,
    "uuid": "d87acb10-81ab-4bff-9d97-dfc62971af13",
    "hitokoto": "我想带一人回云深不知处。带回去，藏起来。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446023",
    "length": 20
  },
  {
    "id": 3903,
    "uuid": "7cc3cc18-26d0-4e3b-a44f-05a19f7b94f1",
    "hitokoto": "生前哪管身后事，浪得几日是几日。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446041",
    "length": 16
  },
  {
    "id": 3904,
    "uuid": "0d7dca17-9144-49bb-bc21-b79093723167",
    "hitokoto": "我薛洋，晓天地，晓人心，但终究不晓星尘。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446068",
    "length": 20
  },
  {
    "id": 3905,
    "uuid": "a5165283-84c8-4807-86a1-faaa81ce83d6",
    "hitokoto": "亦恶亦怜薛成美，半生恶尽半生痴。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446085",
    "length": 16
  },
  {
    "id": 3906,
    "uuid": "6ff33851-9ed8-4cd5-9d8b-4af58bf9473b",
    "hitokoto": "云深夜阑拥月色，少年携酒晚归程，酒香醉情抬眸间，白衣翩立似惊鸿。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446100",
    "length": 32
  },
  {
    "id": 3907,
    "uuid": "bbe8326a-26f0-469f-9601-783c735dfef3",
    "hitokoto": "我见诸君多有病，料诸君见我、应如是。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446117",
    "length": 18
  },
  {
    "id": 3908,
    "uuid": "79be7e3c-f61f-430a-a1f8-dbad7a861b43",
    "hitokoto": "七岁断指，断了他的善，死前断臂，断了他的恶。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446128",
    "length": 22
  },
  {
    "id": 3909,
    "uuid": "de672b64-7110-4b87-9108-f5fc3ab0093f",
    "hitokoto": "我等你十三载，你如何回我？",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446140",
    "length": 13
  },
  {
    "id": 3910,
    "uuid": "9719f5ee-d00b-4b4c-99a0-4ff5923c3265",
    "hitokoto": "喝他喝过的酒，受他受过的伤。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446156",
    "length": 14
  },
  {
    "id": 3911,
    "uuid": "03814fda-471f-4ddd-ad71-236896f9d712",
    "hitokoto": "生老病死，八苦之四，众生必经，江澄亦是。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446388",
    "length": 20
  },
  {
    "id": 3912,
    "uuid": "b67e3ff1-81bb-47c0-a209-7cb42e9306d3",
    "hitokoto": "其实从头到尾，被挫骨扬灰，灰飞烟灭的，只有温情一人。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446404",
    "length": 26
  },
  {
    "id": 3913,
    "uuid": "3813212d-bca7-43cb-a075-fe36cbf86ab7",
    "hitokoto": "谁知，蓝忘机自始至终一眼都没有分给过温宁，只是死死盯牢了他。两人就这么你拉着我、我拽着你，面对面地瞪眼。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446423",
    "length": 52
  },
  {
    "id": 3914,
    "uuid": "f7af2249-9adb-40c7-9f8b-b7b28a2b5d22",
    "hitokoto": "喝他喝过的酒，受他受过的伤，种他种过的思追，养他喜欢的兔子，看他看过的小黄书，画他画过的妆。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446435",
    "length": 46
  },
  {
    "id": 3915,
    "uuid": "c3475929-9a66-46d4-bd6f-dfeb58809bef",
    "hitokoto": "薛洋的小指断了，月老怎么牵线呢。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446452",
    "length": 16
  },
  {
    "id": 3916,
    "uuid": "a89232b5-768f-4ce3-9539-b47c213539df",
    "hitokoto": "只羡忘羡不羡仙，说是天天就天天",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446460",
    "length": 15
  },
  {
    "id": 3917,
    "uuid": "26a24256-2207-4f3a-9efd-0ff56cd5dcd5",
    "hitokoto": "夷陵老祖，五文一张，十文三张！",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446472",
    "length": 15
  },
  {
    "id": 3918,
    "uuid": "937864f7-cbb3-4ee0-b9fe-ae7ed4536256",
    "hitokoto": "现在的魏无羡，离开了蓝忘机就不行。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446481",
    "length": 17
  },
  {
    "id": 3919,
    "uuid": "15806f02-97ba-44cc-a4d9-8b8d480437b2",
    "hitokoto": "灵气也是气，怨气也是气，怨气为何不能为人所用啊？",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446546",
    "length": 24
  },
  {
    "id": 3920,
    "uuid": "4cb253b3-f3aa-417e-b3c7-532392ca456f",
    "hitokoto": "对不起，还有......谢谢你",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446670",
    "length": 15
  },
  {
    "id": 3921,
    "uuid": "de05dfd8-63bb-4393-b584-d15aecb2b1c8",
    "hitokoto": "魏婴，你给我听好！好好护着江澄！死也要护着他！知不知道！",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446790",
    "length": 28
  },
  {
    "id": 3922,
    "uuid": "524eaacb-fb34-4299-bf8e-69ec29b6e05e",
    "hitokoto": "蓝曦臣，我这一生害人无数，杀父杀兄杀妻杀子杀师杀友，天下的坏事我什么没做过！......可我独独没有想过要害你",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446834",
    "length": 55
  },
  {
    "id": 3923,
    "uuid": "e919cd62-1db2-4a19-a6b3-a585475d3611",
    "hitokoto": "生前风采有谁听闻 身后恶名竟无人争 当初穿林拂叶见识得 白衣少年胆怯几分",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537446905",
    "length": 36
  },
  {
    "id": 3932,
    "uuid": "a9410011-47f5-447a-9cf2-cad2e202f226",
    "hitokoto": "我应当感谢你，感谢那个造物的上帝，更感谢使我能傍近你的那个命运。",
    "type": "d",
    "from": "沈从文",
    "from_who": null,
    "creator": "Granat",
    "creator_uid": 2111,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538139937",
    "length": 32
  },
  {
    "id": 3958,
    "uuid": "0901c6aa-5bf6-4ffe-ac4a-77eb7a666712",
    "hitokoto": "抬眼一望，银河仿佛哗的一声，向岛村的心头倾泻下来。",
    "type": "d",
    "from": "雪国",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687575",
    "length": 25
  },
  {
    "id": 3990,
    "uuid": "ad00fbbc-cc02-4a1a-98ca-9de73ec74d59",
    "hitokoto": "跳舞，不停地跳舞。不要考虑为什么跳，不要考虑意义不意义，意义那玩意儿本来就是没有的，要是考虑这个，脚步势必停下来。",
    "type": "d",
    "from": "舞！舞！舞！",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687391",
    "length": 57
  },
  {
    "id": 3999,
    "uuid": "3bf8e67f-0cd2-48b2-8feb-6b94eab8f983",
    "hitokoto": "假如温暖的阳光照得到这里，我拉长的身影大概可以覆盖住灰色的鸟和菠萝吧。",
    "type": "d",
    "from": "无限近似于透明的蓝",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540047595",
    "length": 35
  },
  {
    "id": 4000,
    "uuid": "2b3b5656-b421-4c35-8589-782d119b8203",
    "hitokoto": "我们的生命不是和这种孩子的悲伤一样，迅速地消逝在夜色中吗？",
    "type": "d",
    "from": "暗店街",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540047718",
    "length": 29
  },
  {
    "id": 4004,
    "uuid": "6862712a-8638-4ea6-8f50-f3567572bf0f",
    "hitokoto": "超过一定的年龄之后，所谓人生，无非是一个不断丧失的过程而已。",
    "type": "d",
    "from": "1Q84",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540048062",
    "length": 30
  },
  {
    "id": 4031,
    "uuid": "b215d3f2-e355-4306-b635-beb57a36470f",
    "hitokoto": "仿佛这一瞬间，火光也照亮了他同驹子共同度过的岁月。这当中也充满一种说不出的苦痛和悲哀。",
    "type": "d",
    "from": "雪国",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539681190",
    "length": 43
  },
  {
    "id": 4034,
    "uuid": "ad4064e0-a0ff-458f-85e2-39dc4fca2e79",
    "hitokoto": "记忆这东西类似小说，或者说，小说这东西类似记忆。",
    "type": "d",
    "from": "去中国的小船",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541944236",
    "length": 24
  },
  {
    "id": 4062,
    "uuid": "7fcea6ca-cbfd-4192-8c63-59526aaccfbd",
    "hitokoto": "变化是唯一可称为客观的，普遍的事实。",
    "type": "d",
    "from": "幸会，吃人鬼",
    "from_who": null,
    "creator": "上山打老虎",
    "creator_uid": 2483,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544770053",
    "length": 18
  },
  {
    "id": 4063,
    "uuid": "5089754e-7d61-439b-b02d-85a06f52f054",
    "hitokoto": "无论你接不接受，现实就这么回事，一点也不在乎你怎么想的。",
    "type": "d",
    "from": "幸会，吃人鬼",
    "from_who": null,
    "creator": "上山打老虎",
    "creator_uid": 2483,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544770014",
    "length": 28
  },
  {
    "id": 4064,
    "uuid": "3db61baa-72a3-4d1d-935c-d0d5014ef42e",
    "hitokoto": "我变了。因为我不变，就活不下去。",
    "type": "d",
    "from": "幸会，吃人鬼",
    "from_who": null,
    "creator": "上山打老虎",
    "creator_uid": 2483,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544769989",
    "length": 16
  },
  {
    "id": 4069,
    "uuid": "5bb9aa5a-94b4-4d82-8792-6ab1d7a8b78f",
    "hitokoto": "镇生者之魂，安亡者之心，赎未亡之罪，轮未竟之回。",
    "type": "d",
    "from": "镇魂",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542760710",
    "length": 24
  },
  {
    "id": 4070,
    "uuid": "ec2f745c-c2c8-483b-a708-3137ea7e497c",
    "hitokoto": "未老已衰之石，未冷已冻之水，未生已死之身，未灼已化之魂。",
    "type": "d",
    "from": "镇魂",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542810221",
    "length": 28
  },
  {
    "id": 4071,
    "uuid": "c33b15a2-6d50-4cd3-9558-ff7594458171",
    "hitokoto": "有一种爱情，是插在心上的刀。",
    "type": "d",
    "from": "生死疲劳",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542811434",
    "length": 14
  },
  {
    "id": 4077,
    "uuid": "e9dc77e2-3f4c-4908-a708-a28d4a812530",
    "hitokoto": "在永恒与虚无之间，为你沉默。",
    "type": "d",
    "from": "请以你的名字呼唤我",
    "from_who": null,
    "creator": "nightkeeper",
    "creator_uid": 2454,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544287063",
    "length": 14
  },
  {
    "id": 4078,
    "uuid": "76a517d3-fa92-40e0-8e33-1e32226c10ab",
    "hitokoto": "遇不可说之事，必须保持沉默。",
    "type": "d",
    "from": "幸会，吃人鬼",
    "from_who": null,
    "creator": "上山打老虎",
    "creator_uid": 2483,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544770202",
    "length": 14
  },
  {
    "id": 4096,
    "uuid": "5119015d-60fb-4952-a7cf-7851c52c2510",
    "hitokoto": "心有猛虎，细嗅蔷薇",
    "type": "d",
    "from": "猛虎与蔷薇",
    "from_who": null,
    "creator": "mzy231",
    "creator_uid": 2154,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538840129",
    "length": 9
  },
  {
    "id": 4110,
    "uuid": "0855fda8-9ed0-48b2-918e-588cb46d1bb9",
    "hitokoto": "明月清风晓星尘，凌霜傲雪宋子琛。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "Matsuk",
    "creator_uid": 2238,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540204504",
    "length": 16
  },
  {
    "id": 4111,
    "uuid": "e70d3ba8-c66a-49a2-be14-e2bd620c94ad",
    "hitokoto": "我以为看到了你，便拥有了整个世界。却没想到你的梦里，早已有了我。",
    "type": "d",
    "from": "我欲封天",
    "from_who": null,
    "creator": "世界唯一の勇者",
    "creator_uid": 243,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540464903",
    "length": 32
  },
  {
    "id": 4120,
    "uuid": "d05079b1-4686-4bfd-8843-3eb728d01b3f",
    "hitokoto": "飞雪连天射白鹿，笑书神侠倚碧鸳。",
    "type": "d",
    "from": "金庸",
    "from_who": null,
    "creator": "766fr",
    "creator_uid": 2270,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540912795",
    "length": 16
  },
  {
    "id": 4121,
    "uuid": "3b04c362-1b0c-43c0-a9dc-eb5f5e4d6569",
    "hitokoto": "用我一生，换你十年天真无邪。",
    "type": "d",
    "from": "盗墓笔记",
    "from_who": null,
    "creator": "༄凉ོ࿆风࿆有࿆信ོ࿆࿐",
    "creator_uid": 1948,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542029734",
    "length": 14
  },
  {
    "id": 4126,
    "uuid": "8db04c30-6da4-4eb1-abfb-65d9081f9915",
    "hitokoto": "人最强大的武器，是习惯和信赖。",
    "type": "d",
    "from": "金色梦乡",
    "from_who": null,
    "creator": "alcoholipstick",
    "creator_uid": 2350,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542440735",
    "length": 15
  },
  {
    "id": 4127,
    "uuid": "74e7b15d-7bf9-4051-912a-5db375689a22",
    "hitokoto": "我不敢告诉你我是谁，因为假如我告诉你，你可能会不喜欢我，而那却是我全部所有",
    "type": "d",
    "from": "为什么我不敢告诉你我是谁？",
    "from_who": null,
    "creator": "醉梦大姐姐",
    "creator_uid": 2345,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542512662",
    "length": 37
  },
  {
    "id": 4133,
    "uuid": "f7e61de8-af58-4b3d-a7ba-a67cfb865915",
    "hitokoto": "情不知所起，一往而深，生者可以死，死者可以生，生而不可与死，死而不可复生者，皆非情之至也。",
    "type": "d",
    "from": "牡丹亭",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542800569",
    "length": 45
  },
  {
    "id": 4146,
    "uuid": "a10b7ee0-308a-4f85-89b9-fdd14033d6e0",
    "hitokoto": "春空千鹤若幻梦，夕波千鸟若长鸣。",
    "type": "d",
    "from": "千只鹤",
    "from_who": null,
    "creator": "懒癌晚期",
    "creator_uid": 2415,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543625040",
    "length": 16
  },
  {
    "id": 4150,
    "uuid": "78244a02-1165-4472-a38b-8945858a0780",
    "hitokoto": "即使被关在果壳之中，我仍自以为是无限宇宙之王。",
    "type": "d",
    "from": "哈姆雷特",
    "from_who": null,
    "creator": "nightkeeper",
    "creator_uid": 2454,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544287404",
    "length": 23
  },
  {
    "id": 4153,
    "uuid": "cf375715-dbdf-41f5-9272-6918db9bee33",
    "hitokoto": "昨夜小寐，忽疑君到，却是琉璃火，未央天。",
    "type": "d",
    "from": "谢长留",
    "from_who": null,
    "creator": "昵称",
    "creator_uid": 2461,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544369346",
    "length": 20
  },
  {
    "id": 4156,
    "uuid": "9a439f8d-1896-48a2-acbb-8a31ed88ec94",
    "hitokoto": "命运啊，说是注定，不如说是你忘了是在何时做了选择。",
    "type": "d",
    "from": "塔希里亚故事集",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544444535",
    "length": 25
  },
  {
    "id": 4160,
    "uuid": "0f995ba6-a14e-40bd-b3ee-45eb59fd4f0d",
    "hitokoto": "失去人性，失去很多；失去兽性，失去一切。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "wky32768",
    "creator_uid": 2486,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544850826",
    "length": 20
  },
  {
    "id": 4174,
    "uuid": "090181fa-6093-464b-a04e-23d71d1b4e21",
    "hitokoto": "是你的就好好抓住，不是你的就不要多想。 天底下没谁是欠你的，但是你欠了别人，就别不当回事。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "梦某人",
    "creator_uid": 2530,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545410456",
    "length": 45
  },
  {
    "id": 4182,
    "uuid": "c2687ed8-30be-4531-a627-f33be464227a",
    "hitokoto": "弱小和无知，不是生存的障碍，傲慢才是。",
    "type": "d",
    "from": "三体:死神永生",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788604",
    "length": 19
  },
  {
    "id": 4185,
    "uuid": "07fd806e-0119-4f0f-87a9-ad977a16c88a",
    "hitokoto": "试问天上仙人，谁敢来此人间！",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "徐凤年",
    "creator_uid": 2502,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545101690",
    "length": 14
  },
  {
    "id": 4186,
    "uuid": "7f4d6522-ba89-4201-a274-7fa3c2cdcfe8",
    "hitokoto": "人生当苦无妨，良人当归极好。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "徐凤年",
    "creator_uid": 2502,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545102128",
    "length": 14
  },
  {
    "id": 4187,
    "uuid": "d7d94768-0c29-4bb7-8da9-6d5ec12a58cb",
    "hitokoto": "我们固然拥有可以将我们自身嵌入其中的我们的人生这一运行系统，但这一系统同时也规定了我们自身。",
    "type": "d",
    "from": "旋转木马鏖战记",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545318845",
    "length": 46
  },
  {
    "id": 4195,
    "uuid": "e7dc9a08-e401-4a28-b1d0-432d0bcb134d",
    "hitokoto": "让人类保持理智，确实是种奢求。",
    "type": "d",
    "from": "流浪地球",
    "from_who": null,
    "creator": "lanthanum",
    "creator_uid": 2733,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549639073",
    "length": 15
  },
  {
    "id": 4199,
    "uuid": "79fab55a-582a-41ea-8fa8-2ff3369d6d0d",
    "hitokoto": "小地瓜，我找到你了。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "小飞",
    "creator_uid": 2564,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545905371",
    "length": 10
  },
  {
    "id": 4239,
    "uuid": "50938440-620c-42dc-b0bc-e9c8874529df",
    "hitokoto": "你们认为没有路，是因为没有学会不择手段。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788674",
    "length": 20
  },
  {
    "id": 4240,
    "uuid": "6c990678-d328-40ac-9669-54b34e8fe437",
    "hitokoto": "如果说，有上帝的话。人类一思考，上帝就发笑，如果人类不思考，上帝连发笑都不屑于。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788725",
    "length": 40
  },
  {
    "id": 4241,
    "uuid": "13de5fed-33cd-47f4-a509-4e82795be7ad",
    "hitokoto": "大多数人到死都没有向尘世之外瞥一眼。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788768",
    "length": 18
  },
  {
    "id": 4242,
    "uuid": "16c9b801-62d4-4374-8564-f3b3f684330d",
    "hitokoto": "我有一个梦，也许有一天，灿烂的阳光能照进黑暗森林。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788864",
    "length": 25
  },
  {
    "id": 4245,
    "uuid": "448f9284-2576-49a7-8d9b-89f3e61ea7ab",
    "hitokoto": "把海弄干的鱼在海干前上了陆地，从一片黑暗森林奔向另一片黑暗森林。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547789156",
    "length": 32
  },
  {
    "id": 4246,
    "uuid": "8e933f3e-ed72-4c33-b738-70559f3dc4d6",
    "hitokoto": "西方人并不比东方人聪明，但是他们却找对了路。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788972",
    "length": 22
  },
  {
    "id": 4258,
    "uuid": "8d854c13-5727-4e0f-b2f4-dd4432a26fdf",
    "hitokoto": "为你明灯三千，为你花开满城，为你所向披靡。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "六拾三",
    "creator_uid": 2660,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548163305",
    "length": 21
  },
  {
    "id": 4259,
    "uuid": "85f010ff-7bc9-471c-8bb5-31f2bef8db26",
    "hitokoto": "是非在己，毁誉由人，得失不论。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "六拾三",
    "creator_uid": 2660,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548163584",
    "length": 15
  },
  {
    "id": 4260,
    "uuid": "1e08ae0f-b886-4f4c-b9df-2348511fb83a",
    "hitokoto": "为遇一人入红尘，人去我亦去，此生不留尘。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "六拾三",
    "creator_uid": 2660,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548163615",
    "length": 20
  },
  {
    "id": 4267,
    "uuid": "6183bfd8-cf84-48c5-9a54-25054ca481c7",
    "hitokoto": "一个人有两个我，一个在黑暗中醒着，一个在光明中睡着。",
    "type": "d",
    "from": "纪伯伦",
    "from_who": null,
    "creator": "ChenZ01",
    "creator_uid": 2711,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549191196",
    "length": 26
  },
  {
    "id": 4273,
    "uuid": "01c6a3a8-63e5-46ff-9062-4fca852b8247",
    "hitokoto": "不怕念起，唯恐觉迟，既已执手，此生不负。",
    "type": "d",
    "from": "永安调",
    "from_who": null,
    "creator": "不喝温水",
    "creator_uid": 2723,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549435152",
    "length": 20
  },
  {
    "id": 4275,
    "uuid": "16703934-04aa-4016-a311-233a9993ffe4",
    "hitokoto": "所谓“大家”，就是无视并牺牲了一部分弱势群体后所达到的虚伪的和平与共识",
    "type": "d",
    "from": "我的青春恋爱物语绝对有问题",
    "from_who": null,
    "creator": "DQYdqy",
    "creator_uid": 2730,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549549185",
    "length": 35
  },
  {
    "id": 4276,
    "uuid": "fbad4fc8-4c0a-4da9-b4c9-bd135761c967",
    "hitokoto": "但俗话说，笨人想事情，跟休息没两样。",
    "type": "d",
    "from": "绯弹的亚里亚",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549719759",
    "length": 18
  },
  {
    "id": 4281,
    "uuid": "44220b75-4e12-4e7f-9cbb-2f31f7fbcdcd",
    "hitokoto": "上了陆地的鱼就不能再叫做鱼了",
    "type": "d",
    "from": "三体:黑暗森林",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549884131",
    "length": 14
  },
  {
    "id": 4285,
    "uuid": "00de3416-ba0a-40e9-be1b-fe1d2ce425cd",
    "hitokoto": "给时光以生命，给岁月以文明。",
    "type": "d",
    "from": "三体:黑暗森林",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549898888",
    "length": 14
  },
  {
    "id": 4286,
    "uuid": "b4bbc66d-80c4-4e23-83de-5aceb5700309",
    "hitokoto": "我爱你，与你有何相干？毁灭你，又与你有何相干？",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549898912",
    "length": 23
  },
  {
    "id": 4288,
    "uuid": "be63c12c-460d-407e-8f12-268526734779",
    "hitokoto": "你的无畏来源于无知。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549898959",
    "length": 10
  },
  {
    "id": 4289,
    "uuid": "0ac8e9dd-5997-4cac-a15e-ab3fb2ee32df",
    "hitokoto": "弱肉强食的世界，强者没有理由道歉，弱者也没有资格埋怨。",
    "type": "d",
    "from": "惊悚乐园",
    "from_who": null,
    "creator": "姬轩辕",
    "creator_uid": 3129,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556269795",
    "length": 27
  },
  {
    "id": 4290,
    "uuid": "6d5bcc5d-dfaf-48f0-8fa2-11dbefcae33e",
    "hitokoto": "给岁月以文明，而不是给文明以岁月。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549898981",
    "length": 17
  },
  {
    "id": 4291,
    "uuid": "e7d07a40-86dd-4705-a711-eca5ed71ba4c",
    "hitokoto": "我们都是阴沟里的虫子，但总还是得有人仰望星空。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549898999",
    "length": 23
  },
  {
    "id": 4292,
    "uuid": "f06faf89-fd48-4c25-955e-0fe12e2783c3",
    "hitokoto": "一切都将逝去，只有死神永生。",
    "type": "d",
    "from": "三体:死神永生",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549899031",
    "length": 14
  },
  {
    "id": 4293,
    "uuid": "887f901a-1db0-4ba4-8ef4-36d9bb1fdfa7",
    "hitokoto": "消灭人类暴政，世界属于三体！",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549899054",
    "length": 14
  },
  {
    "id": 4294,
    "uuid": "86dbf5aa-6272-493f-b909-a26dcc8f7522",
    "hitokoto": "碑是那么小，与其说是为了纪念，更像是为了忘却。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549899081",
    "length": 23
  },
  {
    "id": 4295,
    "uuid": "e08077dd-afcf-49d5-9b35-362d8cb2f10c",
    "hitokoto": "我触摸不到的除了喜马拉雅山顶的雪，还有你。",
    "type": "d",
    "from": "同学录",
    "from_who": null,
    "creator": "江梨",
    "creator_uid": 2741,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549983777",
    "length": 21
  },
  {
    "id": 4296,
    "uuid": "7ddb54f7-2c0f-40bd-931a-6e24f7a6ef82",
    "hitokoto": "黄粱一梦，山水万重，人间总相逢。",
    "type": "d",
    "from": "见江山",
    "from_who": null,
    "creator": "江梨",
    "creator_uid": 2741,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549983869",
    "length": 16
  },
  {
    "id": 4297,
    "uuid": "cbeb7770-3b6b-4ce1-b7be-87f682a1f7ce",
    "hitokoto": "成王败寇，失败才是丑恶的。",
    "type": "d",
    "from": "惊悚乐园",
    "from_who": null,
    "creator": "姬轩辕",
    "creator_uid": 3129,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556269455",
    "length": 13
  },
  {
    "id": 4300,
    "uuid": "7716ac7c-b368-4e98-ae99-ab9231f61353",
    "hitokoto": "I asked him, \"how can a man be brave if he's afraid?\" \"That is the only time a man can be brave,\" he told me.",
    "type": "d",
    "from": "冰与火之歌",
    "from_who": null,
    "creator": "111",
    "creator_uid": 2336,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550578652",
    "length": 109
  },
  {
    "id": 4301,
    "uuid": "bf166f28-2eb8-4af0-adf1-dad40c1aa26e",
    "hitokoto": "一切都将逝去，唯有死神永生。",
    "type": "d",
    "from": "三体Ⅲ",
    "from_who": null,
    "creator": "御坂妹33号",
    "creator_uid": 2783,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550630979",
    "length": 14
  },
  {
    "id": 4309,
    "uuid": "b4f01610-ee34-4860-97d6-679d1738c662",
    "hitokoto": "路是脚踏出来的，历史是人写出来的。",
    "type": "d",
    "from": "鲁迅",
    "from_who": null,
    "creator": "zqy2018",
    "creator_uid": 2652,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551500334",
    "length": 17
  },
  {
    "id": 4310,
    "uuid": "c7d6841d-f591-4a5f-b614-7bc260881e31",
    "hitokoto": "要对得起你的苦难。",
    "type": "d",
    "from": "胡歌",
    "from_who": null,
    "creator": "阁主博客",
    "creator_uid": 2831,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551540477",
    "length": 9
  },
  {
    "id": 4323,
    "uuid": "eaa36607-07ff-4829-8955-3748ed149bab",
    "hitokoto": "最阴险的敌人往往都站在最光明的角落里。",
    "type": "d",
    "from": "黑暗萌主",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556772136",
    "length": 19
  },
  {
    "id": 4324,
    "uuid": "62ca0d1c-e518-4b65-a48e-760c6c37c012",
    "hitokoto": "残花无零，落红无情",
    "type": "d",
    "from": "黑暗萌主",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556772122",
    "length": 9
  },
  {
    "id": 4325,
    "uuid": "e54f2488-6ae3-4182-bfaf-276dd804ebc8",
    "hitokoto": "越是经历过大变故的人，都越会去珍惜来之不易的和平，这或许，就是老人和年轻人的差别吧。",
    "type": "d",
    "from": "诸神眷恋与遗忘的幻想乡",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556772047",
    "length": 42
  },
  {
    "id": 4326,
    "uuid": "4fb6f4e8-6ef7-41c3-8b36-83c91a7988ac",
    "hitokoto": "谁是敌人，谁是朋友，不须由别人去告诉你，也不该由别人去决定，而是该由自己决定的。",
    "type": "d",
    "from": "异界之死亡女骑士",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556771953",
    "length": 40
  },
  {
    "id": 4329,
    "uuid": "5664e745-96b4-4fa0-ae43-e8dbf930f069",
    "hitokoto": "人类文明从仰望星空那一刻起，就已经距离揭示宇宙奥秘仅有一步之遥了。",
    "type": "d",
    "from": "朝闻道",
    "from_who": null,
    "creator": "MILLOPE",
    "creator_uid": 3119,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556529463",
    "length": 33
  },
  {
    "id": 4363,
    "uuid": "a282d06d-2c2c-4b31-8db4-096ad6743297",
    "hitokoto": "也许正义会迟到，但它永远不会缺席！",
    "type": "d",
    "from": "小说",
    "from_who": null,
    "creator": "Jason_Lee",
    "creator_uid": 3117,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556092041",
    "length": 17
  },
  {
    "id": 4364,
    "uuid": "0bbf1df2-ae3c-47cf-91aa-4fae34162e93",
    "hitokoto": "手握日月摘星辰，世间无我这般人",
    "type": "d",
    "from": "唐家三少",
    "from_who": null,
    "creator": "Jason_Lee",
    "creator_uid": 3117,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556091902",
    "length": 15
  },
  {
    "id": 4389,
    "uuid": "a79a5753-a9cb-4712-86bd-771ff5161db3",
    "hitokoto": "师哥，玫瑰到了花期，我很想你。",
    "type": "d",
    "from": "碎玉投珠",
    "from_who": null,
    "creator": "不曾天涯",
    "creator_uid": 2904,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552698602",
    "length": 15
  },
  {
    "id": 4390,
    "uuid": "52df1fa1-45f2-4d46-8952-1e9b1b7031ce",
    "hitokoto": "弱小和无知从来就不是一个文明毁灭的原因，傲慢才是。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "王兰花蛤",
    "creator_uid": 2889,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553243374",
    "length": 25
  },
  {
    "id": 4399,
    "uuid": "50a10b91-a265-4a0e-8c16-5005395fb9fb",
    "hitokoto": "我爱你，可跟你又有什么关系？",
    "type": "d",
    "from": "浮士德",
    "from_who": null,
    "creator": "王兰花蛤",
    "creator_uid": 2889,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552561645",
    "length": 14
  },
  {
    "id": 4415,
    "uuid": "b98c4939-0ebc-4b2a-a9ba-2c8c9d6c7209",
    "hitokoto": "弱小和无知不是生存的障碍，傲慢才是。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "STman",
    "creator_uid": 2972,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554040449",
    "length": 18
  },
  {
    "id": 4416,
    "uuid": "a99741fd-22c3-478d-b101-d856705b3569",
    "hitokoto": "乌鸦为什么像写字台？",
    "type": "d",
    "from": "爱丽丝梦游仙境",
    "from_who": null,
    "creator": "janeblog.cn",
    "creator_uid": 2978,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554100080",
    "length": 10
  },
  {
    "id": 4417,
    "uuid": "7400417c-fc82-4197-948f-a8458cf1f040",
    "hitokoto": "受到乌托邦声音的诱惑，他们拼命地挤进天堂的大门，但当大门在身后砰然关上时，他们发现自己是在地狱里。",
    "type": "d",
    "from": "米兰昆德拉",
    "from_who": null,
    "creator": "姜汁",
    "creator_uid": 2980,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554117348",
    "length": 49
  },
  {
    "id": 4438,
    "uuid": "8089b393-d141-4eae-8eed-d5b23086f850",
    "hitokoto": "人类的悲欢并不相通，我只是觉得他们吵闹。",
    "type": "d",
    "from": "鲁迅",
    "from_who": null,
    "creator": "相月•十",
    "creator_uid": 3237,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557986934",
    "length": 20
  },
  {
    "id": 4440,
    "uuid": "2dcbc495-f0f8-4074-8b3f-522feb5f2006",
    "hitokoto": "如果一朵花很美，那么有时我会不由自主地想到：“要活下去！”",
    "type": "d",
    "from": "川端康成",
    "from_who": null,
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1558370443",
    "length": 29
  },
  {
    "id": 4441,
    "uuid": "fb4f9e31-3793-4e91-bbb5-a299942affe9",
    "hitokoto": "对我来说，风光无限的是你，跌落尘埃的也是你。重点是“你”，而不是“怎样”的你。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "风待葬",
    "creator_uid": 3262,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1558542599",
    "length": 39
  },
  {
    "id": 4443,
    "uuid": "4508290e-603e-4e1c-8246-e5448fbec75d",
    "hitokoto": "要是有些事我没说，你别以为是忘了，我什么也没忘，但是有些事只适合收藏。",
    "type": "d",
    "from": "我与地坛",
    "from_who": null,
    "creator": "风待葬",
    "creator_uid": 3262,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1558887112",
    "length": 35
  },
  {
    "id": 4446,
    "uuid": "ce93a4c9-0024-46a2-91be-e9e96257673e",
    "hitokoto": "已识乾坤大，犹怜草木青。",
    "type": "d",
    "from": "马一浮",
    "from_who": null,
    "creator": "MILLOPE",
    "creator_uid": 3119,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559051982",
    "length": 12
  },
  {
    "id": 4451,
    "uuid": "a827ade0-5511-4445-b0c0-9fb9e3f256b3",
    "hitokoto": "小太阳很忙，小云朵想吃糖，长颈鹿嫌脖子不够长，喜欢你太难忘",
    "type": "d",
    "from": "童话镇的邮递员",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567959448",
    "length": 29
  },
  {
    "id": 4453,
    "uuid": "02dc9ed7-884b-43f7-bab9-72dab41b3768",
    "hitokoto": "人必须先说很多话，然后保持静默。",
    "type": "d",
    "from": "中国哲学简史",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564281396",
    "length": 16
  },
  {
    "id": 4462,
    "uuid": "0dac757d-ef47-4745-afde-61cd4a14dce3",
    "hitokoto": "当你凝视深渊，深渊也在凝视着你。",
    "type": "d",
    "from": "尼采",
    "from_who": null,
    "creator": "不知火的橙子",
    "creator_uid": 3880,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568016270",
    "length": 16
  },
  {
    "id": 4464,
    "uuid": "41c81688-d2a3-42da-b0e0-bbf8e61e5902",
    "hitokoto": " 不合理的事物，未必都是显而易见的",
    "type": "d",
    "from": "惊悚乐园",
    "from_who": null,
    "creator": "2879824237",
    "creator_uid": 3871,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567934364",
    "length": 17
  },
  {
    "id": 4465,
    "uuid": "15f7fc2d-6168-4cc0-a4d5-65a987a9fdc9",
    "hitokoto": "眼泪可以渡走悲伤,眼泪带不走的悲伤,就用笑声埋藏。",
    "type": "d",
    "from": "惊悚乐园",
    "from_who": null,
    "creator": "2879824237",
    "creator_uid": 3871,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567934275",
    "length": 25
  },
  {
    "id": 4476,
    "uuid": "6c913d21-c077-4f0e-96db-521ac837d574",
    "hitokoto": "来自南方的温柔的风，经不起北方的寒冷。",
    "type": "d",
    "from": "最爱你的十年",
    "from_who": null,
    "creator": "烁烁眼里有星星鸭",
    "creator_uid": 3309,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559391482",
    "length": 19
  },
  {
    "id": 4477,
    "uuid": "0f279e8c-39af-437d-8a01-fbce502372f7",
    "hitokoto": "对友谊来说，笑声确实是个不错的开端，同时也是最好的结局。",
    "type": "d",
    "from": "道林·格雷的画像",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559817344",
    "length": 28
  },
  {
    "id": 4480,
    "uuid": "5e2276f5-c083-4017-8118-00e0bfbc57c0",
    "hitokoto": "所有坚硬冰冷的东西都会永远坚硬冰冷下去，而所有柔软温暖的东西只有眼下才会柔软温暖。",
    "type": "d",
    "from": "（以色列）阿摩司·奥兹",
    "from_who": null,
    "creator": "17shou_VIP",
    "creator_uid": 2705,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560070702",
    "length": 41
  },
  {
    "id": 4482,
    "uuid": "62c519aa-a82a-4bf5-ab87-ba5582b165f6",
    "hitokoto": "在童话中，一个人做他想做的事；在现实中，一个人做他能做的事。",
    "type": "d",
    "from": "埃莱娜·费兰特",
    "from_who": null,
    "creator": "17shou_VIP",
    "creator_uid": 2705,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560070976",
    "length": 30
  },
  {
    "id": 4483,
    "uuid": "2518f9ba-b104-45d6-9bc2-0ad3f5c4f9f3",
    "hitokoto": "死并非再生的对立面，而是作为生的一部分永存于生中。",
    "type": "d",
    "from": "村上春树",
    "from_who": null,
    "creator": "17shou_VIP",
    "creator_uid": 2705,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560071008",
    "length": 25
  },
  {
    "id": 4487,
    "uuid": "b846295d-b170-4ae0-884a-6fea29015bf3",
    "hitokoto": "命运如同一团乱麻，我们抽丝剥茧百般追寻，最终终于解开了这个线团，却发现所有人手里都拿错了线头…",
    "type": "d",
    "from": "希灵帝国",
    "from_who": null,
    "creator": "NightlySound",
    "creator_uid": 3375,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560748783",
    "length": 47
  },
  {
    "id": 4489,
    "uuid": "8cb1b1bb-0e41-40c8-8b36-751b253566dc",
    "hitokoto": "当太阳落山以后，烛光永无法替代。",
    "type": "d",
    "from": "反恐精英在异界",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560777426",
    "length": 16
  },
  {
    "id": 4490,
    "uuid": "25894459-c7a3-4e7a-8862-d2e865b2b4d3",
    "hitokoto": "我们历经沧桑，这样错过了一生最好的时光。",
    "type": "d",
    "from": "黑暗萌主",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560777485",
    "length": 20
  },
  {
    "id": 4491,
    "uuid": "2177888e-5de4-4b63-88d5-59af93534378",
    "hitokoto": "所谓的时间，是不为人的意愿而转移的事物，最是残酷，又最是公平。",
    "type": "d",
    "from": "诸神眷恋与遗忘的幻想乡",
    "from_who": null,
    "creator": "远空凌",
    "creator_uid": 703,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560777574",
    "length": 31
  },
  {
    "id": 4495,
    "uuid": "54720f18-e5ce-463c-8837-205cf9a5ef36",
    "hitokoto": "现实就是一本蹩脚的小说，它从不按常理出牌。",
    "type": "d",
    "from": "希灵帝国",
    "from_who": null,
    "creator": "NightlySound",
    "creator_uid": 3375,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1561008895",
    "length": 21
  },
  {
    "id": 4497,
    "uuid": "d441ee2f-e714-4f0b-98a3-ec37aff8f02b",
    "hitokoto": "所谓癌症，治疗的过程就是痛苦。",
    "type": "d",
    "from": "我，处于地狱之中",
    "from_who": null,
    "creator": "NightlySound",
    "creator_uid": 3375,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1561387619",
    "length": 15
  },
  {
    "id": 4508,
    "uuid": "fe391658-8510-4a2d-af22-de3dfe969f76",
    "hitokoto": "风啊，你还要吹到何时......",
    "type": "d",
    "from": "卡尔·冯·沃尔里奇",
    "from_who": null,
    "creator": "陈俊豪",
    "creator_uid": 3452,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562154148",
    "length": 16
  },
  {
    "id": 4511,
    "uuid": "6d6b57fb-a899-48d4-b2a7-5e7353b3c040",
    "hitokoto": "我们奋力前行，逆水行舟，被不断向后推，直至回到往昔岁月。",
    "type": "d",
    "from": "了不起的盖茨比",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562570647",
    "length": 28
  },
  {
    "id": 4525,
    "uuid": "6c95d605-166c-4b88-a1de-7c0bc3497947",
    "hitokoto": "愿我有生之年，得见您君临天下。",
    "type": "d",
    "from": "黑塔利亚",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562980879",
    "length": 15
  },
  {
    "id": 4532,
    "uuid": "dde19fff-8e41-4969-94a7-bed0663d5a65",
    "hitokoto": "天不生我李淳罡，剑道万古如长夜。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562982455",
    "length": 16
  },
  {
    "id": 4542,
    "uuid": "ef955436-454a-4fcf-982d-91a67c59256b",
    "hitokoto": "错了就错了吧，一个做错的英雄，至少比什么都不做的笨蛋好。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "HKHbest",
    "creator_uid": 3368,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563334394",
    "length": 28
  },
  {
    "id": 4557,
    "uuid": "47052fa4-3f51-4989-a137-f4a7fdb2209a",
    "hitokoto": "莫对他人妄行揣测，是人能给予自己的最高尊严。",
    "type": "d",
    "from": "二哈和他的白猫师尊",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564080986",
    "length": 22
  },
  {
    "id": 4558,
    "uuid": "db1c1fa3-121e-427e-b04f-e16e6c5c77bc",
    "hitokoto": "地狱太冷，我来殉你。",
    "type": "d",
    "from": "二哈和他的白猫师尊",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564081011",
    "length": 10
  },
  {
    "id": 4561,
    "uuid": "e7cb1849-7803-43cf-8a6a-38dbabfa8589",
    "hitokoto": "王来承认，王来允许，王来背负这个世界！",
    "type": "d",
    "from": "Fate/Zero",
    "from_who": null,
    "creator": "你家炸了",
    "creator_uid": 3557,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564187804",
    "length": 19
  },
  {
    "id": 4565,
    "uuid": "c53391de-4978-4ad1-a192-efcf7239b403",
    "hitokoto": "为遇一人而入红尘，人去我亦去，此生不留尘",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "牙人圭uu",
    "creator_uid": 3596,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564830660",
    "length": 20
  },
  {
    "id": 4577,
    "uuid": "329dc76f-fd11-4d4a-afca-768bece669d8",
    "hitokoto": "春复一春，枝头黄莺飞。秋复一秋，城头大雁归。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "墨逸",
    "creator_uid": 3656,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565766941",
    "length": 22
  },
  {
    "id": 4578,
    "uuid": "9aca4499-dc4e-44f7-b0e7-64c43303d5e8",
    "hitokoto": "\"痴\"这个字，真有趣，明是知道是病，依然痴心不改",
    "type": "d",
    "from": "豆瓣红楼梦点评:红发",
    "from_who": null,
    "creator": "Mnizjc",
    "creator_uid": 3674,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566324479",
    "length": 24
  },
  {
    "id": 4596,
    "uuid": "a7d41e72-7d66-482d-ba12-14a6e65f6239",
    "hitokoto": "苦其心志，饿其体肤，空乏其身，行拂乱其所为。",
    "type": "d",
    "from": "孟子",
    "from_who": null,
    "creator": "Charls_Yiyan",
    "creator_uid": 3788,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567043608",
    "length": 22
  },
  {
    "id": 4602,
    "uuid": "fdd3916f-35ac-451d-af22-157306d49816",
    "hitokoto": "追求得到之日即其终止之日，寻觅的过程亦即失去的过程。",
    "type": "d",
    "from": "国境以南，太阳以西",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567149443",
    "length": 26
  },
  {
    "id": 4608,
    "uuid": "a38919a7-a925-43aa-bcf9-a399e453e3b1",
    "hitokoto": "今天的我们伤痕累累，但比起昨日，我们应该多少有所成长",
    "type": "d",
    "from": "My days 永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567584466",
    "length": 26
  },
  {
    "id": 4623,
    "uuid": "ed5b2085-a04b-4ab1-a0ec-1ab6e9fe811d",
    "hitokoto": "或许并不是所有人都能在这个艰难的世界上生存下来，但每一个牺牲者的出现，都只能证明我们的无能。",
    "type": "d",
    "from": "黎明之剑",
    "from_who": null,
    "creator": "水令千泠",
    "creator_uid": 3864,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567857973",
    "length": 46
  },
  {
    "id": 4648,
    "uuid": "b651b685-d3d7-46db-87e1-8ee8a148f685",
    "hitokoto": "一个会用风筝向你写出“我想你”的女孩，真让人永远都忘不了她。",
    "type": "d",
    "from": "偷影子的人",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312184",
    "length": 30
  },
  {
    "id": 4649,
    "uuid": "1d313b62-1c41-4674-9cee-c189235b008b",
    "hitokoto": "每个人都要穿过他们自己的荒原。在这个地方发现你已经死去的真相，然后无可奈何地接受。",
    "type": "d",
    "from": "摆渡人",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312218",
    "length": 41
  },
  {
    "id": 4650,
    "uuid": "acb4b2b1-8dd6-4187-9a98-eb2bf57bf6fb",
    "hitokoto": "一个人无法自成孤岛，要么至少，一个人无法自成最理想的孤岛。",
    "type": "d",
    "from": "岛上书店",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312235",
    "length": 29
  },
  {
    "id": 4651,
    "uuid": "67df565c-0561-48f1-a573-6867dd95b399",
    "hitokoto": "大多数人如果能给更多事情一个机会的话，他们的问题都能解决。",
    "type": "d",
    "from": "岛上书店",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312250",
    "length": 29
  },
  {
    "id": 4652,
    "uuid": "1e21ecc2-e439-4ee9-a12b-7059f9eb2d93",
    "hitokoto": "你不是不擅长学习，只是没有找到自己想要学习的东西而已。",
    "type": "d",
    "from": "梦幻花",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312268",
    "length": 27
  },
  {
    "id": 4653,
    "uuid": "1bdd0f29-ceac-48ba-b526-b3ea05b5a6db",
    "hitokoto": "无论你选择什么道路我都一直站在你这边。唯一不变的就是永远支持你。",
    "type": "d",
    "from": "梦幻花",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312283",
    "length": 32
  },
  {
    "id": 4654,
    "uuid": "bfd4b2ba-9479-4bb8-bc30-58f5b412e680",
    "hitokoto": "我只是你生活里的一个影子，你却在我的生命里占有重要地位。如果我只是个单纯的过客，为何要让我闯入你的生活？我千百次想过要离开你，但仅凭一己之力我做不到。",
    "type": "d",
    "from": "偷影子的人",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312201",
    "length": 75
  },
  {
    "id": 4655,
    "uuid": "665171d3-f62e-4931-8f5f-7bcfdeae7f45",
    "hitokoto": "这个世界有很多置他人与不幸，并幸灾乐祸的人。",
    "type": "d",
    "from": "梦幻花",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312298",
    "length": 22
  },
  {
    "id": 4656,
    "uuid": "e8b9a9c2-0bee-4a7e-819e-70209575328a",
    "hitokoto": "有些真相注定是要小心翼翼深埋心底的，因为答案揭晓的那一刻，也是灰飞烟灭的开始。",
    "type": "d",
    "from": "嫌疑人x的献身",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312320",
    "length": 39
  },
  {
    "id": 4658,
    "uuid": "36204273-75c2-43c5-8a6a-bf15dd5a9d94",
    "hitokoto": "要求杀人凶手自我惩戒，根本是虚无的十字架。然而，即使是这种虚无的十字架，也必须让凶手在监狱中背负着。",
    "type": "d",
    "from": "虚无的十字架",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312356",
    "length": 50
  },
  {
    "id": 4659,
    "uuid": "faa5cca2-3576-4742-af2b-3a70a5574bb0",
    "hitokoto": "为你的生命找到一个长期的、深层的、不能被满足的乐趣，让这个永恒乐趣带领你穿透生命的无常。",
    "type": "d",
    "from": "拆掉思维里的墙",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312368",
    "length": 44
  },
  {
    "id": 4660,
    "uuid": "b977b4c1-e2ad-4cd3-a09b-98b43a38fefc",
    "hitokoto": "世界上没有一条河不拐弯，但最终都要流向大海。",
    "type": "d",
    "from": "好好说话",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312382",
    "length": 22
  },
  {
    "id": 4661,
    "uuid": "4e5066ab-b1f2-478b-af93-cdbb2f510522",
    "hitokoto": "愿你有好运，如果没有。希望你在慈悲中学会坚强。 愿有很多人爱你，如果没有，希望你在寂寞中学会宽容。",
    "type": "d",
    "from": "愿你慢慢长大",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312418",
    "length": 49
  },
  {
    "id": 4662,
    "uuid": "545d6e75-114f-4d96-b7f0-42fed882d272",
    "hitokoto": "如果我们只看到自己的普通，可能就会错过特别的人生。",
    "type": "d",
    "from": "深夜食堂",
    "from_who": null,
    "creator": "岔路ko",
    "creator_uid": 3976,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569322333",
    "length": 25
  },
  {
    "id": 4667,
    "uuid": "a6ddcdc4-d642-47b5-87d2-9cccf1519cf6",
    "hitokoto": " 全是理智的心，恰如一柄全是锋刃的刀。它叫使用它的人手上流血。",
    "type": "d",
    "from": "飞鸟集",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569328413",
    "length": 31
  },
  {
    "id": 4678,
    "uuid": "4c04c761-672d-41a2-a028-fd69dfdc019d",
    "hitokoto": "于千万人之中，遇见你所遇见的人；于千万年之中，时间的无涯荒野里，没有早一步，也没有晚一步，刚巧赶上了。 ",
    "type": "d",
    "from": "爱",
    "from_who": "张爱玲",
    "creator": "柔刃",
    "creator_uid": 3053,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569815192",
    "length": 52
  },
  {
    "id": 4680,
    "uuid": "a4b6f029-950c-429a-a7a7-e4bd1543ae9a",
    "hitokoto": "差距并不可怕，可怕的是因为差距而放弃。",
    "type": "d",
    "from": "全职高手",
    "from_who": null,
    "creator": "莫離",
    "creator_uid": 4011,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1570018352",
    "length": 19
  },
  {
    "id": 4682,
    "uuid": "5624b773-7c09-49c3-a093-068438f61249",
    "hitokoto": "你应该是上天赐予我的满心欢喜。",
    "type": "d",
    "from": "荒生虚闻录",
    "from_who": null,
    "creator": "芲犯",
    "creator_uid": 4014,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1570088236",
    "length": 15
  },
  {
    "id": 4685,
    "uuid": "51fd0a27-4ba6-436f-8c89-ae6977abb546",
    "hitokoto": "一个随便把别人当朋友的人，往往不会有真正的朋友。一个喜欢嘴上称兄道弟的人，心里其实没有真正的兄弟。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1572157189",
    "length": 49
  },
  {
    "id": 4695,
    "uuid": "779b17d0-7add-40f5-aa9f-4c033e7537ad",
    "hitokoto": "人们之所以会怀念故乡，是因为心爱的人就在故乡。",
    "type": "d",
    "from": "狼与香辛料",
    "from_who": null,
    "creator": "wwlwwl",
    "creator_uid": 4041,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570590685",
    "length": 23
  },
  {
    "id": 4700,
    "uuid": "93e34c8f-94d3-4d8d-85e9-e728e7c1b9af",
    "hitokoto": "孤独可是致人于死的疾病呐。",
    "type": "d",
    "from": "狼与香辛料",
    "from_who": null,
    "creator": "wwlwwl",
    "creator_uid": 4041,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1570590671",
    "length": 13
  },
  {
    "id": 4703,
    "uuid": "2128aac1-4e6a-4e70-b9e2-cd57e2db6dbe",
    "hitokoto": "如果……不是因为我的缘故……或许大家都不会出事吧……",
    "type": "d",
    "from": "曼殊华",
    "from_who": null,
    "creator": "陈俊豪",
    "creator_uid": 3452,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1570630265",
    "length": 26
  },
  {
    "id": 4707,
    "uuid": "49305f4b-909a-461e-ac3e-f556e71adb67",
    "hitokoto": "单程孤舟，出云入霞，如歌如吟。",
    "type": "d",
    "from": "门孔",
    "from_who": null,
    "creator": "Henry_Huang",
    "creator_uid": 4069,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571118457",
    "length": 15
  },
  {
    "id": 4710,
    "uuid": "8773249c-edbc-4af7-95d2-3ce10f746d7c",
    "hitokoto": "读书人皆是负心人，最负痴心人。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571145391",
    "length": 15
  },
  {
    "id": 4717,
    "uuid": "82ff6017-3a13-4af7-b9fa-bf323b8247b2",
    "hitokoto": "别的禅，我都不修。独你是我的禅，秀色可餐",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571145760",
    "length": 20
  },
  {
    "id": 4718,
    "uuid": "b04fcc6a-5f40-4d54-b9a1-0f47ee0f39c7",
    "hitokoto": "我喝过很烈的酒，也放过不该放的手，从前不会回头，往后不会将就。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": null,
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571145899",
    "length": 31
  },
  {
    "id": 4721,
    "uuid": "95917fca-a8cf-4b51-8dd8-de3b2c6abe64",
    "hitokoto": "一定要爱着点什么，恰似草木对光阴的钟情。",
    "type": "d",
    "from": "人间草木",
    "from_who": "汪曾祺",
    "creator": "/...月月",
    "creator_uid": 4817,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580882558",
    "length": 20
  },
  {
    "id": 4727,
    "uuid": "9f8e6e61-0fa6-4e6c-96ee-99ad931a22d8",
    "hitokoto": "你睁开眼睛的时候，我在这里。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580564381",
    "length": 14
  },
  {
    "id": 4728,
    "uuid": "b84614a3-37a1-4d21-b29e-0e31bd262d6c",
    "hitokoto": "我不怕被人否定，我从小到大都没怎么被肯定过，肯定自己这种事儿，还得听自己的，我说我好，我就是好。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580564338",
    "length": 48
  },
  {
    "id": 4729,
    "uuid": "0f3ef620-de6e-47eb-be50-fea5738c0dc2",
    "hitokoto": "每个人都有自己的故事，或悲或喜或无奈，不接触深了，你永远都不知道这一个个经过的人心心里装着的事，亮着灯的一扇扇窗里有没有在叹息。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580564308",
    "length": 64
  },
  {
    "id": 4730,
    "uuid": "1b7f8e68-6d0a-4d4c-9e7e-2b449444b723",
    "hitokoto": "他放弃的不是我，也不是感情，他放弃的是他自己， 人这一辈子，可能会放弃很多东西，很多人。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580564269",
    "length": 44
  },
  {
    "id": 4731,
    "uuid": "8450b2db-590b-4224-9465-06b74bd9f7f8",
    "hitokoto": "没有谁的生活会一直完美，但无论什么时候，都要看着前方，满怀希望就会所向披靡。\r\n",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563809",
    "length": 40
  },
  {
    "id": 4732,
    "uuid": "f87012c6-f320-4b81-86dd-634cf679eb76",
    "hitokoto": "别让我跑了，别我一说算了，你就来去自如走了，你多缠一会，行吗？万一我后悔了，回头你不在那儿了怎么办？",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563768",
    "length": 50
  },
  {
    "id": 4733,
    "uuid": "1fc196e2-f54c-4361-a1dd-5b8a14459e50",
    "hitokoto": "有些意外是意料之中，有些意外是意料之外，而你，就是我意料之外的意外。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563712",
    "length": 34
  },
  {
    "id": 4734,
    "uuid": "23e5037a-83fd-4804-b6ae-81bef4eef041",
    "hitokoto": "你知道吗，有些人，会以各种你情愿或者不情愿的方式，留在你的记忆里，比如我。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563636",
    "length": 37
  },
  {
    "id": 4735,
    "uuid": "8b73af5c-1c21-4b5b-9307-579338702dc6",
    "hitokoto": "人就是这样的，想来想去，犹豫来犹豫去，觉得自己没有准备好，勇气没攒够，其实只要迈出去了那一步，就会发现其实所有的一切早就准备好了。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563558",
    "length": 65
  },
  {
    "id": 4736,
    "uuid": "c93823ee-47ae-46f3-ac59-538fd2cf3d0d",
    "hitokoto": "希望你永远都笑的像一束阳光，你是我的阳光。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563521",
    "length": 21
  },
  {
    "id": 4737,
    "uuid": "5dbda419-48bf-4847-8178-9097aec6c184",
    "hitokoto": "我想，左肩有你，右肩微笑。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563479",
    "length": 13
  },
  {
    "id": 4738,
    "uuid": "d14b2a93-9060-4dba-aca9-864cd16e04a6",
    "hitokoto": "我就要他，自己走过来，一步一步，不管他用多长时间，他得自己走过来。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563385",
    "length": 33
  },
  {
    "id": 4739,
    "uuid": "d5f5e52a-a039-4e0c-8b3f-9395594d6654",
    "hitokoto": "希望我们都能像对方一样勇敢。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563360",
    "length": 14
  },
  {
    "id": 4740,
    "uuid": "adc0046c-9dd0-4b06-b432-8b4223d677da",
    "hitokoto": "我会一直喜欢到你不再需要我喜欢你为止。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563291",
    "length": 19
  },
  {
    "id": 4741,
    "uuid": "12e85a5c-95e9-4b82-a8b7-c2c749f21f89",
    "hitokoto": "没有谁的生活会一直完美，但无论什么时候，都要看着前方，满怀希望就会所向披靡。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563259",
    "length": 38
  },
  {
    "id": 4742,
    "uuid": "27e70d6f-79ad-4c6f-8ee4-ac62ca4bb892",
    "hitokoto": "我想跟你在一起。我想跟你谈恋爱，不是谈个恋爱，是你，不是别人。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563227",
    "length": 31
  },
  {
    "id": 4743,
    "uuid": "8b2b1b1a-47d8-4008-b05b-774f0034f9e4",
    "hitokoto": "他并不是有多寂寞，有多孤单，需要在这里随便找个什么人开始一段感情，只是因为对方是顾飞。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563205",
    "length": 43
  },
  {
    "id": 4744,
    "uuid": "5d1e8272-ec60-462f-9b60-d5ea690623df",
    "hitokoto": "只对你，无论谈恋爱还是谈个恋爱，都得是跟你。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563169",
    "length": 22
  },
  {
    "id": 4745,
    "uuid": "ac214f92-dcbf-496b-81b4-a725b9c3054a",
    "hitokoto": "想跟我谈恋爱，还是想跟我谈个恋爱？",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563145",
    "length": 17
  },
  {
    "id": 4746,
    "uuid": "73a08cc8-c978-4353-acee-4a34278762da",
    "hitokoto": "迈出第一步的是他，迈出第二步的也是他，一步一步的都是他。但害怕的也是他，一惊一乍的同样是他。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580563044",
    "length": 46
  },
  {
    "id": 4747,
    "uuid": "2c70c998-0fb6-4260-a9d3-7dafe735e70e",
    "hitokoto": "你喜欢一个人，看到所有跟他有关的东西，都会变成一团毛球。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580556256",
    "length": 28
  },
  {
    "id": 4748,
    "uuid": "666f269b-5cb6-409f-bba4-bf0357f4d67d",
    "hitokoto": "有些坚持，经不起一点点希望，哪怕是一点光亮，也会让人陷入痛苦。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580556144",
    "length": 31
  },
  {
    "id": 4749,
    "uuid": "6784f5d4-eb67-4323-87d9-42a043d341b1",
    "hitokoto": "我要赢一壶酒，拿来娶你。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580555894",
    "length": 12
  },
  {
    "id": 4750,
    "uuid": "1782bbb7-668f-46c2-b9c7-06227c539d8b",
    "hitokoto": "我想抬头暖阳春草，你给我简单拥抱。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580555808",
    "length": 17
  },
  {
    "id": 4751,
    "uuid": "dc6fc385-2c34-4f47-b81f-d18bf56311fa",
    "hitokoto": "我想在你眼里撒野奔跑，我想一个眼神就到老。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580555766",
    "length": 21
  },
  {
    "id": 4752,
    "uuid": "48f91a18-98b5-45c2-ac9a-038f353d8598",
    "hitokoto": "简童，我把肾给你，你把心给我吧。",
    "type": "d",
    "from": "蚀骨危情",
    "from_who": "沈谨修",
    "creator": "凿枘",
    "creator_uid": 4777,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580555339",
    "length": 16
  },
  {
    "id": 4753,
    "uuid": "7e22feed-6fc4-43f1-8e45-56d591faa79a",
    "hitokoto": "世界灿烂盛大，欢迎回家。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580555079",
    "length": 12
  },
  {
    "id": 4754,
    "uuid": "16566bed-fb6e-417e-853d-406a92083063",
    "hitokoto": "这里的一切都有始有终，却能容纳所有的不期而遇和久别重逢。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580554964",
    "length": 28
  },
  {
    "id": 4755,
    "uuid": "1a40a5ac-ceaf-495f-9c72-76470bc280d5",
    "hitokoto": "深处暖春 ，才会怕冷。\r\n",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580552193",
    "length": 13
  },
  {
    "id": 4760,
    "uuid": "fc26a947-969b-43bd-9c84-e9df5cf162c4",
    "hitokoto": "我把人生看成是无常的，把人的无可奈何、与生俱来的轻薄看成是虚无的。",
    "type": "d",
    "from": "心",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370830",
    "length": 33
  },
  {
    "id": 4761,
    "uuid": "f9db28b5-511a-463f-8ddd-4b5a92c42d06",
    "hitokoto": "现在我们也都还各自活着，我想。",
    "type": "d",
    "from": "斯普特尼克恋人",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370829",
    "length": 15
  },
  {
    "id": 4762,
    "uuid": "51864e3c-0f0a-4816-b11e-d4fc3e92ed34",
    "hitokoto": "当两颗卫星的轨道偶尔交叉时，我们便这样相会了。",
    "type": "d",
    "from": "斯普特尼克恋人",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370829",
    "length": 23
  },
  {
    "id": 4763,
    "uuid": "92a0575f-f9ef-4616-82c6-5195afbf1f99",
    "hitokoto": "我从壁橱里取出被褥，让她躺好，一边吸烟一边看着窗外的绵绵春雨。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370828",
    "length": 31
  },
  {
    "id": 4764,
    "uuid": "b3a6bc8f-a756-49cf-bad2-3d68a1f98807",
    "hitokoto": "我一边注视沉默的空间里闪闪浮动的光粒子，一边力图确定心的坐标。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370828",
    "length": 31
  },
  {
    "id": 4765,
    "uuid": "53fb9a5d-ad88-4e62-bfcb-511647cf7e0f",
    "hitokoto": "生在此侧，死在彼侧。我在此侧，不在彼侧。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370827",
    "length": 20
  },
  {
    "id": 4766,
    "uuid": "ceb20f32-6ced-4719-a532-146cc8b8312a",
    "hitokoto": "树梢间泻下的秋日阳光，在她肩部一闪一闪地跳跃着。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370827",
    "length": 24
  },
  {
    "id": 4767,
    "uuid": "d2ac29c4-212a-49a4-a75b-ca1367d62e30",
    "hitokoto": "死并非生的对立面，而作为生的一部分永存。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370827",
    "length": 20
  },
  {
    "id": 4768,
    "uuid": "00613386-f830-4ad4-8f4f-36de27c902f2",
    "hitokoto": "一只飞鸟以零点三倍马赫的速度划过天空，留下两道白色的翼痕。",
    "type": "d",
    "from": "想要成为女孩子",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370826",
    "length": 29
  },
  {
    "id": 4769,
    "uuid": "8b2f5174-ae50-4c6c-819b-744ccea8fd0b",
    "hitokoto": "这些悄悄抽出小绿芽的幼苗，终将有一天会长成参天大树吧。",
    "type": "d",
    "from": "如果你曾奋不顾身爱上一个人",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370826",
    "length": 27
  },
  {
    "id": 4770,
    "uuid": "09f05521-3927-430f-8671-9e16ad92d2ef",
    "hitokoto": "她更期待夏日午后痛快炽烈的阳光。正如他们那痛快炽烈的青春和爱情。",
    "type": "d",
    "from": "如果你曾奋不顾身爱上一个人",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370825",
    "length": 32
  },
  {
    "id": 4771,
    "uuid": "de0305ad-05d7-4884-8d48-bdca86c196b7",
    "hitokoto": "既然决定成为一个女孩子，既然决定走上这条忤逆‘上帝’的路，那在最开始的时候就已经决定和命运抗争到底了。",
    "type": "d",
    "from": "想要变成鹰的鱼",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370825",
    "length": 51
  },
  {
    "id": 4772,
    "uuid": "cc9fd1bd-c662-436c-b856-28c6cada0e2a",
    "hitokoto": "至此以后，杀死幻想。",
    "type": "d",
    "from": "咱的一位朋友",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370825",
    "length": 10
  },
  {
    "id": 4773,
    "uuid": "72bcad88-96e6-483e-8553-8247212963a3",
    "hitokoto": "原来，天上的星，都是曾被人惦念而又遗忘的梦啊。",
    "type": "d",
    "from": "小荷",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370824",
    "length": 23
  },
  {
    "id": 4774,
    "uuid": "96e7e3dd-5c23-42a8-8f68-9c314f68230c",
    "hitokoto": "是男还是女，没有关系呢。",
    "type": "d",
    "from": "駄作",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370824",
    "length": 12
  },
  {
    "id": 4777,
    "uuid": "7ef4457f-8dd1-44d9-831f-f3c917e1442c",
    "hitokoto": "这座城又到了一年的毕业季，这座城再没有了我们的南池路100号。",
    "type": "d",
    "from": "也不是很久之前的南池路100号",
    "from_who": "朱涵冰",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370822",
    "length": 31
  },
  {
    "id": 4778,
    "uuid": "e82b3736-f38b-4e51-bf33-63c1d4d8f18a",
    "hitokoto": "樱花落在赤裸的土壤上再也不会绽放，教室的窗外响起了蝉鸣，夏天到了。",
    "type": "d",
    "from": "野蛮生长",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370822",
    "length": 33
  },
  {
    "id": 4779,
    "uuid": "50216ca6-e544-43a0-9b01-1e269360e5fb",
    "hitokoto": "周日，午后的阳光总是那么慵懒，樱花树上缀满了粉色的小花，远远望去像一团浅粉色的烟花。",
    "type": "d",
    "from": "野蛮生长",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370821",
    "length": 42
  },
  {
    "id": 4780,
    "uuid": "56257564-de79-426f-a472-eeb36f20f6c2",
    "hitokoto": "亭边总有花影，与我消遣一段旖旎的小时光。",
    "type": "d",
    "from": "最美是花影不扫",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370821",
    "length": 20
  },
  {
    "id": 4781,
    "uuid": "4601e773-c942-483a-8281-51fc38a3ba8b",
    "hitokoto": "我是那么喜欢夏日的花影。每每走在路上，耳朵里灌着人声、车声、蝉鸣声，我仍不觉得聒噪，因为路上总有花树，总有花影，清清凉凉，被风抚着，清幽解暑。",
    "type": "d",
    "from": "最美是花影不扫",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370820",
    "length": 71
  },
  {
    "id": 4782,
    "uuid": "d8151a52-e302-4e18-8909-e956cfeb4875",
    "hitokoto": "但是我，我没有眼泪。宇宙，宇宙也没有眼泪呀！眼泪有什么用啊？",
    "type": "d",
    "from": "雷电颂",
    "from_who": "郭沫若",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370820",
    "length": 30
  },
  {
    "id": 4789,
    "uuid": "0eab7b03-5129-4c0a-a5be-e7a0a9095a1d",
    "hitokoto": "万物皆有尽头，唯有死神永生。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "Dead_Walker",
    "creator_uid": 4110,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571640750",
    "length": 14
  },
  {
    "id": 4801,
    "uuid": "c4041069-54e6-482b-b499-0a76b0fa9355",
    "hitokoto": "沧溟汤汤，迷谷成双。有子一人，匪思如狂。百念溯转，鲜餐且怅。伶仃落落，心胡不伤？",
    "type": "d",
    "from": "倾君沧溟恨",
    "from_who": null,
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571141696",
    "length": 40
  },
  {
    "id": 4805,
    "uuid": "dd025fa1-735b-40d7-b074-48e9f84e0958",
    "hitokoto": "你笑起来真像好天气。",
    "type": "d",
    "from": "简媜",
    "from_who": null,
    "creator": "Kilig",
    "creator_uid": 4140,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572139289",
    "length": 10
  },
  {
    "id": 4807,
    "uuid": "e17a339a-3ad0-444e-bcb1-5bba183eefcc",
    "hitokoto": "这么好的一位少年，那么他喜欢着的少女，得是多好的姑娘啊？",
    "type": "d",
    "from": "陈平安",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157066",
    "length": 28
  },
  {
    "id": 4808,
    "uuid": "7a96fe79-661a-4b09-bf1c-5e8175e1b3ad",
    "hitokoto": "自己觉得不好的事情，就干脆不要有第一次，一次也不要做，一小步也不能走出去，要不然回头来看，吃亏吃苦的还是自己。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157137",
    "length": 55
  },
  {
    "id": 4809,
    "uuid": "ba921639-90af-4071-a229-421319283a72",
    "hitokoto": "请不要把陌生人的些许善意，视为珍稀的瑰宝，却把身边亲近人的全部付出，当做天经地义的事情，对其视而不见。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157265",
    "length": 51
  },
  {
    "id": 4810,
    "uuid": "7e0ea136-b1c0-4b12-8368-d4117579e135",
    "hitokoto": "看似与人为善、心肠柔软之人，必然有一块坚硬如铁的心境土壤，在苦难人生中，死死支撑着那份看似愚蠢的善意。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157317",
    "length": 51
  },
  {
    "id": 4811,
    "uuid": "1dfec615-5385-4e48-badc-fdfdd0ee0c5d",
    "hitokoto": "某些人和事，哪怕是路边的风景，可是只要看一眼，依然会让人觉得很美好。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157501",
    "length": 34
  },
  {
    "id": 4813,
    "uuid": "b02f7631-bd14-415f-bc6c-762472efaebc",
    "hitokoto": "君子不妄动，动必有道。君子不徒语，语必有理。君子不苟求，求必有义。君子不虚行，行必有正。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157828",
    "length": 44
  },
  {
    "id": 4814,
    "uuid": "fa16d6c1-0565-4b01-acce-92f4274e976c",
    "hitokoto": "世间万般讲理与不讲理，终归会落在一处，我心安处即吾乡。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572158005",
    "length": 27
  },
  {
    "id": 4817,
    "uuid": "a19f33d7-f864-4a6f-a381-90383ec11db1",
    "hitokoto": "有些事情，不去做，陈平安心里不痛快。可有些事情，再不痛快，也只能忍着。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157015",
    "length": 35
  },
  {
    "id": 4818,
    "uuid": "8905159b-286d-4252-b93c-1f015de5fa9e",
    "hitokoto": "有些人之间，注定只要相逢，就是对的。如果还能重逢，就是最好的。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157102",
    "length": 31
  },
  {
    "id": 4819,
    "uuid": "0829796c-d9e7-4f75-8d0b-fccd7282bcb7",
    "hitokoto": "列星随行，日月递炤，四时代御，阴阳大化，风雨博施，万物各得其和以生，各得其养以成。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157164",
    "length": 41
  },
  {
    "id": 4820,
    "uuid": "5c98a0aa-1206-4441-b6e2-891f9631b65b",
    "hitokoto": "天大地大，独自一人，然后遇上了某个大坎，你死活就是跨不过去，要么憋屈死，要么找死，还能怎么办？",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157294",
    "length": 47
  },
  {
    "id": 4821,
    "uuid": "03a1cdd1-ed5c-4be9-8199-3e27aaf13501",
    "hitokoto": "人都会长大的，长大了之后，就会捡起一些新东西，丢掉一些旧东西，就这么丢丢捡捡，哗啦一下子，就老喽。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157862",
    "length": 49
  },
  {
    "id": 4822,
    "uuid": "325b5b31-bedb-4fc6-a444-9a5a196e600b",
    "hitokoto": "临死去只落孑然一身，赴阴司始问子孙安在；到头来徒留千古骂名，来地府方知万事皆休。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157955",
    "length": 40
  },
  {
    "id": 4823,
    "uuid": "b30fd877-21fe-4523-9684-7896a4db947c",
    "hitokoto": "真正的强者不在于什么无敌，而在于活着，输得再惨都别死了，而是每次都能够站起来，再次愤然出拳出剑！",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157535",
    "length": 48
  },
  {
    "id": 4824,
    "uuid": "b68f08e5-9a92-47ea-890a-efe57cb4313e",
    "hitokoto": "女子总爱在情爱一事上动脑筋，男子喜好在江山一事上花心思。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157590",
    "length": 28
  },
  {
    "id": 4825,
    "uuid": "0fc116b1-9d96-44d7-969b-3a54d151f0f7",
    "hitokoto": "走得再远，看得再细，终究会有这样那样的错过，不可能真正将风景看遍。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157718",
    "length": 33
  },
  {
    "id": 4826,
    "uuid": "14061b09-6f73-4739-afd3-ab4a5b8b84c9",
    "hitokoto": "别人的大道再好，那也是别人的道路，不妨埋头做事，但问耕耘莫问收获，偶尔抬头，左右看两眼其它路上的人物风光，就够了。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157758",
    "length": 57
  },
  {
    "id": 4828,
    "uuid": "8e34d593-e451-481c-9318-5792bef70d4e",
    "hitokoto": "有聚终有散，人生就是一场场折柳。岁月长河里，仿佛存在着一座座杨柳依依的渡口，每一段光阴逆旅当中，会有人离船而去，有人登船作伴，然后在下一座渡口又有新的聚散离别。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572157349",
    "length": 80
  },
  {
    "id": 4836,
    "uuid": "083b3d43-f7bb-4fb1-ac25-8c3bd8d34bfa",
    "hitokoto": "生而为人，我很抱歉",
    "type": "d",
    "from": "人间失格",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572270731",
    "length": 9
  },
  {
    "id": 4843,
    "uuid": "c6f7335f-1c0d-40e2-9a55-6946f9a13572",
    "hitokoto": "在月色与雪色之间，你是第三种绝色",
    "type": "d",
    "from": "余光中",
    "from_who": null,
    "creator": "亘古者·道一",
    "creator_uid": 4207,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572857980",
    "length": 16
  },
  {
    "id": 4844,
    "uuid": "07a4c694-c6db-4e23-8585-23a88ceab5d9",
    "hitokoto": "这是在是我所知物理学中最富诗意的东西：你的一切都是星辰。",
    "type": "d",
    "from": "劳伦斯·M·克劳斯",
    "from_who": null,
    "creator": "亘古者·道一",
    "creator_uid": 4207,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572858875",
    "length": 28
  },
  {
    "id": 4845,
    "uuid": "b6523c12-3fa6-4148-8a44-f33e5a58ea82",
    "hitokoto": "你身体里的每一个原子都来自一颗爆炸了的恒星，形成你左手的原子可能与右手的来自不同的恒星。这是在我所知物理学中最富诗意的东西：你的一切都是星辰",
    "type": "d",
    "from": "劳伦斯·M·克劳斯",
    "from_who": null,
    "creator": "亘古者·道一",
    "creator_uid": 4207,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572860855",
    "length": 70
  },
  {
    "id": 4854,
    "uuid": "ad74c45d-c9ea-4115-a0fb-67507c338cf7",
    "hitokoto": "以为是初见，其实是重逢。\r\n",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "卑微网友.",
    "creator_uid": 4776,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580554931",
    "length": 14
  },
  {
    "id": 4855,
    "uuid": "8947200d-5743-47d6-b8a1-8a801f0c94e0",
    "hitokoto": "一草一千秋，一花一世界。",
    "type": "d",
    "from": "目送",
    "from_who": "龙应台",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370818",
    "length": 12
  },
  {
    "id": 4856,
    "uuid": "5d23caa1-bde1-4d0d-9f85-af8067c55290",
    "hitokoto": "我站在路口，哈出的气可以把那些六角形的雪融化。",
    "type": "d",
    "from": "嗨，STORM GLASS",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370817",
    "length": 23
  },
  {
    "id": 4863,
    "uuid": "f5078bae-d3a0-4f40-be36-a4e597f66e5d",
    "hitokoto": "每个人都有属于自己的一片森林，也许我们从来不曾去过，但它一直在那里，总会在那里。迷失的人迷失了，相逢的人会再相逢。即使是你最心爱的人，心中都会有一片你无法到达的森林。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": null,
    "creator": "南瓜童鞋",
    "creator_uid": 4251,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573376571",
    "length": 83
  },
  {
    "id": 4865,
    "uuid": "a97fcb1a-622c-43e5-b017-c119cc35d340",
    "hitokoto": "天上剑仙三百万，见我也须尽低眉",
    "type": "d",
    "from": "修真",
    "from_who": null,
    "creator": "纯情",
    "creator_uid": 4273,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573653246",
    "length": 15
  },
  {
    "id": 4866,
    "uuid": "53d2c2e0-231c-478a-9b94-f6d1151dc92d",
    "hitokoto": "我总在这里等着，你不过来， 不让我过去，那么我就在这里，累了 的时候，退后一步，回头看，我在这 里。",
    "type": "d",
    "from": "凰权",
    "from_who": "宁弈",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581150531",
    "length": 50
  },
  {
    "id": 4867,
    "uuid": "2227fe22-222e-4cab-ae01-f938c53bb45e",
    "hitokoto": "和你在一起，需要下地狱吗？那么，我去。",
    "type": "d",
    "from": "扶摇皇后",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581150255",
    "length": 19
  },
  {
    "id": 4868,
    "uuid": "fc7e80c9-1a69-442b-b5b3-1b96309014f9",
    "hitokoto": "如果我们最终要离别,请让我此刻沉睡在你的海洋,三万里长空碧蓝如洗,这一刻你的天地便是我的全部",
    "type": "d",
    "from": "扶摇皇后",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581150129",
    "length": 46
  },
  {
    "id": 4869,
    "uuid": "686e038b-d116-434d-a27e-346eb7db0e8a",
    "hitokoto": "看尽三十三宫阙，最高不过离恨天。  数遍四百四病难，最苦不过长牵念。",
    "type": "d",
    "from": "扶摇皇后",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581150091",
    "length": 34
  },
  {
    "id": 4870,
    "uuid": "994373fe-5abd-469b-adec-29665106576d",
    "hitokoto": "如今我终于明白，我渡得过万里狂风，渡得过千条性命，渡得过诗酒年华，却渡不过，你不顾而去的目光。",
    "type": "d",
    "from": "扶摇皇后",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581150036",
    "length": 47
  },
  {
    "id": 4872,
    "uuid": "774138f0-f77a-4f3b-990e-9e5a8e459238",
    "hitokoto": "逐鹿场，你和我，都容不得心软。你若不肯横刀立斩，那便我先绝情出手，等你以命相博。\r\n",
    "type": "d",
    "from": "凰权",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581149124",
    "length": 42
  },
  {
    "id": 4873,
    "uuid": "6a7c04e3-9de8-44ff-b6af-1919585ed18f",
    "hitokoto": "谁也不再拥有温暖的温度，来焐热那一片彻骨的寒",
    "type": "d",
    "from": "凰权",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581149017",
    "length": 22
  },
  {
    "id": 4875,
    "uuid": "5ebd2c21-1b91-438e-b821-331bd9ac5b8f",
    "hitokoto": "我的心，永在它该在的位置，或有一日翻江倒海，能换得它倾倒翻覆。",
    "type": "d",
    "from": "凰权",
    "from_who": "凤知微",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581148720",
    "length": 31
  },
  {
    "id": 4876,
    "uuid": "64da51e9-00b4-4bef-b3d1-aff1cf2fc002",
    "hitokoto": "这一番乱哄哄你争我杀，到头来换了什么？不过是半樽薄酒，一身落拓，数曲残琴，满鬓风霜。",
    "type": "d",
    "from": "凰权",
    "from_who": "天下归元",
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581148590",
    "length": 42
  },
  {
    "id": 4877,
    "uuid": "d51719e5-08ff-4f7d-8251-5807c6de4dce",
    "hitokoto": "我也喜欢哦，那种追求温柔的，暖暖的，互相吸引着的，用力生活的心情。",
    "type": "d",
    "from": "知音漫客",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370815",
    "length": 33
  },
  {
    "id": 4878,
    "uuid": "2a1cd5bf-7ed1-4945-b220-d8c2887bd941",
    "hitokoto": "那涂涂画画的字句，幼圆的字体，只有一句，我喜欢你。",
    "type": "d",
    "from": "春色の空",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370815",
    "length": 25
  },
  {
    "id": 4883,
    "uuid": "f05987f3-40e8-4533-9cba-e10b121fc213",
    "hitokoto": "给岁月以文明，而不是给文明以岁月。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "h2o",
    "creator_uid": 4312,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574142882",
    "length": 17
  },
  {
    "id": 4885,
    "uuid": "bb196b78-d6de-45a4-8e2d-02a8d6b273f7",
    "hitokoto": "你最爱的人，你为他做了很多事，但他不知道，因为你觉得做这些事都是应该的，你忘记跟他说了。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "answer",
    "creator_uid": 4337,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574482847",
    "length": 44
  },
  {
    "id": 4889,
    "uuid": "9b0ab484-3aaa-4745-b014-723868c42ec2",
    "hitokoto": "遇事不决，可问春风。",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "chen11",
    "creator_uid": 4299,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573980410",
    "length": 10
  },
  {
    "id": 4890,
    "uuid": "4974e940-f8b9-46f2-bf8c-26c18477b1d7",
    "hitokoto": "循此苦旅，直抵群星",
    "type": "d",
    "from": "SCP基金会",
    "from_who": null,
    "creator": "h2o",
    "creator_uid": 4312,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574142807",
    "length": 9
  },
  {
    "id": 4891,
    "uuid": "8a6e1045-4400-4857-b41b-61aa77362100",
    "hitokoto": "我们这种人，生来就是要毁灭一些东西。前面是山，我们就爬山，前面是海，我们就渡海，前面是皇宫 ，我们就开炮！",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "answer",
    "creator_uid": 4337,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574483051",
    "length": 53
  },
  {
    "id": 4898,
    "uuid": "a701237d-450b-4aed-abec-3bfa56114b4b",
    "hitokoto": "世间文字八万个，唯有一字最是能杀人：情字可误人，情字可杀人。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": "烽火戏诸侯",
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571145156",
    "length": 30
  },
  {
    "id": 4899,
    "uuid": "815425c5-c770-4cb0-ba40-40b924820a4d",
    "hitokoto": "War is peace.  Freedom is slavery.  Ignorance is strength.",
    "type": "d",
    "from": "1984",
    "from_who": "George Orwell",
    "creator": "dgklr",
    "creator_uid": 4214,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572934234",
    "length": 58
  },
  {
    "id": 4902,
    "uuid": "86848c4e-4c45-41ee-bbe9-9e43777c9492",
    "hitokoto": "那些杀不死我的，终将使我变得更加强大。",
    "type": "d",
    "from": "尼采",
    "from_who": "尼采",
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1574512303",
    "length": 19
  },
  {
    "id": 4907,
    "uuid": "38501995-780c-4243-a555-9a74bd7e1889",
    "hitokoto": "永远年轻，永远热泪盈眶。",
    "type": "d",
    "from": "达摩流浪者",
    "from_who": "Jack Kerouac",
    "creator": "ozjkaddy",
    "creator_uid": 4274,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573654113",
    "length": 12
  },
  {
    "id": 4910,
    "uuid": "145d3487-f367-4bf8-80b1-24d07e622a13",
    "hitokoto": "一个人可以被毁灭，但不能被打败。",
    "type": "d",
    "from": "老人与海",
    "from_who": "海明威",
    "creator": "夕之树",
    "creator_uid": 4248,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573333725",
    "length": 16
  },
  {
    "id": 4911,
    "uuid": "55f4a3ef-3051-46f8-8c12-bf8e0c363632",
    "hitokoto": "燕雀安知鸿鹄之志哉？",
    "type": "d",
    "from": "史记·陈涉世家",
    "from_who": "陈涉",
    "creator": "夕之树",
    "creator_uid": 4248,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573334054",
    "length": 10
  },
  {
    "id": 4914,
    "uuid": "c989d2e8-6cdf-499c-b5a3-979dab049063",
    "hitokoto": "“I'a I'a.Cthulhu Fhatgn!”",
    "type": "d",
    "from": "霍华德·菲利普·洛夫克拉夫特",
    "from_who": null,
    "creator": "亘古者·道一",
    "creator_uid": 4207,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572862771",
    "length": 25
  },
  {
    "id": 4921,
    "uuid": "c5d0a232-7848-41e8-85f5-9d43780a09ab",
    "hitokoto": "那一年我二十一岁，在我一生的黄金时代，我有好多奢望：我想爱，想吃，还想在一瞬间变成天上半明半暗的云。",
    "type": "d",
    "from": "黄金时代",
    "from_who": "王小波",
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571539218",
    "length": 50
  },
  {
    "id": 4924,
    "uuid": "a2a26b36-adbb-4a00-83b1-70209f7a5e15",
    "hitokoto": "此剑抚平天下不平事，此剑无愧世间有愧人。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": "烽火戏诸侯",
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571145207",
    "length": 20
  },
  {
    "id": 4933,
    "uuid": "b5731a29-f2a3-4dc0-ab67-ddab443c29b5",
    "hitokoto": "树敌真的很容易，有时候简单到令人痛心",
    "type": "d",
    "from": "进化",
    "from_who": null,
    "creator": "滑稽者",
    "creator_uid": 4240,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574848199",
    "length": 18
  },
  {
    "id": 4938,
    "uuid": "986485fc-4b3d-4346-82c3-2e1f373d0f69",
    "hitokoto": "凡事都有一个与一望而知不同的真相",
    "type": "d",
    "from": "约翰·勒卡雷",
    "from_who": null,
    "creator": "久鸽",
    "creator_uid": 4374,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575427961",
    "length": 16
  },
  {
    "id": 4939,
    "uuid": "376b1594-72e1-4aa4-9328-5918448e1ed4",
    "hitokoto": "当我忘了你的时候，我就忘了我自己。",
    "type": "d",
    "from": "呼啸山庄",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575474183",
    "length": 17
  },
  {
    "id": 4944,
    "uuid": "495e41eb-4923-4df6-8768-0cdc70a5f9b0",
    "hitokoto": "你的无畏来源于无知",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717842",
    "length": 9
  },
  {
    "id": 4945,
    "uuid": "505082a1-2029-4041-b2d6-053b2cd835c9",
    "hitokoto": "我们都是阴沟里的虫子,但总还是得有人仰望星空。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717861",
    "length": 23
  },
  {
    "id": 4946,
    "uuid": "f81a5c73-cc1f-4ab6-a55f-9e38243dfae9",
    "hitokoto": "死亡是一座永恒的灯塔，不管你驶向何方，最终都会朝它转向。一切都将逝去，只有死神永生。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717882",
    "length": 42
  },
  {
    "id": 4947,
    "uuid": "0007c1fb-5209-42c7-a0f1-3390d31123ce",
    "hitokoto": "碑是那么小，与其说是为了纪念，更像是为了忘却。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717902",
    "length": 23
  },
  {
    "id": 4948,
    "uuid": "79336ff2-3817-4d46-8773-1e83a8c20b12",
    "hitokoto": "弱小和无知，不是生存的障碍，傲慢才是。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717938",
    "length": 19
  },
  {
    "id": 4949,
    "uuid": "4edc6dac-cc2a-4f73-a0a3-47058c7368ea",
    "hitokoto": "给岁月以文明，而不是给文明以岁月。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717962",
    "length": 17
  },
  {
    "id": 4950,
    "uuid": "ea640d2a-1bd5-4f81-85e6-68621f3ad802",
    "hitokoto": "空不是无，空是一种存在，你得用空这种存在填满自己。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575717975",
    "length": 25
  },
  {
    "id": 4955,
    "uuid": "0d707444-f4a5-43b3-a5dc-064e64579cf0",
    "hitokoto": "前进！前进！不择手段的前进！",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575718005",
    "length": 14
  },
  {
    "id": 4963,
    "uuid": "34cad705-470f-46a4-a951-0bd58571ae5c",
    "hitokoto": "阳光依然干净，星河依然灿烂。世界也依然在长久深情中缓缓地朝前走。于是时间奔流，得以见证人间在漫长岁月里，所有的永恒和不朽。",
    "type": "d",
    "from": "黑天",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665975",
    "length": 61
  },
  {
    "id": 4964,
    "uuid": "445dc7ab-031e-45c2-8e8f-6a0384cf815f",
    "hitokoto": "有些事情，即便不用纸笔，也一样会被铭记。",
    "type": "d",
    "from": "黑天",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665935",
    "length": 20
  },
  {
    "id": 4965,
    "uuid": "a4a5a43d-f4df-4d27-8c15-27d21c1adcd0",
    "hitokoto": "悠长人生和白首深情，都是岁月的善举。",
    "type": "d",
    "from": "黑天",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665909",
    "length": 18
  },
  {
    "id": 4966,
    "uuid": "10418c87-be69-436a-b50a-fc5435ce400f",
    "hitokoto": "他突然开始有点喜欢这个看似严苛无趣、却偶尔能给人惊喜的世界了，因为面前这个他特别喜欢的人。这大概是他有生以来最大程度的爱屋及乌。",
    "type": "d",
    "from": "黑天",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665399",
    "length": 64
  },
  {
    "id": 4967,
    "uuid": "6fcde87f-0672-4f0a-aac3-566c4aefc8df",
    "hitokoto": "这些或板正严肃、或风趣幽默的长辈们,在那些平静岁月里扮演着各种角色——引路者、监督人、朋友、师长,正面的、反面的,讨人喜欢的、令人畏惧的,但总有那么些时候，他们会褪下所有附属身份，去当一个能拦下所有风雨的纯粹的父亲。",
    "type": "d",
    "from": "黑天",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665301",
    "length": 108
  },
  {
    "id": 4969,
    "uuid": "a052cb56-ff66-40fb-9ade-f474c7796e74",
    "hitokoto": "他只有两只手，所以只能用心抓住一个人。",
    "type": "d",
    "from": "黑天",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665163",
    "length": 19
  },
  {
    "id": 4970,
    "uuid": "09a9a100-85d1-437f-9512-7c5a45b26531",
    "hitokoto": "黑，真他妈的黑啊。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "peerin",
    "creator_uid": 4859,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581663676",
    "length": 9
  },
  {
    "id": 4983,
    "uuid": "1fff4d92-ff1a-438e-8682-c202d5b1a492",
    "hitokoto": " 那个夏天的蝉鸣比哪一年都聒噪，教室窗外枝桠疯长，却总也挡不住烈阳。",
    "type": "d",
    "from": "校园",
    "from_who": "木苏里",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496827",
    "length": 34
  },
  {
    "id": 4984,
    "uuid": "29692dfa-36a8-46a1-83f9-0c04f085dc47",
    "hitokoto": "爱恋中的每个瞬间都有可能是一生。",
    "type": "d",
    "from": "文学",
    "from_who": null,
    "creator": "悠远的苍穹",
    "creator_uid": 4871,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496588",
    "length": 16
  },
  {
    "id": 4985,
    "uuid": "6b160474-0528-4c38-b07c-37bc862e738e",
    "hitokoto": "眼睛为她下着雨，心却为她打着伞，这就是爱情。 ",
    "type": "d",
    "from": "泰戈尔",
    "from_who": null,
    "creator": "悠远的苍穹",
    "creator_uid": 4871,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496560",
    "length": 23
  },
  {
    "id": 4987,
    "uuid": "e2d3183d-0b58-4113-bed1-448f9b77f396",
    "hitokoto": "死亡是唯一一座永远亮着的灯塔，不管你向哪里航行，最终都得转向它指引的方向。一切终会逝去，只有死神永生。",
    "type": "d",
    "from": "三体：死神永生",
    "from_who": "刘慈欣",
    "creator": "悠远的苍穹",
    "creator_uid": 4871,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496291",
    "length": 51
  },
  {
    "id": 4990,
    "uuid": "004f20be-24e3-441d-844b-e360dac701e7",
    "hitokoto": "一颗红心两只手，世世代代跟党走。",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581493317",
    "length": 16
  },
  {
    "id": 4992,
    "uuid": "1421e241-079c-48d1-aa63-69452bf03f21",
    "hitokoto": "不幸的人最怕别人说他们的幸福。",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581473453",
    "length": 15
  },
  {
    "id": 4993,
    "uuid": "abd559d1-8502-4e5d-826a-05144e864fb4",
    "hitokoto": "人们，你们怎么能因为贫穷，就以物遮目，而变化得如此愚蠢呢？",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581473266",
    "length": 29
  },
  {
    "id": 4994,
    "uuid": "b0942f1e-6b9b-4b28-8fdb-e5f84466e587",
    "hitokoto": "农民家的孩子啊，他们的第一堂功课就是劳动！",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581473117",
    "length": 21
  },
  {
    "id": 4995,
    "uuid": "f6efcb6d-d96a-40b5-a60b-9d0b52ff4240",
    "hitokoto": "欲悲闻鬼叫，我哭豺狼笑。",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581473046",
    "length": 12
  },
  {
    "id": 4996,
    "uuid": "2900f38e-cad5-4445-8299-d057d3cb6925",
    "hitokoto": "锁链可以锁住门窗，锁住手脚，但人心是锁不住的！",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581472944",
    "length": 23
  },
  {
    "id": 4997,
    "uuid": "8b8e213f-386d-4896-bfab-e2415400991e",
    "hitokoto": "在最平常的事情中都可以显示出一个人人格的伟大来！",
    "type": "d",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581472858",
    "length": 24
  },
  {
    "id": 5002,
    "uuid": "b7cc121f-4214-4693-a5af-05b8e8f13ec5",
    "hitokoto": "山有峰顶，海有彼岸，漫漫长途，终有回转，余味苦涩，终有回甘。",
    "type": "d",
    "from": "一切都是最好的安排",
    "from_who": null,
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581329541",
    "length": 30
  },
  {
    "id": 5003,
    "uuid": "c236e8ad-6604-4ec0-898a-86f3821d505a",
    "hitokoto": "中国总是被他们最勇敢的人保护得很好。",
    "type": "d",
    "from": "论中国",
    "from_who": "基辛格 ",
    "creator": "crazywhale",
    "creator_uid": 4851,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581257453",
    "length": 18
  },
  {
    "id": 5005,
    "uuid": "27b301a3-6fb9-48b4-b4cb-8025413797c9",
    "hitokoto": "从今天起，你要做一个不动声色的大人了。不准情绪化，不准偷偷想念，不准回头看。去过自己另外的生活。你要听话，不是所有的鱼都会生活在同一片海里。",
    "type": "d",
    "from": "舞舞舞",
    "from_who": "村上春树",
    "creator": "谙世.",
    "creator_uid": 4845,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581230726",
    "length": 70
  },
  {
    "id": 5007,
    "uuid": "ab39a7c4-65b1-45f8-b77e-fbb38c103ebf",
    "hitokoto": "青春把记忆印成彩色的相片，镶嵌在少女如云柔软的裙摆里！",
    "type": "d",
    "from": "春色の空",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370815",
    "length": 27
  },
  {
    "id": 5008,
    "uuid": "1ae2a0d1-a104-492b-91e8-912c37328a50",
    "hitokoto": "嗨！要溢出粉色泡泡的香草女孩，跨越三角尺的制服鞋，干净清爽的三角巾，放课后的绿荫小巷，蓝色把天空染成了炫目的晴朗。",
    "type": "d",
    "from": "春色の空",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370814",
    "length": 57
  },
  {
    "id": 5009,
    "uuid": "4fe5e817-42f9-41fa-b408-e4fac80c449e",
    "hitokoto": "呐，我对你的沉沦，就像樱花落入大地~",
    "type": "d",
    "from": "你看樱花我看你",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370814",
    "length": 18
  },
  {
    "id": 5010,
    "uuid": "70fe915d-f4e2-468f-9e60-f26eb4a35aaf",
    "hitokoto": "盛夏的那张数学卷子，一笔一画，我都写得极认真。卷子交上去，被塞进档案袋里，我的七年级结束了。",
    "type": "d",
    "from": "周大伯你好，周大伯再见",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370813",
    "length": 46
  },
  {
    "id": 5011,
    "uuid": "7cc61b1a-781f-49f1-9e3e-96997cce616a",
    "hitokoto": "孤身一人，去往一个陌生地方，开启一段未知旅程。",
    "type": "d",
    "from": "转学路？不，青春纪！",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370813",
    "length": 23
  },
  {
    "id": 5012,
    "uuid": "84f876fd-5d8f-4e89-a12b-56f41c0100e7",
    "hitokoto": "心向花开，何不朝夕。",
    "type": "d",
    "from": "百年浅吟",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370813",
    "length": 10
  },
  {
    "id": 5013,
    "uuid": "5ff8e399-27bb-49ba-9a25-a8ad66f22408",
    "hitokoto": "尚未决定清与浊的心，是否能成为自己的眼睛？",
    "type": "d",
    "from": "清雨·浊雨",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370812",
    "length": 21
  },
  {
    "id": 5014,
    "uuid": "cc31e819-5850-4118-bc56-eb91f3d080bd",
    "hitokoto": "有些事，只能一个人做。有些关，只能一个人过。有些路啊，只能一个人走。",
    "type": "d",
    "from": "山路",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370811",
    "length": 34
  },
  {
    "id": 5015,
    "uuid": "7bff78a2-0afd-4047-b619-586f8e792d5a",
    "hitokoto": "我慢慢地，慢慢地了解到，所谓父女母子一场只不过意味着，你和他的缘分就是今生今世不断地在目送他的背影渐行渐远。",
    "type": "d",
    "from": "目送",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370811",
    "length": 54
  },
  {
    "id": 5016,
    "uuid": "3f4527fc-3d67-419c-94c9-b2feb8153b9c",
    "hitokoto": "一路上樱花照眼，她静静看着窗外流荡过去的风景，窗玻璃映出她自己的容颜，和窗外的粉色樱花明灭掩映；她的眼神迷离，时空飘忽。",
    "type": "d",
    "from": "雨儿",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370810",
    "length": 60
  },
  {
    "id": 5017,
    "uuid": "e34847d5-904f-4f7e-8069-ceaa1f975bd9",
    "hitokoto": "黑夜给了我黑色眼睛，我却用它寻找光明。",
    "type": "d",
    "from": "一代人·巨星",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370810",
    "length": 19
  },
  {
    "id": 5023,
    "uuid": "2f04bc0f-5491-4435-adb6-38add217c05d",
    "hitokoto": "放弃不难，但坚持一定很酷。",
    "type": "d",
    "from": "解忧杂货店",
    "from_who": "东野圭吾",
    "creator": "CY-Track",
    "creator_uid": 4740,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580262873",
    "length": 13
  },
  {
    "id": 5041,
    "uuid": "a6b4c2ca-4cdf-4a47-bb4b-02a344d2cc33",
    "hitokoto": "“马孔多在下雨”",
    "type": "d",
    "from": "百年孤独",
    "from_who": null,
    "creator": "TycXdd",
    "creator_uid": 4608,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578361056",
    "length": 8
  },
  {
    "id": 5048,
    "uuid": "c28dbd85-7a1d-4735-a55e-7e689816ca19",
    "hitokoto": "和平视窗计划只是个美丽的童话，竞赛代替不了战争，就像葡萄酒代替不了鲜血。",
    "type": "d",
    "from": "光荣与梦想",
    "from_who": null,
    "creator": "005",
    "creator_uid": 4640,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578843550",
    "length": 36
  },
  {
    "id": 5050,
    "uuid": "a944dab8-b8f8-4989-8b4e-4f72146718e9",
    "hitokoto": "过去的人真笨，过去的人真难。",
    "type": "d",
    "from": "地火",
    "from_who": "刘慈欣",
    "creator": "005",
    "creator_uid": 4640,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578843069",
    "length": 14
  },
  {
    "id": 5051,
    "uuid": "39f4a28d-4756-4dd6-a629-5a79ce3901e2",
    "hitokoto": "就在这一夜，不知道有多少与我一样的新新人类上路了，不管好坏，我们将是第一批真正触摸永恒的人。",
    "type": "d",
    "from": "2018",
    "from_who": null,
    "creator": "005",
    "creator_uid": 4640,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578843823",
    "length": 46
  },
  {
    "id": 5057,
    "uuid": "8a32e748-1d48-4e2d-9370-8e1845a21772",
    "hitokoto": "维罗纳的夏天找不到这样一朵好花。",
    "type": "d",
    "from": "罗密欧与朱丽叶",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1580182489",
    "length": 16
  },
  {
    "id": 5065,
    "uuid": "6b412dc6-c27b-48da-8135-8a66f682e309",
    "hitokoto": "我躲在断墙后面 偷看两个少年徒手摘光 星星映在了他们眼里 光却撒在了我身上",
    "type": "d",
    "from": "撒野",
    "from_who": null,
    "creator": "墨客熊",
    "creator_uid": 4413,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581818737",
    "length": 37
  },
  {
    "id": 5070,
    "uuid": "73c710e7-59b3-4b7f-8d28-ea0f21cd397c",
    "hitokoto": "It was the best of times, it was the worst of times.",
    "type": "d",
    "from": "双城记",
    "from_who": "狄更斯",
    "creator": "Hermione_Granger",
    "creator_uid": 4956,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581949481",
    "length": 52
  },
  {
    "id": 5073,
    "uuid": "83a0321d-2850-4928-b85e-d8949127a395",
    "hitokoto": "我们终将在没有黑暗的地方相见。",
    "type": "d",
    "from": "1984",
    "from_who": null,
    "creator": "C712",
    "creator_uid": 4955,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581950095",
    "length": 15
  },
  {
    "id": 5077,
    "uuid": "19c48107-e701-4dcd-b9b7-47da104be5a3",
    "hitokoto": "人生不可以有后悔，只可以有遗憾，遗憾是感叹错过，后悔是否定自己曾经做的选择",
    "type": "d",
    "from": "一切都是最好的安排",
    "from_who": null,
    "creator": "盛夏",
    "creator_uid": 4964,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582011731",
    "length": 37
  },
  {
    "id": 5078,
    "uuid": "f27221fc-5ac1-43fa-84e1-b0aa976b4ab2",
    "hitokoto": "言念君子温其如玉",
    "type": "d",
    "from": "剑来",
    "from_who": null,
    "creator": "龙染",
    "creator_uid": 4966,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582029930",
    "length": 8
  },
  {
    "id": 5080,
    "uuid": "87d264ad-af32-4ade-86ef-905878c1f1ee",
    "hitokoto": "为了自己，我必须饶恕你。一个人，不能永远在胸中养着一条毒蛇；不能夜夜起身，在灵魂的园子里栽种荆棘。",
    "type": "d",
    "from": "自深深处",
    "from_who": "奥斯卡·王尔德",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582100646",
    "length": 49
  },
  {
    "id": 5081,
    "uuid": "b017da94-55f6-4a66-bcca-c4a098da781e",
    "hitokoto": "悲剧将人生的有价值的东西毁灭给人看，喜剧将那无价值的撕破给人看。",
    "type": "d",
    "from": "语丝",
    "from_who": "鲁迅",
    "creator": "Ling",
    "creator_uid": 5012,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582284187",
    "length": 32
  },
  {
    "id": 5082,
    "uuid": "f70d5a7e-2122-4d44-a5be-5cc8ec6e73c2",
    "hitokoto": "当你想要放弃的时候，想想是什么让你当初坚持走到了这里。",
    "type": "d",
    "from": "科比",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468810",
    "length": 27
  },
  {
    "id": 5083,
    "uuid": "49448db1-56ca-47cb-9d71-edab3e5579ba",
    "hitokoto": "当脑子里很乱的时候，做爱是最好的选择。要是烦恼和痛苦也都能被快感冲走的话就好了。",
    "type": "d",
    "from": "駄作",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468853",
    "length": 40
  },
  {
    "id": 5084,
    "uuid": "efd0ed6a-c973-4d6a-bf9f-5798c8457a28",
    "hitokoto": "每个人都在自己的生命中频繁地抛弃着自己的过去。",
    "type": "d",
    "from": "幽兰黛尔",
    "from_who": "米哈游",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468891",
    "length": 23
  },
  {
    "id": 5085,
    "uuid": "16812aa9-7295-4a72-a322-f4ed95275d8c",
    "hitokoto": "梦如同黎明的泡沫一样渐渐消失。",
    "type": "d",
    "from": "幽兰黛尔",
    "from_who": "米哈游",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468918",
    "length": 15
  },
  {
    "id": 5091,
    "uuid": "e69f5609-378f-4461-89d0-7508f2a06022",
    "hitokoto": "影响大众想象力的，并不是事实本身，而是它扩散和传播的方式。",
    "type": "d",
    "from": "乌合之众",
    "from_who": "古斯塔夫·勒庞",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468676",
    "length": 29
  },
  {
    "id": 5092,
    "uuid": "19ec3c14-5ca0-43a6-b991-e4e4341f37e5",
    "hitokoto": "人死后会成为什么?夜空中的一座孤岛。",
    "type": "d",
    "from": "一封孤岛的信",
    "from_who": "著小生zoki",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468746",
    "length": 18
  },
  {
    "id": 5093,
    "uuid": "55b59bf6-57fb-4000-89bf-f35727f82b59",
    "hitokoto": "我想告诉你，这个世界是为了你幸福才存在的。",
    "type": "d",
    "from": "关于我被小学女生绑架这件事",
    "from_who": "猫薄荷制作组",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468783",
    "length": 21
  },
  {
    "id": 5103,
    "uuid": "2f35b9c6-4e2d-45ba-a231-d409cc02a168",
    "hitokoto": "藏好自己，做好清理。",
    "type": "d",
    "from": "三体",
    "from_who": null,
    "creator": "748883120",
    "creator_uid": 5014,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582305563",
    "length": 10
  },
  {
    "id": 5104,
    "uuid": "ab267855-445b-4513-a9a4-03ae664d3b5c",
    "hitokoto": "管他是不是人面兽心，我们只要活着就行。",
    "type": "d",
    "from": "维庸之妻",
    "from_who": "太宰治",
    "creator": "山山而川",
    "creator_uid": 5024,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582400515",
    "length": 19
  },
  {
    "id": 5105,
    "uuid": "2a6a8d63-6708-4c05-b0c4-3880d6930773",
    "hitokoto": "毁灭你，与你有何相干?",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "748883120",
    "creator_uid": 5014,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582305644",
    "length": 11
  },
  {
    "id": 5107,
    "uuid": "c39cc433-0a3b-45c6-bdc2-f955c73ef09d",
    "hitokoto": "人们生于信仰，毁于信仰。人们在信仰的灰烬重生。",
    "type": "d",
    "from": "残次品",
    "from_who": null,
    "creator": "C712",
    "creator_uid": 4955,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581948735",
    "length": 23
  },
  {
    "id": 5129,
    "uuid": "0e7b493b-16d4-4baf-9fc7-1c9db2427014",
    "hitokoto": "有美一人，清扬婉兮。",
    "type": "d",
    "from": "诗经·国风·郑风·野有蔓草",
    "from_who": null,
    "creator": "PiaoxueMaster",
    "creator_uid": 5042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582512880",
    "length": 10
  },
  {
    "id": 5140,
    "uuid": "143831ed-fb7a-4337-863c-4e43118cdac3",
    "hitokoto": "为了苦难中的祖国，我扑动蝴蝶的翅膀......",
    "type": "d",
    "from": "2018",
    "from_who": null,
    "creator": "005",
    "creator_uid": 4640,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578842948",
    "length": 23
  },
  {
    "id": 5142,
    "uuid": "692dc660-a77c-4106-834f-4500d18ef1cd",
    "hitokoto": "什么是死？是终点，是永诀，是不可挽回，是再也握不到的手、感觉不到的温度，再也说不出口的“对不起”。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "上官天涵",
    "creator_uid": 4614,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578454342",
    "length": 49
  },
  {
    "id": 5143,
    "uuid": "6a2ac4a9-6cb8-461c-820d-1b15d0c41254",
    "hitokoto": "很多年之后，他才知道“绝影”只是个传说。布加迪威龙是世界上量产最快的跑车，但他跑不过时光，更跑不过早已注定好的命运。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "上官天涵",
    "creator_uid": 4614,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578454211",
    "length": 58
  },
  {
    "id": 5144,
    "uuid": "d2a4a1d0-f8e1-462b-9cdc-748606886b8c",
    "hitokoto": "一见钟情不是个魔法，它是命运。第一次遭遇命运的时候我们措手不及，所以在命运面前惨败，第二次我们已经全副武装，我们不能在同一件事上失败两次。",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "上官天涵",
    "creator_uid": 4614,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578454121",
    "length": 69
  },
  {
    "id": 5158,
    "uuid": "7d611720-a247-4c3b-89b1-88ebb870d257",
    "hitokoto": "万物初发清净明，可知此芽成何草。",
    "type": "d",
    "from": "冰菓",
    "from_who": null,
    "creator": "scvoet",
    "creator_uid": 1713,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582784066",
    "length": 16
  },
  {
    "id": 5160,
    "uuid": "5bae86fb-36a1-4fb2-8464-ebbd41ffeb77",
    "hitokoto": "快乐固然兴奋，痛苦又何尝不美丽。",
    "type": "d",
    "from": "谈生命",
    "from_who": null,
    "creator": "laoming",
    "creator_uid": 5106,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582804080",
    "length": 16
  },
  {
    "id": 5162,
    "uuid": "a9109850-294f-49f3-9824-afdc84d89d6d",
    "hitokoto": "面具戴太久，就会长到脸上，再想揭下来，除非伤筋动骨扒皮。",
    "type": "d",
    "from": "鲁迅日记",
    "from_who": "鲁迅",
    "creator": "MoonDrop",
    "creator_uid": 5112,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582813886",
    "length": 28
  },
  {
    "id": 5167,
    "uuid": "f32de80e-0bbb-4fb6-8143-0a33ef49f08f",
    "hitokoto": "想带你去看电影，明天你就不是我女朋友了。",
    "type": "d",
    "from": "撒哈拉的故事",
    "from_who": "三毛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582959409",
    "length": 20
  },
  {
    "id": 5168,
    "uuid": "b3d82324-7ba6-4f17-b429-f0779e33daab",
    "hitokoto": "每夜你上床时，一定要觉得，今天可真活了个够，那么你的人生都不会有遗憾！",
    "type": "d",
    "from": "撒哈拉的故事",
    "from_who": "三毛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582959603",
    "length": 35
  },
  {
    "id": 5170,
    "uuid": "8aa16fbf-815e-4d66-98e2-1beef907f9e1",
    "hitokoto": "生命的过程，无论是阳春白雪，青菜豆腐，都得尝尝是什么滋味，才不枉走这么一遭！",
    "type": "d",
    "from": "撒哈拉的故事",
    "from_who": "三毛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582969240",
    "length": 38
  },
  {
    "id": 5171,
    "uuid": "58eea441-0fe4-45e6-9980-91f76b2a623e",
    "hitokoto": "每想你一次，天上飘落一粒沙，从此形成了撒哈拉！",
    "type": "d",
    "from": "撒哈拉的故事",
    "from_who": "三毛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582969488",
    "length": 23
  },
  {
    "id": 5172,
    "uuid": "6e03b66f-1015-4222-ba1b-2ce764dc2b04",
    "hitokoto": "每想拥抱你一次，天空飘落一片雪，至此雪花拥抱撒哈拉！",
    "type": "d",
    "from": "撒哈拉的故事",
    "from_who": "荷西",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582969510",
    "length": 26
  },
  {
    "id": 5177,
    "uuid": "2b9682d2-c9b1-4709-9b54-402ca747e2eb",
    "hitokoto": "人的悲欢本不相通我只觉得他们吵闹。",
    "type": "d",
    "from": "小杂感",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583044367",
    "length": 17
  },
  {
    "id": 5178,
    "uuid": "eff111d6-5f26-4f9a-9b11-5e8243ad1670",
    "hitokoto": "这世间的繁华喧闹，却栖息不下一颗干净的灵魂。在这污灰漫天的人间，欲出淤泥而不染，还真是难。",
    "type": "d",
    "from": "知乎",
    "from_who": "归璨",
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583044559",
    "length": 45
  },
  {
    "id": 5180,
    "uuid": "d433c564-e9a1-4f3f-a301-75167d6695ef",
    "hitokoto": "幸福的家庭都是相似的，不幸的家庭各有各的不幸。",
    "type": "d",
    "from": "安娜·卡列妮娜",
    "from_who": null,
    "creator": "曲奇",
    "creator_uid": 5168,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583050291",
    "length": 23
  },
  {
    "id": 5181,
    "uuid": "2db4ccdc-a706-4915-afca-49641c8002a6",
    "hitokoto": "祝你，生生不息，前程似锦。",
    "type": "d",
    "from": "知乎",
    "from_who": "归璨",
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583044589",
    "length": 13
  },
  {
    "id": 5182,
    "uuid": "05790dfc-4503-4393-8db1-8f1805b87c5d",
    "hitokoto": "幸福的家庭都是相似的，不幸的家庭各有各的不幸。",
    "type": "d",
    "from": "安娜·卡列妮娜",
    "from_who": null,
    "creator": "曲奇",
    "creator_uid": 5168,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583050338",
    "length": 23
  },
  {
    "id": 5184,
    "uuid": "b7659c7b-8134-4807-b216-6d3e76860be9",
    "hitokoto": "童年啊，是梦中的真，是真中的梦，是回忆时含泪的微笑。",
    "type": "d",
    "from": "繁星春水",
    "from_who": null,
    "creator": "Aldrich",
    "creator_uid": 5178,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583115583",
    "length": 26
  },
  {
    "id": 5185,
    "uuid": "bb46385d-91ce-4255-a2c9-9d27a057ea1a",
    "hitokoto": "或许是不知梦的缘故，流离之人追逐幻影。",
    "type": "d",
    "from": "龙族",
    "from_who": "江南",
    "creator": "夜隐辉",
    "creator_uid": 5181,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583123842",
    "length": 19
  },
  {
    "id": 5187,
    "uuid": "3ed97aca-767a-4980-b18a-8332fdee0969",
    "hitokoto": "天地之功不可仓促，艰难之业当累日月。",
    "type": "d",
    "from": "后汉书",
    "from_who": null,
    "creator": "臻子",
    "creator_uid": 5190,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583153408",
    "length": 18
  },
  {
    "id": 5192,
    "uuid": "c281cc33-585d-49ac-bf67-55de5971ee84",
    "hitokoto": "石可破也，而不可夺坚；丹可磨也，而不可夺赤。",
    "type": "d",
    "from": "吕氏春秋",
    "from_who": null,
    "creator": "臻子",
    "creator_uid": 5190,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583203638",
    "length": 22
  },
  {
    "id": 5194,
    "uuid": "5d2dea45-93bc-4f62-a1b1-330226f02a7f",
    "hitokoto": "青年人珍重的描写罢，时间正翻着书页，请你着笔！",
    "type": "d",
    "from": "青年人",
    "from_who": null,
    "creator": "Aldrich",
    "creator_uid": 5178,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583204977",
    "length": 23
  },
  {
    "id": 5196,
    "uuid": "9a7bdfb6-1071-4cbc-81f2-353dcbb1971d",
    "hitokoto": "但愿世间人无病，何愁架上药生尘。",
    "type": "d",
    "from": "心印杂记",
    "from_who": "清朝对联",
    "creator": "心印001",
    "creator_uid": 3471,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583224552",
    "length": 16
  },
  {
    "id": 5198,
    "uuid": "d8866e09-d5e8-449f-a6bb-e123261bf3c1",
    "hitokoto": "人之所以不幸，就缘于置身这卑劣的人世间，为卑劣所恼，连自己的言行也不得不变的卑劣起来。",
    "type": "d",
    "from": "戏作三昧",
    "from_who": null,
    "creator": "欧气震八荒",
    "creator_uid": 5166,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583222176",
    "length": 43
  },
  {
    "id": 5199,
    "uuid": "24be7fdc-7ae5-405c-8723-f32084a361e0",
    "hitokoto": "只要假以时日，没有什么是不可战胜的。",
    "type": "d",
    "from": "福尔摩斯探案集",
    "from_who": null,
    "creator": "eqmm",
    "creator_uid": 5209,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583222042",
    "length": 18
  },
  {
    "id": 5200,
    "uuid": "c8b3d0d2-b85c-4d57-86c0-a2b375f20261",
    "hitokoto": "唯因虚梦，尤需真活。彼梦会醒，此梦亦终有醒来之时。人生在世，要活得回首往事之际能无愧于说：此生确曾活出个名堂来。",
    "type": "d",
    "from": "黄粱梦",
    "from_who": null,
    "creator": "欧气震八荒",
    "creator_uid": 5166,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583222015",
    "length": 56
  },
  {
    "id": 5202,
    "uuid": "5e0f391f-9036-4dd4-b0c8-7488eaf9b17f",
    "hitokoto": "好一似今朝沦落人，且回首往昔荣华日。",
    "type": "d",
    "from": "鼻子",
    "from_who": null,
    "creator": "欧气震八荒",
    "creator_uid": 5166,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583221781",
    "length": 18
  },
  {
    "id": 5203,
    "uuid": "fa8e481a-c11c-4422-922e-15b6e30f9e6e",
    "hitokoto": "人心如同无明之黑暗，烦有烦恼之火，长燃不熄，淡去的只是生命……",
    "type": "d",
    "from": "袈裟与盛远",
    "from_who": null,
    "creator": "欧气震八荒",
    "creator_uid": 5166,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583221671",
    "length": 31
  },
  {
    "id": 5207,
    "uuid": "2a13d738-47a7-4628-af3d-7f7f41d50963",
    "hitokoto": "上面的雪，很冷吧，冰冷的月光照着它。下面的雪，很重吧，上百的人们压过它。中间的雪，很寂寞吧，看不见天也看不见地。",
    "type": "d",
    "from": "诗集",
    "from_who": null,
    "creator": "ana",
    "creator_uid": 5227,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583321715",
    "length": 56
  },
  {
    "id": 5208,
    "uuid": "2f7b7ae1-027a-4466-bcca-2224c53f126e",
    "hitokoto": "生命不止，奋斗不息。",
    "type": "d",
    "from": "托马斯·卡莱尔经典语录",
    "from_who": null,
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583326894",
    "length": 10
  },
  {
    "id": 5216,
    "uuid": "388175f4-84e7-4e73-a4fc-65d046f01140",
    "hitokoto": "齐人三鼓之后，彼竭我盈之时。",
    "type": "d",
    "from": "曹刿论战",
    "from_who": null,
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583455716",
    "length": 14
  },
  {
    "id": 5217,
    "uuid": "6e5d087f-423a-49dd-86ad-e2453a0afcd8",
    "hitokoto": "使我有洛阳二顷田，安能佩六国相印。",
    "type": "d",
    "from": "苏秦",
    "from_who": null,
    "creator": "Kwokzc",
    "creator_uid": 5260,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583461682",
    "length": 17
  },
  {
    "id": 5218,
    "uuid": "e1ff5e24-42a0-487c-9f95-5ac150879522",
    "hitokoto": "无论走到哪里，都应该记住，过去都是假的，回忆是一条没有尽头的路，一切以往的春天都不复存在，就连那最坚韧而又狂乱的爱情归根结底也不过是一种转瞬即逝的现实。",
    "type": "d",
    "from": "百年孤独",
    "from_who": null,
    "creator": "Kwokzc",
    "creator_uid": 5260,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583461844",
    "length": 76
  },
  {
    "id": 5224,
    "uuid": "d058f3d0-ee3d-4fb9-aeac-19c14f6ab711",
    "hitokoto": "以雪案萤窗，换六月荣光。",
    "type": "d",
    "from": "网络",
    "from_who": null,
    "creator": "Aldrich",
    "creator_uid": 5178,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583720575",
    "length": 12
  },
  {
    "id": 5225,
    "uuid": "dc642737-8e45-432e-8729-7454f9affc98",
    "hitokoto": "人从来就想重写自己的会传记，改变过去，抹去痕迹，抹去自己的，也抹去别人的，想遗忘的远不是那么简单。",
    "type": "d",
    "from": "不能承受的生命之轻",
    "from_who": "米兰·昆德拉",
    "creator": "冰微尘@",
    "creator_uid": 5251,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583709057",
    "length": 49
  },
  {
    "id": 5227,
    "uuid": "cbd6b4a5-d054-4620-a7dd-0fb5771c6f3c",
    "hitokoto": "我们各自努力，最高处见！",
    "type": "d",
    "from": "网络",
    "from_who": null,
    "creator": "Aldrich",
    "creator_uid": 5178,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583720157",
    "length": 12
  },
  {
    "id": 5230,
    "uuid": "1fb9c41f-00c6-4de7-9757-be0f954b7532",
    "hitokoto": "生如夏花之绚烂，死如秋叶之静美。",
    "type": "d",
    "from": "飞鸟集",
    "from_who": null,
    "creator": "Aldrich",
    "creator_uid": 5178,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583720252",
    "length": 16
  },
  {
    "id": 5233,
    "uuid": "9504a2a2-bab7-4c7d-b643-a6642ed5c55e",
    "hitokoto": "人间没有单纯的快乐，快乐总夹带着烦恼和忧虑。",
    "type": "d",
    "from": "杨绛",
    "from_who": "我们仨",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583786494",
    "length": 22
  },
  {
    "id": 5236,
    "uuid": "8302ae15-e4ca-4033-94e3-5bc752efb4c4",
    "hitokoto": "原来这世上所有的一切都会失去，全是泡影。不论你多么想留住的东西，最终都会从你手上流走。",
    "type": "d",
    "from": "西游日记",
    "from_who": "今何在",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583786613",
    "length": 43
  },
  {
    "id": 5237,
    "uuid": "fc64c2a7-889a-4c88-a703-29a84a5c0a30",
    "hitokoto": "你跳不出这个世界，是因为你不知道这个世界有多大，一旦你知道了，你就超出了它。",
    "type": "d",
    "from": "悟空传",
    "from_who": "今何在",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583786665",
    "length": 38
  },
  {
    "id": 5239,
    "uuid": "f253f5e2-5218-4569-92e4-263d75dfe982",
    "hitokoto": "谁愿意做陨石，或受难者冰冷的塑像；看着不熄的青春之火，在别人的手中传递。",
    "type": "d",
    "from": "结局或开始——献给遇罗克",
    "from_who": "北岛",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583783159",
    "length": 36
  },
  {
    "id": 5242,
    "uuid": "2471d118-acee-434b-8784-feea996bccd9",
    "hitokoto": "广厦千间，夜眠仅需六尺；家财万贯，日食不过三餐。",
    "type": "d",
    "from": "增广贤文",
    "from_who": null,
    "creator": "白玉楼的白麻薯",
    "creator_uid": 5325,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583822444",
    "length": 24
  },
  {
    "id": 5250,
    "uuid": "80e951cb-534f-4545-b558-ca48fc5c1ecc",
    "hitokoto": "我知这世界，本如露水般短暂。然而，然而。",
    "type": "d",
    "from": "然而",
    "from_who": "小林一茶",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583852949",
    "length": 20
  },
  {
    "id": 5251,
    "uuid": "291cc928-8327-4b92-a397-ff810e655e46",
    "hitokoto": "希望我们都能像对方一样勇敢。",
    "type": "d",
    "from": "撒野",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583889672",
    "length": 14
  },
  {
    "id": 5253,
    "uuid": "2ffea546-f6e5-466a-aadc-8ea025a17672",
    "hitokoto": "尽管我们知道再无任何希望，我们仍然期待。等待稍稍一点动静，稍稍一点声响。",
    "type": "d",
    "from": "追忆似水年华",
    "from_who": "普鲁斯特",
    "creator": "Coral",
    "creator_uid": 5360,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583940878",
    "length": 36
  },
  {
    "id": 5254,
    "uuid": "7d527d29-74c5-4b27-97e4-cd884d083260",
    "hitokoto": "日子总是往前走，人总是在变，不知道是淡忘还是适应。",
    "type": "d",
    "from": "撒野",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583890039",
    "length": 25
  },
  {
    "id": 5255,
    "uuid": "1d537563-3705-446f-83ad-e03559d7e75a",
    "hitokoto": "愿中国青年都摆脱冷气，只是向上走，不必听自暴自弃者流的话。能做事的做事，能发声的发声。有一分热，发一分光。就令萤火一般，也可以在黑暗里发一点光，不必等候炬火。",
    "type": "d",
    "from": "热风",
    "from_who": null,
    "creator": "冰微尘@",
    "creator_uid": 5251,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583891248",
    "length": 79
  },
  {
    "id": 5256,
    "uuid": "87518a30-a0aa-4256-95be-eee6c845d87f",
    "hitokoto": "虎狼在外，不敢不殚精竭虑；山河未定，也不敢轻贱其身。",
    "type": "d",
    "from": "杀破狼",
    "from_who": "priest",
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583892767",
    "length": 26
  },
  {
    "id": 5257,
    "uuid": "50fb5429-1c21-4c6d-96c4-58c785edc97a",
    "hitokoto": "我连魂魄都是黑的，唯独心尖上一点点，血还是红的。用它护着你，我愿意。",
    "type": "d",
    "from": "镇魂",
    "from_who": "priest",
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893026",
    "length": 34
  },
  {
    "id": 5258,
    "uuid": "0673e589-72ee-4063-a7f3-242f4fc8e571",
    "hitokoto": "生不由己，不如不生。",
    "type": "d",
    "from": "镇魂",
    "from_who": "priest",
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893046",
    "length": 10
  },
  {
    "id": 5259,
    "uuid": "8621a1fa-e24a-431b-a99f-50814e1d79c6",
    "hitokoto": "我接住了，你这一辈子，生生死死、死死生生我都再不会松手，哪怕你有一天烦了、厌了、想走了，我也绝对不会放开你，就算勒，也要把你勒死在我怀里。",
    "type": "d",
    "from": "镇魂",
    "from_who": null,
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893079",
    "length": 69
  },
  {
    "id": 5260,
    "uuid": "38ce5b45-919b-47ba-b893-a680312e634d",
    "hitokoto": "我心里有一簇迎着烈日而生的花，比一切美酒都要芬芳，滚烫的馨香淹没过稻草人的胸膛，草扎的精神，从此万寿无疆。",
    "type": "d",
    "from": "默读",
    "from_who": "priest",
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893161",
    "length": 53
  },
  {
    "id": 5261,
    "uuid": "d8a0e95b-9106-491e-a709-7f477ef927e5",
    "hitokoto": "身在无间，心在桃源。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893384",
    "length": 10
  },
  {
    "id": 5262,
    "uuid": "151d393a-cea6-4236-80d0-5f7dc02b7bd2",
    "hitokoto": "为你，所向披靡。",
    "type": "d",
    "from": "天官赐福",
    "from_who": "墨香铜臭",
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893424",
    "length": 8
  },
  {
    "id": 5263,
    "uuid": "1dce82db-295c-4020-bb03-9e0ef7625b57",
    "hitokoto": "为你战死是我至高无上的荣耀。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893463",
    "length": 14
  },
  {
    "id": 5267,
    "uuid": "003def79-f904-49e4-ad59-84c3f8fdb738",
    "hitokoto": "世间情动，不过盛夏白瓷梅子汤，碎冰碰壁当啷响。",
    "type": "d",
    "from": "穆玄英挂帅",
    "from_who": null,
    "creator": "Coral",
    "creator_uid": 5360,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583941476",
    "length": 23
  },
  {
    "id": 5272,
    "uuid": "dd4631f7-02d5-4fb2-8c5a-7918aa319188",
    "hitokoto": "我会千里迢迢，披星戴月地赶来带你走，这一次换成我来保护你。",
    "type": "d",
    "from": "吞海",
    "from_who": "淮上",
    "creator": "立风.",
    "creator_uid": 5399,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584102189",
    "length": 29
  },
  {
    "id": 5277,
    "uuid": "313bb3a8-fbb7-4b7b-b34e-9a6972f923e8",
    "hitokoto": "一个人自以为刻骨铭心的回忆，别人也许早已经忘记了。",
    "type": "d",
    "from": "流波上的舞",
    "from_who": "张小娴",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584292274",
    "length": 25
  },
  {
    "id": 5280,
    "uuid": "ce8bbc45-4ce3-42b8-b206-f84f54257666",
    "hitokoto": "有些意外是意料之中，有些意外是意料之外，而你，就是我意料之外的意外。",
    "type": "d",
    "from": "撒野",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583889934",
    "length": 34
  },
  {
    "id": 5281,
    "uuid": "560f7cb9-55b6-4245-88d4-334bf964d228",
    "hitokoto": "我想，在你眼里，撒野奔跑；我想，一个眼神，就到老。",
    "type": "d",
    "from": "撒野",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583889782",
    "length": 25
  },
  {
    "id": 5282,
    "uuid": "c8cb7d11-2dd9-4b97-b0f1-78a45362e077",
    "hitokoto": "没有谁的生活会一直完美，但无论什么时候，都要看着前方，满怀希望就会所向披靡。",
    "type": "d",
    "from": "撒野",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583889706",
    "length": 38
  },
  {
    "id": 5283,
    "uuid": "7e6677e9-9224-4425-82ae-b84c569f8870",
    "hitokoto": "我愿供灯千盏，照彻长夜，即便飞蛾扑火，也无所畏惧。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583888828",
    "length": 25
  },
  {
    "id": 5284,
    "uuid": "b5a12be3-3620-4ac3-9d12-c663b984733c",
    "hitokoto": "如果你的梦想，是拯救苍生，那我的梦想，便唯你一人。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583888634",
    "length": 25
  },
  {
    "id": 5285,
    "uuid": "c89d7396-0223-4fd1-bb31-9a694f8f4ded",
    "hitokoto": "路好不好走，也许我不能决定，但走不走，却只有我能决定。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583888563",
    "length": 27
  },
  {
    "id": 5286,
    "uuid": "a464a1db-9a5f-4865-a9f5-b5f4f344de77",
    "hitokoto": "对我来说，风光无限的是你，跌落尘埃的也是你。重点是“你”，而不是“怎样”的你。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583888532",
    "length": 39
  },
  {
    "id": 5287,
    "uuid": "29ed4442-413f-44ca-9d7d-56ed184e67d2",
    "hitokoto": "美丽的东西存在于世上，这一点本身就值得感谢了。",
    "type": "d",
    "from": "天官赐福",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583888512",
    "length": 23
  },
  {
    "id": 5288,
    "uuid": "646be484-dc8c-4741-b7a1-50195d5748d2",
    "hitokoto": "自以为心若顽石，却终究人非草木。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583887943",
    "length": 16
  },
  {
    "id": 5290,
    "uuid": "38773377-50d7-45da-8c71-9eb84c4e8008",
    "hitokoto": "你要记着别人对你的好，不要去记你对别人的好。人心里不要装那么多东西，这样才会快活自在。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "仄言",
    "creator_uid": 5164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583887434",
    "length": 43
  },
  {
    "id": 5293,
    "uuid": "5937deee-2885-497b-8e6e-30a7e7e33c71",
    "hitokoto": "知识改变命运，可是没有告诉她，什么样的命运才算好。",
    "type": "d",
    "from": "这么多年",
    "from_who": "八月长安",
    "creator": "辞九",
    "creator_uid": 5415,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584178433",
    "length": 25
  },
  {
    "id": 5294,
    "uuid": "b76fbb68-27f8-4ed1-9752-bc871855a966",
    "hitokoto": "为你，千千万万遍。",
    "type": "d",
    "from": "追风筝的人",
    "from_who": null,
    "creator": "晚柠",
    "creator_uid": 5345,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584181606",
    "length": 9
  },
  {
    "id": 5295,
    "uuid": "edd2f861-4090-4377-a314-ebde18053adb",
    "hitokoto": "如果你认识从前的我，也许会原谅现在的我。",
    "type": "d",
    "from": "倾城之恋",
    "from_who": "张爱玲",
    "creator": "唐陌",
    "creator_uid": 5432,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584250202",
    "length": 20
  },
  {
    "id": 5297,
    "uuid": "91540a51-f8c0-4a2b-8957-b6bc5dac78c8",
    "hitokoto": "爱画的人天生就是寂寞的，因为他们总是企图在画中寻找自己向往的生命，可是却不明白，那些落在画上的色泽，早就已经死掉了。",
    "type": "d",
    "from": "左手倒影右手年华",
    "from_who": "郭敬明",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584291793",
    "length": 58
  },
  {
    "id": 5298,
    "uuid": "e4be4d74-3744-4cf0-ab62-ead4e7ec9d25",
    "hitokoto": "心中是寂然的轰鸣，像是某种巨大的坍塌。",
    "type": "d",
    "from": "幻城",
    "from_who": "郭敬明",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584291879",
    "length": 19
  },
  {
    "id": 5299,
    "uuid": "0ae43569-da6f-4d98-add9-edf940887574",
    "hitokoto": "献给徐徐多多的祭日。",
    "type": "d",
    "from": "挪威的森林",
    "from_who": "村上春树",
    "creator": "tgitc",
    "creator_uid": 3018,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584370068",
    "length": 10
  },
  {
    "id": 5300,
    "uuid": "9a8a7d9b-43b0-4c24-84de-b1c1894618c9",
    "hitokoto": "没有谁说过一生只能爱一个人，亦没有谁说过，重新开始是对过去的背叛。",
    "type": "d",
    "from": "你若安好 便是晴天",
    "from_who": "白落梅",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584492172",
    "length": 33
  },
  {
    "id": 5301,
    "uuid": "ea97b4a0-a68e-400b-8486-79b8ee467dac",
    "hitokoto": "停留是刹那，转身即天涯。",
    "type": "d",
    "from": "你若安好 便是晴天",
    "from_who": "白落梅",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584492281",
    "length": 12
  },
  {
    "id": 5303,
    "uuid": "49fbb0a8-71c8-42e6-9acd-78eeb647d194",
    "hitokoto": "嘤其鸣兮，求其友声。友声可远在千里之外，可远在数十百年之后。",
    "type": "d",
    "from": "我们仨",
    "from_who": "杨绛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584621615",
    "length": 30
  },
  {
    "id": 5304,
    "uuid": "9a5d61b2-9553-41a5-8396-62470011502c",
    "hitokoto": "世间好物不坚牢，彩云易散琉璃脆。",
    "type": "d",
    "from": "我们仨",
    "from_who": "杨绛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584621801",
    "length": 16
  },
  {
    "id": 5305,
    "uuid": "9f4b73a8-2d82-4482-ad66-640f9d5daa7f",
    "hitokoto": "人间也没有永远。我们一生坎坷，暮年才有了一个可以安顿的居处。但老病相催，我们在人生道路上已走到尽头了。",
    "type": "d",
    "from": "我们仨",
    "from_who": null,
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584621819",
    "length": 51
  },
  {
    "id": 5307,
    "uuid": "88ca8f8c-014b-4a20-9096-9bda992e42c6",
    "hitokoto": "梦想为劳，梦累了要梦魇的！",
    "type": "d",
    "from": "我们仨",
    "from_who": "杨绛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584621686",
    "length": 13
  },
  {
    "id": 5310,
    "uuid": "3882b9e3-94c7-433d-9ed7-322f62b05dd7",
    "hitokoto": "我去旅行，是因为我决定了要去，并不是因为对风景的兴趣。",
    "type": "d",
    "from": "霍乱时期的爱情",
    "from_who": "加西亚·马尔克斯",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584873657",
    "length": 27
  },
  {
    "id": 5313,
    "uuid": "50b860e1-f80d-4848-b37e-a5f62d7403e4",
    "hitokoto": "不以物喜，不以己悲。",
    "type": "d",
    "from": "岳阳楼记",
    "from_who": "范仲淹",
    "creator": "餘笙南吟丶",
    "creator_uid": 5582,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584948891",
    "length": 10
  },
  {
    "id": 5318,
    "uuid": "1979ee42-3ecd-4f38-9f99-8fefc8817f02",
    "hitokoto": "从今往后，彼此依赖，彼此知觉。彼此珍贵，彼此喜爱。",
    "type": "d",
    "from": "他们俩",
    "from_who": "TinSunset",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585292870",
    "length": 25
  },
  {
    "id": 5319,
    "uuid": "6f7d063c-3fe6-4d67-9976-63a62b7335a6",
    "hitokoto": "我孤注一掷的勇气，与无法预料的未来，统统交到了你手中。那从这一刻起，拜托你负责照料好手中紧握的我的一切。——我负责爱你和更加爱你。",
    "type": "d",
    "from": "他们俩",
    "from_who": "TinSunset",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585292846",
    "length": 65
  },
  {
    "id": 5320,
    "uuid": "0b27bd72-17b7-421b-afd5-7190b648bca5",
    "hitokoto": "他是终日不化的冰山，遇见极圈不落的骄阳。",
    "type": "d",
    "from": "他们俩",
    "from_who": "TinSunset",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585292796",
    "length": 20
  },
  {
    "id": 5322,
    "uuid": "6cdd38c1-c81e-4dc9-aefa-d00b105d612a",
    "hitokoto": "醉笑陪君三千场，不诉离殇。",
    "type": "d",
    "from": "清醒纪",
    "from_who": "安妮宝贝",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585365103",
    "length": 13
  },
  {
    "id": 5326,
    "uuid": "3d4c9f8a-c763-475c-b4c4-1b93003deb22",
    "hitokoto": "许多念念不忘，只是一瞬；许多一瞬，却是念念不忘。",
    "type": "d",
    "from": "海上灵光",
    "from_who": "许嵩",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585291186",
    "length": 24
  },
  {
    "id": 5329,
    "uuid": "24ef7472-270d-4805-a522-3fb586d0dce0",
    "hitokoto": "我爱你，你是我呼吸的城堡，如此轻柔，我们要天长地久。",
    "type": "d",
    "from": "布劳提根诗选",
    "from_who": "理查德·布劳提恩",
    "creator": "牛跡小四",
    "creator_uid": 5543,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584696728",
    "length": 26
  },
  {
    "id": 5330,
    "uuid": "1d1ca36f-f968-4ec6-bf83-01d9cf53f0b1",
    "hitokoto": "我希望你的头发，用新的世界地图，将我覆盖；那样，我所去之处，便会美如，你的头发。",
    "type": "d",
    "from": "布劳提根诗选",
    "from_who": "理查德 布劳提恩",
    "creator": "牛跡小四",
    "creator_uid": 5543,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584697057",
    "length": 40
  },
  {
    "id": 5331,
    "uuid": "7bd6e6ee-cfc1-49f5-85c8-f64ba95c10c2",
    "hitokoto": "太好了/在清晨醒来/一个人/不必在已经/不爱的时候/跟谁说/我爱你。",
    "type": "d",
    "from": "布劳提根诗选",
    "from_who": "理查德 布劳提恩",
    "creator": "牛跡小四",
    "creator_uid": 5543,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584697184",
    "length": 34
  },
  {
    "id": 5334,
    "uuid": "b0462ee5-90f5-4d27-a995-40d97d4a18d8",
    "hitokoto": "我们的时代还没到来，有的人死后方生。",
    "type": "d",
    "from": "在世纪的转折点上",
    "from_who": "尼采",
    "creator": "邵素",
    "creator_uid": 5570,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584852381",
    "length": 18
  },
  {
    "id": 5348,
    "uuid": "da5c6ae6-a66e-4649-aaf8-ea658912c6d4",
    "hitokoto": "吻就落在耳后，阻隔喧嚣缺口。",
    "type": "d",
    "from": "菱形月亮",
    "from_who": "南语",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585291507",
    "length": 14
  },
  {
    "id": 5349,
    "uuid": "0e418fc0-0472-44f1-831c-87e0aa2a39c4",
    "hitokoto": "万物皆有裂痕，那是光照进来的地方。",
    "type": "d",
    "from": "颂歌",
    "from_who": "莱昂纳德·科恩",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585292929",
    "length": 17
  },
  {
    "id": 5388,
    "uuid": "6c6658a6-42dd-42cc-b0c9-cd42c28225ea",
    "hitokoto": "以梦为马，以汗为泉；不忘初心 ，不负韶华。",
    "type": "d",
    "from": "以梦为马",
    "from_who": "海子",
    "creator": "筱君",
    "creator_uid": 5642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585244831",
    "length": 21
  },
  {
    "id": 5390,
    "uuid": "f1b5bea6-5466-4d73-90f9-2d6491a9197b",
    "hitokoto": "又能逃到哪里去，你我都各有困局。",
    "type": "d",
    "from": "寄世书",
    "from_who": "雲姑",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585291447",
    "length": 16
  },
  {
    "id": 5391,
    "uuid": "6ea16d72-33f7-45d4-ba4d-8b2ab7c78cfa",
    "hitokoto": "凡事都有偶然的凑巧，结果却又如宿命的必然。",
    "type": "d",
    "from": "边城",
    "from_who": "沈从文",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585293006",
    "length": 21
  },
  {
    "id": 5392,
    "uuid": "1a5b7ff6-2e3d-4e36-a169-be596aa28e4d",
    "hitokoto": "不善言辞的人连哭泣也不擅长，干燥的泥土贪婪的承接了他的泪水，一点一点深褐色的，又让人想到血。",
    "type": "d",
    "from": "墓园",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585365205",
    "length": 46
  },
  {
    "id": 5395,
    "uuid": "b408f89a-4423-46c4-94cf-8187f10bf22d",
    "hitokoto": "山河远阔，人间烟火，无一是你，无一不是你。",
    "type": "d",
    "from": "江海共余生",
    "from_who": null,
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585366338",
    "length": 21
  },
  {
    "id": 5397,
    "uuid": "5ecfb622-46f0-44cc-b6ac-32357d6bb9eb",
    "hitokoto": "理智在找食物，找衣服，找遮盖的时候很管用，理智是最好的工具箱。可是理智过了头你就可能把宇宙跟洗澡水一起放掉。",
    "type": "d",
    "from": "少年派的奇幻漂流",
    "from_who": "杨·马泰尔",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585385024",
    "length": 54
  },
  {
    "id": 5399,
    "uuid": "d5aa9b26-3735-45f6-af80-0cb876f82fb8",
    "hitokoto": "你错了，第十四人，你把投在湖面的倒影错当成了夜空的繁星。",
    "type": "d",
    "from": "猎魔人Ⅲ：精灵之血",
    "from_who": "威戈佛特兹",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585410921",
    "length": 28
  },
  {
    "id": 5403,
    "uuid": "6789d761-e460-4d77-9f3f-33078d6eb244",
    "hitokoto": "我还没来得及，还没来得及想：得到的却注定失去，还是一开始就不曾发出?",
    "type": "d",
    "from": "子不语",
    "from_who": "夏达",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585493594",
    "length": 34
  },
  {
    "id": 5407,
    "uuid": "fb639d64-44c4-45c9-82be-679729cb1c1b",
    "hitokoto": "大鹏一日同风起，扶摇直上九万里。",
    "type": "d",
    "from": "上李邕",
    "from_who": "李白",
    "creator": "今A",
    "creator_uid": 1611,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585650511",
    "length": 16
  },
  {
    "id": 5431,
    "uuid": "3a7b3a7e-66e0-4c7c-9e30-979f0170da3b",
    "hitokoto": "我们永远无法叫醒一个装睡的人 。",
    "type": "d",
    "from": "你永远都无法叫醒一个装睡的人",
    "from_who": "周濂",
    "creator": "Soiltary、K",
    "creator_uid": 3915,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585672808",
    "length": 16
  },
  {
    "id": 5433,
    "uuid": "5454a188-62d6-4584-bd77-de337a061ce7",
    "hitokoto": "你是比那更多的东西，希里。比那更多的东西。",
    "type": "d",
    "from": "猎魔人Ⅱ：命运之剑",
    "from_who": "杰洛特",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585884519",
    "length": 21
  },
  {
    "id": 5436,
    "uuid": "67a434a8-f0c6-460d-8fd2-253ad12edffc",
    "hitokoto": "再等一等，等我，来劈开冻住我们的冷。",
    "type": "d",
    "from": "勒内·夏尔诗选",
    "from_who": "勒内·夏尔",
    "creator": "七又",
    "creator_uid": 5784,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585987960",
    "length": 18
  },
  {
    "id": 5458,
    "uuid": "c285c9ac-61e1-4cb2-a2d5-d66b6d4ac58c",
    "hitokoto": "当夜幕降临，黑暗笼罩全身，在一片漆黑的路上独自前进，也许会感疲惫，也许会感胆怯，只要抬头仰望仍看的见夜空中闪烁的星光。那清澈的光辉必定会驻留在我们心中，给予我们持续朝目的地前进的勇气与力量。",
    "type": "d",
    "from": "文学少女",
    "from_who": "野村美月",
    "creator": "何叶",
    "creator_uid": 5724,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586056698",
    "length": 95
  },
  {
    "id": 5459,
    "uuid": "f70aad4e-463a-4f15-ad36-990d5b849ac0",
    "hitokoto": "庭有枇杷树，吾妻死之年所手植也，今已亭亭如盖矣。",
    "type": "d",
    "from": "项脊轩志",
    "from_who": "归有光",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585886288",
    "length": 24
  },
  {
    "id": 5493,
    "uuid": "c70acf82-cacf-4111-96fc-3f9548f61dba",
    "hitokoto": "往昔所造诸恶业，皆由无始贪嗔痴。从身语意之所生，一切我今皆忏悔。",
    "type": "d",
    "from": "大方广佛华严经",
    "from_who": null,
    "creator": "机智的狐狸菌",
    "creator_uid": 5198,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586243963",
    "length": 32
  },
  {
    "id": 5846,
    "uuid": "46b82921-e1ab-4209-a081-4628b233e490",
    "hitokoto": "在隆冬，我终于知道，我身上有一个不可战胜的夏天。",
    "type": "d",
    "from": "夏天集",
    "from_who": "加缪",
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586362372",
    "length": 24
  },
  {
    "id": 5847,
    "uuid": "d05f262f-f515-4d4d-8ceb-8949202b6a14",
    "hitokoto": "不快乐是一片需要英雄的大陆。",
    "type": "d",
    "from": "浮士德",
    "from_who": "歌德",
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586362553",
    "length": 14
  },
  {
    "id": 5956,
    "uuid": "5a42c7a9-cc3f-4c41-a7e2-187a2c3936b4",
    "hitokoto": "来源于噩梦，却是迷人的。",
    "type": "d",
    "from": "网络",
    "from_who": "流光印记",
    "creator": "流光印记",
    "creator_uid": 5586,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1586339855",
    "length": 12
  },
  {
    "id": 5957,
    "uuid": "5d259d21-d500-474e-afb9-fb8e818920f6",
    "hitokoto": "人类充满了谎言，我又怎能独善其身",
    "type": "d",
    "from": "流光印记",
    "from_who": "南枝",
    "creator": "流光印记",
    "creator_uid": 5586,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1586339906",
    "length": 16
  },
  {
    "id": 5965,
    "uuid": "fa1c24e2-eff0-4fb6-92dc-6cf6ea51b03d",
    "hitokoto": "何人知我霜雪催，何人与我共一醉。",
    "type": "d",
    "from": "杀破狼",
    "from_who": "Priest",
    "creator": "山崎卉熹",
    "creator_uid": 5942,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587125462",
    "length": 16
  },
  {
    "id": 5969,
    "uuid": "bf9383ce-bfd5-47d1-91e9-66ec2410a3e9",
    "hitokoto": "这个世界，很多人，很多事，我们都会忘记，唯一不忘的，是我们曾经的过去。",
    "type": "d",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587181422",
    "length": 35
  },
  {
    "id": 5970,
    "uuid": "3f0db778-aa77-436d-badf-0811ae439773",
    "hitokoto": "这世界的担子太重了，不是一个人可以担负得起的；这世上的悲哀太多了，不是一颗心可以承受的。",
    "type": "d",
    "from": "年轻的国王",
    "from_who": "奥斯卡·王尔德",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587381756",
    "length": 44
  },
  {
    "id": 5973,
    "uuid": "79481c77-d375-4080-99f6-7bd34b2ce34f",
    "hitokoto": "在涉及神明的问题上，你接触的越多，就越偏离人类，了解的越多就越靠近神明。",
    "type": "d",
    "from": "黎明之剑",
    "from_who": null,
    "creator": "流光印记",
    "creator_uid": 5586,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587488530",
    "length": 36
  },
  {
    "id": 5979,
    "uuid": "97d31136-f99e-4789-bf2b-3ae6740a9594",
    "hitokoto": "一旦有一天我不得不长久地离开它，我会怎样想念它，我会怎样想念它并且梦见它，我会怎样因为不敢想念它而梦也梦不到它。",
    "type": "d",
    "from": "我与地坛",
    "from_who": "史铁生",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588164237",
    "length": 56
  },
  {
    "id": 5981,
    "uuid": "daabad0b-a246-4f2f-a151-4231e1e29a25",
    "hitokoto": "然而，在那些日子里，春天最后总是来临，但是使人心惊的是它差一点来不了。",
    "type": "d",
    "from": "流动的盛宴",
    "from_who": "厄内斯特·海明威",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588164513",
    "length": 35
  },
  {
    "id": 6003,
    "uuid": "db4fe009-23dc-417e-80a3-4b9cb5ff0763",
    "hitokoto": "我怎么会知道，这些牡蛎产自哪个海岸呢？",
    "type": "d",
    "from": "猎魔人Ⅴ：火之洗礼",
    "from_who": "安德烈·斯帕克沃斯基",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586482703",
    "length": 19
  },
  {
    "id": 6006,
    "uuid": "811db294-ec8e-421d-a526-e8c1b11e1698",
    "hitokoto": "那时，我还没有懂得人性是如何的矛盾，我不知道真诚中有多少做作，高贵中有多少卑鄙，或者，邪恶中有多少善良。如今我是充分懂得了，小气与大方、怨怼与仁慈、憎恨与热爱，是可以并存于同一颗心的。",
    "type": "d",
    "from": "月亮与六便士",
    "from_who": "毛姆",
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586776694",
    "length": 92
  },
  {
    "id": 6013,
    "uuid": "d29078ee-15b2-46fd-b592-f17953293539",
    "hitokoto": "把别人的经验变成自己的，他的本事就大了。",
    "type": "d",
    "from": "毛主席语录",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586611889",
    "length": 20
  },
  {
    "id": 6014,
    "uuid": "c7814f51-7794-4a01-b128-f19e786c1b41",
    "hitokoto": "高贵者最愚蠢，卑贱者最聪明！",
    "type": "d",
    "from": "毛泽东",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586611983",
    "length": 14
  },
  {
    "id": 6022,
    "uuid": "1d34522b-6117-4f7d-bc3b-87ef88d50869",
    "hitokoto": "宇宙很大，生活更大，也许以后还有缘相见。",
    "type": "d",
    "from": "三体",
    "from_who": "智子",
    "creator": "chunbingge",
    "creator_uid": 6177,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1589109595",
    "length": 20
  },
  {
    "id": 6031,
    "uuid": "dc394325-d219-45b5-82b0-bb47d7d92e16",
    "hitokoto": "In every dream I am lonely and desperate.If only I could find him,I think, we could go home together.",
    "type": "d",
    "from": "我们仨（英文版）",
    "from_who": "杨绛",
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586939867",
    "length": 101
  },
  {
    "id": 6035,
    "uuid": "1f75fe27-ea80-4114-9054-79895d24d376",
    "hitokoto": "我怎么会知道，这些牡蛎产自哪个海岸呢？",
    "type": "d",
    "from": "猎魔人Ⅴ：火之洗礼",
    "from_who": "薇歌",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587083845",
    "length": 19
  },
  {
    "id": 6040,
    "uuid": "0dedaf19-da35-47ad-96a0-f416c14b565c",
    "hitokoto": "所爱隔山海，山海不可平。",
    "type": "d",
    "from": "无题",
    "from_who": "littlesen",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587260225",
    "length": 12
  },
  {
    "id": 6042,
    "uuid": "a348581a-6be7-4a75-888d-5c7b0ec2ff5e",
    "hitokoto": "不要走在我的前面，因为我可能跟不上你；也不要走在我的后面，因为我可能不会引路；请走在我的身边，做我的朋友。",
    "type": "d",
    "from": "秋是第二个春",
    "from_who": "阿尔贝·加缪",
    "creator": "溟YX",
    "creator_uid": 5965,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587346092",
    "length": 53
  },
  {
    "id": 6043,
    "uuid": "29033fa3-e03a-47d6-a98f-bb1eb4384d6b",
    "hitokoto": "信仰如锁，凡人在这头，神明在另一头。",
    "type": "d",
    "from": "黎明之剑",
    "from_who": "远瞳",
    "creator": "流光印记",
    "creator_uid": 5586,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587488562",
    "length": 18
  },
  {
    "id": 6044,
    "uuid": "ca3383d1-3873-4518-88af-5aeb7b4c3a9d",
    "hitokoto": "胸中有丘壑，眉目作山河。胸中有丘壑，眼里存山河。",
    "type": "d",
    "from": "你才是自己的过来人",
    "from_who": "李爱玲",
    "creator": "你听我说",
    "creator_uid": 5994,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587513273",
    "length": 24
  },
  {
    "id": 6051,
    "uuid": "06c1d3db-91de-4ae5-9d43-7e36b1fbff28",
    "hitokoto": "在天愿作比翼鸟，在地愿为连理枝。天长地久有时尽，此恨绵绵无绝期。",
    "type": "d",
    "from": "长恨歌",
    "from_who": "白居易",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587538743",
    "length": 32
  },
  {
    "id": 6067,
    "uuid": "33a9b9ea-1ad9-45a3-aa5a-3c0d3957f8b3",
    "hitokoto": "草原大得孤独，白云美得忧愁，我不知道是不是碰到了最好的马，也许我还没有走遍草原。",
    "type": "d",
    "from": "洗澡",
    "from_who": "阿城",
    "creator": "破晓之雪",
    "creator_uid": 5882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587948818",
    "length": 40
  },
  {
    "id": 6076,
    "uuid": "e6fa185c-bbe3-47ed-9614-79d61dbd4b01",
    "hitokoto": "知道各位都是不要命的，我们也是冲不要命来的。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588064058",
    "length": 22
  },
  {
    "id": 6077,
    "uuid": "5cc9238e-585a-412a-84d1-ed46de678cd3",
    "hitokoto": "我点燃了火，却控制不了它。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588064100",
    "length": 13
  },
  {
    "id": 6078,
    "uuid": "5eed7e4c-8b29-4792-9c6c-94f5cd070f00",
    "hitokoto": "虫子从来就没有真正被战胜过。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588064143",
    "length": 14
  },
  {
    "id": 6079,
    "uuid": "fb040842-889b-4a9c-85f8-ba8b8d4a0531",
    "hitokoto": "没有了对高处的恐惧，就体会不到高处之美。",
    "type": "d",
    "from": "三体II·黑暗森林",
    "from_who": "刘慈欣",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588064194",
    "length": 20
  },
  {
    "id": 6080,
    "uuid": "a5c24742-341d-43f6-842c-5bf2b6e121de",
    "hitokoto": "什么样的人都有，包括完美的人和完美的女人，只是你无缘遇到。",
    "type": "d",
    "from": "三体II·黑暗森林",
    "from_who": "刘慈欣",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588064253",
    "length": 29
  },
  {
    "id": 6086,
    "uuid": "a384ab33-15bf-49d4-b89f-625999599f0a",
    "hitokoto": "虚空，孤寂。",
    "type": "d",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588331053",
    "length": 6
  },
  {
    "id": 6089,
    "uuid": "ca9ab1f2-4c8f-4c59-ae68-5c2c036616c4",
    "hitokoto": "拼命对一个人好，生怕做错一点对方就不喜欢你，这不是爱，是取悦。",
    "type": "d",
    "from": "卡耐基",
    "from_who": null,
    "creator": "xiaoz",
    "creator_uid": 6104,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588496832",
    "length": 31
  },
  {
    "id": 6095,
    "uuid": "63b2e48b-3dd3-49d0-bdac-175b3cf92644",
    "hitokoto": "勇者愤怒，抽刃向更强者；怯者愤怒，却抽刃向更弱者。",
    "type": "d",
    "from": "华盖集·杂感",
    "from_who": "鲁迅",
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590306373",
    "length": 25
  },
  {
    "id": 6096,
    "uuid": "26686d77-9517-4a12-ab54-b7a06a201ae4",
    "hitokoto": "终此一生，只有两种办法：要么梦见生活，要么落实生活。",
    "type": "d",
    "from": "勒内·夏尔",
    "from_who": null,
    "creator": "stydxm",
    "creator_uid": 6251,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590287820",
    "length": 26
  },
  {
    "id": 6097,
    "uuid": "d7914610-3b7d-4b21-b8aa-85c2b5646d23",
    "hitokoto": "明月装饰了你的窗子，你装饰了别人的梦。",
    "type": "d",
    "from": "断章",
    "from_who": "卞之琳",
    "creator": "LemonPig",
    "creator_uid": 6267,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590196041",
    "length": 19
  },
  {
    "id": 6100,
    "uuid": "cc58124d-5ba8-450e-8c9f-114ce133bdc3",
    "hitokoto": "斩尽杀绝，这是对一个文明最高的重视。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "~灿若繁星~",
    "creator_uid": 6249,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589952285",
    "length": 18
  },
  {
    "id": 6109,
    "uuid": "ed656909-a276-4349-907f-56812627796b",
    "hitokoto": "此后如竟没有炬火，我便是唯一的光。",
    "type": "d",
    "from": "热风",
    "from_who": "鲁迅",
    "creator": "匕田",
    "creator_uid": 6110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588511838",
    "length": 17
  },
  {
    "id": 6115,
    "uuid": "0efc2712-bff9-4d7d-87f8-b2e6eaa7dc59",
    "hitokoto": "一个半真半假的谣言，远比一个彻头彻尾的谣言厉害。谣言中最毒的配方，莫过于绝大部分真实中只有一小处虚假，而这个小处却关及人品。",
    "type": "d",
    "from": "余秋雨",
    "from_who": null,
    "creator": "梦逍遥",
    "creator_uid": 4596,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588595743",
    "length": 62
  },
  {
    "id": 6116,
    "uuid": "4ab4976a-0405-4222-a631-33dbfa815d4e",
    "hitokoto": "当我无牵无挂的时候，贫穷对我来说只是晚上吃馒头和吃牛排的区别，无损我的快乐，可当我爱上一个姑娘的时候，我才深深的感受到了什么是贫穷所带来的自卑。枕头里期满了发了霉的梦，梦里住满了无法拥有的人。",
    "type": "d",
    "from": "在人间凑数的日子",
    "from_who": "皮皮虾网友",
    "creator": "xiaoz",
    "creator_uid": 6104,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588497322",
    "length": 96
  },
  {
    "id": 6117,
    "uuid": "9854f5b1-54b6-4f8b-8c84-ce292cfefbc0",
    "hitokoto": "一定要爱这点什么，恰似草木对光阴的柔情。",
    "type": "d",
    "from": "人间草木",
    "from_who": "汪曾祺",
    "creator": "Monique",
    "creator_uid": 6109,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588510460",
    "length": 20
  },
  {
    "id": 6119,
    "uuid": "4fa71a3b-4aa7-431c-9ec3-30a910502a15",
    "hitokoto": "两千三百一十二天，他们相遇在寒风朔雪中。以为是初见，其实是重逢。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "水夕是汐",
    "creator_uid": 6127,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588668243",
    "length": 32
  },
  {
    "id": 6120,
    "uuid": "3afadd51-0b6d-4667-b99f-94cb5b9adfa0",
    "hitokoto": "亲爱的，我把自己放在你耳边，你会听到的吧。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "水夕是汐",
    "creator_uid": 6127,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588668295",
    "length": 21
  },
  {
    "id": 6121,
    "uuid": "d2395dc3-080d-4e00-9996-dd7e53fa4954",
    "hitokoto": "所以说爱恨真是奇怪的东西，有的早早腐烂入土，有的刻骨。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "水夕是汐",
    "creator_uid": 6127,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588668325",
    "length": 27
  },
  {
    "id": 6122,
    "uuid": "9e5cdd32-6b71-4e87-9dc9-66fbac428643",
    "hitokoto": "只有身处暖春，才会怕冷。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "水夕是汐",
    "creator_uid": 6127,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588668474",
    "length": 12
  },
  {
    "id": 6123,
    "uuid": "4d482876-49b5-47e0-be87-20a9f1ec4ef8",
    "hitokoto": "怪物之所以是怪物，不是因为做了什么，而是它为什么做。",
    "type": "d",
    "from": "全球高考",
    "from_who": "木苏里",
    "creator": "水夕是汐",
    "creator_uid": 6127,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588668500",
    "length": 26
  },
  {
    "id": 6132,
    "uuid": "d1489852-fb9c-479b-aafe-02f794916628",
    "hitokoto": "喜欢一个人，始于颜值，陷于才华，忠于人品，痴于肉体， 迷于声音，醉于深情。",
    "type": "d",
    "from": "喜欢一个人",
    "from_who": "吴桂君",
    "creator": "独孤2020",
    "creator_uid": 6304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591776919",
    "length": 37
  },
  {
    "id": 6140,
    "uuid": "a28adbfb-a305-4d65-8b2f-bee758795cbe",
    "hitokoto": "愿中国青年都摆脱冷气，只是向上走，不必听自暴自弃者的话……",
    "type": "d",
    "from": "新青年",
    "from_who": "鲁迅",
    "creator": "穷枫",
    "creator_uid": 6405,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591432156",
    "length": 29
  },
  {
    "id": 6141,
    "uuid": "d74d4b24-b4b5-41cc-b9ff-d6743f30b0ff",
    "hitokoto": "书上说，天下没有不散的筵席；不要怕，书上还说了，人生何处不相逢。",
    "type": "d",
    "from": "雪中悍刀行",
    "from_who": "烽火戏诸侯",
    "creator": "Vae",
    "creator_uid": 6401,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591422811",
    "length": 32
  },
  {
    "id": 6150,
    "uuid": "377f0760-d935-4527-a91c-d9085fcf20df",
    "hitokoto": "七情拆解，无非心印；六欲所指，皆由心生。",
    "type": "d",
    "from": "我师兄实在太稳健了",
    "from_who": "言归正传",
    "creator": "青面灵圣",
    "creator_uid": 5873,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589277169",
    "length": 20
  },
  {
    "id": 6156,
    "uuid": "eb766eef-9833-4ef3-a356-210d0da0ed0d",
    "hitokoto": "愿你出走半生，归来仍是少年。",
    "type": "d",
    "from": "愿你出走半生，归来仍是少年",
    "from_who": "孙衍",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589356208",
    "length": 14
  },
  {
    "id": 6160,
    "uuid": "6f73d273-53ec-45d6-8d1d-d677534f102a",
    "hitokoto": "若批评不自由，则赞美无意义。",
    "type": "d",
    "from": "费加罗的婚礼",
    "from_who": "博马舍",
    "creator": "怀表小兔",
    "creator_uid": 6212,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589440601",
    "length": 14
  },
  {
    "id": 6164,
    "uuid": "5e4b688d-6d6d-41b9-9e70-e205f53d7ec0",
    "hitokoto": "恋情未露人已知，本欲独自暗相思。",
    "type": "d",
    "from": "阴阳师",
    "from_who": "梦枕貘",
    "creator": "thyhates",
    "creator_uid": 6218,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589534998",
    "length": 16
  },
  {
    "id": 6167,
    "uuid": "882bada7-5d49-47ae-aa69-ebec4fe9cb60",
    "hitokoto": "所见即所得，所想及所见。",
    "type": "d",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589635253",
    "length": 12
  },
  {
    "id": 6170,
    "uuid": "4f2e4f4b-1e2c-49ba-97ac-c39f5731a3b3",
    "hitokoto": "生而为人，我很抱歉！",
    "type": "d",
    "from": "人间失格",
    "from_who": "太宰治",
    "creator": "木兮",
    "creator_uid": 6232,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589774922",
    "length": 10
  },
  {
    "id": 6176,
    "uuid": "a87463d3-c4de-49f4-afe0-2a049e026051",
    "hitokoto": "没有谁的生活会一直完美，但无论什么时候，都要看着前方，满怀希望就会所向披靡。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "~灿若繁星~",
    "creator_uid": 6249,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589951443",
    "length": 38
  },
  {
    "id": 6178,
    "uuid": "c6bbaf56-41da-49f6-b5b5-ce08cd86fb37",
    "hitokoto": "哪有什么岁月静好，只是有人在替你负重前行。",
    "type": "d",
    "from": "哪有什么岁月静好，不过是有人替你负重前行",
    "from_who": "苏心",
    "creator": "stydxm",
    "creator_uid": 6251,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589983944",
    "length": 21
  },
  {
    "id": 6184,
    "uuid": "583b41d2-8361-4256-be89-308a7b143693",
    "hitokoto": "God said: Let there be light.",
    "type": "d",
    "from": "Holy Bible",
    "from_who": null,
    "creator": "CerberusX",
    "creator_uid": 6287,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590378057",
    "length": 29
  },
  {
    "id": 6211,
    "uuid": "0dec0cee-180e-444c-8e3e-8eb24bdd4c50",
    "hitokoto": "我更喜欢晚霞，晚霞消失后可以看星星，朝霞消失后，就只剩下光天化日下的现实了。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590670974",
    "length": 38
  },
  {
    "id": 6253,
    "uuid": "a7ce2cfd-6022-467b-b4e9-a9c36bd94a99",
    "hitokoto": "故事不长，也不难讲，脸红相遇，红眼而离。",
    "type": "d",
    "from": "我在人间凑数的日子",
    "from_who": null,
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591705211",
    "length": 20
  },
  {
    "id": 6254,
    "uuid": "2e7c867d-404c-495e-805f-a67905aa60b3",
    "hitokoto": "秃顶这个词也太伤人了，不如叫“年少荒芜”，带着一股孤独而忧伤的文学气息，可以说是精神上的美发了。",
    "type": "d",
    "from": "微博",
    "from_who": "山口姨太",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592154190",
    "length": 48
  },
  {
    "id": 6258,
    "uuid": "d5f4a8cd-d1d5-4df6-84fb-afe3d76808ff",
    "hitokoto": "云破星出之夜，我对星低喃：吞噬我。",
    "type": "d",
    "from": "弗吉尼亚·伍尔芙",
    "from_who": "海浪",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592126088",
    "length": 17
  },
  {
    "id": 6263,
    "uuid": "c1669e17-8622-4ec3-8ea5-9c4a3dc0bede",
    "hitokoto": "我真想告诫所有长大了的男孩子，千万不要跟母亲来这套倔强，羞涩就更不必，我已经懂了可我已经来不及了。",
    "type": "d",
    "from": "我与地坛",
    "from_who": "史铁生",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592125130",
    "length": 49
  },
  {
    "id": 6264,
    "uuid": "de9ae67c-2c2c-45c3-9eef-61c4f866f365",
    "hitokoto": "还可以想象一对热恋中的情人，互相一次次说“我一刻也不想离开你”，又互相一次次说“时间已经不早了”，时间不早了可我一刻也不想离开你，一刻也不想离开你可时间毕竟是不早了。",
    "type": "d",
    "from": "我与地坛",
    "from_who": "史铁生",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592125040",
    "length": 83
  },
  {
    "id": 6267,
    "uuid": "39ed1d38-5daa-4b62-a96c-baf952b03c2b",
    "hitokoto": "这些突兀地出现在荒野中的草棚麦垛，绊住了风的腿，扯住了风的衣裳，缠住了风的头发，让它追不上前面的风。她撕扯，哭喊。喊得满天地都是风声。",
    "type": "d",
    "from": "一个人的村庄",
    "from_who": "刘亮程",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592124619",
    "length": 67
  },
  {
    "id": 6281,
    "uuid": "74e0dcd5-f5e1-48d6-bb58-f423a48bcfc0",
    "hitokoto": "沧海横流，方显英雄本色。",
    "type": "d",
    "from": "满江红·一九六三年元旦书怀",
    "from_who": "郭沫若",
    "creator": "LemonPig",
    "creator_uid": 6267,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1593061851",
    "length": 12
  },
  {
    "id": 6283,
    "uuid": "d00713de-91cf-4c42-b0a6-79a035abdad4",
    "hitokoto": "既然选择了远方，便只顾风雨兼程。",
    "type": "d",
    "from": "热爱生命",
    "from_who": "汪国真",
    "creator": "陈默",
    "creator_uid": 2334,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592290834",
    "length": 16
  },
  {
    "id": 6286,
    "uuid": "a1cd7c19-c607-489a-ac59-826271f5abdd",
    "hitokoto": "我一生恶事做，轻易许愿只怕没有神明会眷顾，只好亲自为你点了一万盏灯，每点一盏心中默念一句南无阿弥陀佛，上有九天神明下有阴间官判，天可怜见，能算我心诚了么？",
    "type": "d",
    "from": "暴君",
    "from_who": "漫漫何其多",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592396639",
    "length": 77
  },
  {
    "id": 6287,
    "uuid": "e660a1d0-a955-4da0-a877-b782db2c5b19",
    "hitokoto": "年长者最大的修养就是控制住批评年轻人的欲望。",
    "type": "d",
    "from": "月亮与六便士",
    "from_who": "毛姆",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592396811",
    "length": 22
  },
  {
    "id": 6292,
    "uuid": "099ac550-f121-4377-bd28-ec44ffdab22b",
    "hitokoto": "每个人都会对未知充满恐惧，因为未知代表着你不知道以自己的能力是否能够应对。",
    "type": "d",
    "from": "渡魂实录",
    "from_who": "余连方",
    "creator": "xuj",
    "creator_uid": 6496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592528521",
    "length": 37
  },
  {
    "id": 6298,
    "uuid": "43b747db-5a2b-4727-b633-68019eabc29b",
    "hitokoto": "幸亏时光不会倒流，否则万物一定会朝旧岁月里疾步奔跑。",
    "type": "d",
    "from": "迷楼",
    "from_who": "刘以鬯",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592578507",
    "length": 26
  },
  {
    "id": 6299,
    "uuid": "fbc2fdf9-122f-470c-8232-7921558b7761",
    "hitokoto": "怕什么，既然许你朝暮，我岂敢不命长？",
    "type": "d",
    "from": "这个锅我背了",
    "from_who": "三千大梦叙平生",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592710401",
    "length": 18
  },
  {
    "id": 6300,
    "uuid": "34d37904-0d9c-4d92-9a50-1f85d84b82d8",
    "hitokoto": "这是他替你起的名字，执掌江山，定波安澜，他会看着你。",
    "type": "d",
    "from": "这个锅我背了",
    "from_who": "三千大梦叙平生",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592710427",
    "length": 26
  },
  {
    "id": 6301,
    "uuid": "95b4bf24-cf76-4d64-908b-fac0df85ed57",
    "hitokoto": "长廊里，清雅如竹的少年眉眼温润含笑，稳稳牵起幼童的手。走过刀光剑影，走过血雨腥风，走过被暗影分割的暖阳，往前不急不缓地走去。走不到头。",
    "type": "d",
    "from": "这个锅我背了",
    "from_who": "三千大梦叙平生",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592710455",
    "length": 67
  },
  {
    "id": 6302,
    "uuid": "ab645585-2a1d-4968-9250-691c8a9fe916",
    "hitokoto": "纵马而已，何必认路？",
    "type": "d",
    "from": "这个锅我背了",
    "from_who": "三千大梦叙平生",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592710565",
    "length": 10
  },
  {
    "id": 6308,
    "uuid": "12542b45-ee9c-4253-84ce-d016c9c6fc8a",
    "hitokoto": "乾坤琉璃色，碧宇凝清光。",
    "type": "d",
    "from": "这个锅我背了",
    "from_who": "三千大梦叙平生",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592710590",
    "length": 12
  },
  {
    "id": 6311,
    "uuid": "83998978-28a5-4982-91fd-8671fd1e1865",
    "hitokoto": "已有之事后必再有，已行之事后必再行。",
    "type": "d",
    "from": "圣经·传道书",
    "from_who": "所罗门",
    "creator": "envy",
    "creator_uid": 6526,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592896827",
    "length": 18
  },
  {
    "id": 6326,
    "uuid": "51f4c20c-fce3-41fc-9c92-e5ec0f5ec26b",
    "hitokoto": "我和谁都不争，和谁争我都不屑。我的双手烤着生命之火取暖，火萎了，我也准备走了。",
    "type": "d",
    "from": "生与死",
    "from_who": "兰德",
    "creator": "沈时筠",
    "creator_uid": 6568,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593238398",
    "length": 39
  },
  {
    "id": 6327,
    "uuid": "a6120d3c-6357-4ae8-8429-ea436da79380",
    "hitokoto": "我跳进深渊，也不曾听到他的姓名。或许他并不是我想象中的魔鬼，但我坚信他也一定不是什么天使。",
    "type": "d",
    "from": "罪犯请沉默",
    "from_who": "迷羔羊",
    "creator": "AMU",
    "creator_uid": 6407,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593243080",
    "length": 45
  },
  {
    "id": 6330,
    "uuid": "038eee24-df5f-47fd-8dad-89cc5818efef",
    "hitokoto": "我公开把自己的心献给沉重而苦难的大地，常常在神圣的夜晚向大地承诺忠诚的爱，至死不渝。",
    "type": "d",
    "from": "恩培多克勒之死",
    "from_who": "Der Tod des Empedokles",
    "creator": "朏之长生者",
    "creator_uid": 6574,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593261018",
    "length": 42
  },
  {
    "id": 6336,
    "uuid": "1077db0d-130a-4469-8cde-ff94792d0b20",
    "hitokoto": "我们哭着降临世界，却可以笑着走向永恒。",
    "type": "d",
    "from": "如果国宝会说话",
    "from_who": "如果国宝会说话",
    "creator": "AST_hong",
    "creator_uid": 6577,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593264949",
    "length": 19
  },
  {
    "id": 6345,
    "uuid": "73406fbb-328f-48a0-bab9-41501dd04e0b",
    "hitokoto": "我不敢下苦功琢磨自己，怕终于知道自己并非珠玉；然而心中又存着一丝希冀，便又不肯甘心与瓦砾为伍。",
    "type": "d",
    "from": "山月记",
    "from_who": "中岛敦",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593543153",
    "length": 47
  },
  {
    "id": 6346,
    "uuid": "655378b7-4c4e-469a-803e-4a65fc1aba56",
    "hitokoto": "前天，我看见一只兔子；昨天，我看见一只鹿；而今天，我看见你。",
    "type": "d",
    "from": "蒲公英女孩",
    "from_who": "罗伯特",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593543319",
    "length": 30
  },
  {
    "id": 6366,
    "uuid": "b8b6c3dd-8420-411e-be1c-b16be893c4ef",
    "hitokoto": "年轻时，我们什么都听不进去，只顾满怀希望地朝未来前进。“未来”是骗人的，它让人以为那是永恒的旅行。可是生命一眨眼就结束了，毫无意义。生命没有未来，只充满着过去。",
    "type": "d",
    "from": "被偷走的人",
    "from_who": "提埃里·科恩",
    "creator": "chilam",
    "creator_uid": 6424,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594221209",
    "length": 80
  },
  {
    "id": 6372,
    "uuid": "1ec2929e-89ac-42b2-b371-5d7cdb21a958",
    "hitokoto": "既没有长亭外古道边，也没有劝君更尽一杯酒，我们还想着来日方长呢，却见完了此生最后一面。",
    "type": "d",
    "from": "拾遗",
    "from_who": null,
    "creator": "机智的狐狸菌",
    "creator_uid": 5198,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594615742",
    "length": 43
  },
  {
    "id": 6376,
    "uuid": "6d754630-928f-4f21-9e64-b742488165c2",
    "hitokoto": "永远不要让自己被自己所更愿意相信的、或者认为人们相信了、会对社会更加有益的东西所影响。只是单单地去审视，什么才是事实。",
    "type": "d",
    "from": "罗素给后人的留言",
    "from_who": "罗素",
    "creator": "chilam",
    "creator_uid": 6424,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594223996",
    "length": 59
  },
  {
    "id": 6377,
    "uuid": "968d5b7c-4058-4c5a-9fc0-cb5dd7bc2b9e",
    "hitokoto": "心有猛虎，细嗅蔷薇。",
    "type": "d",
    "from": "In me, past, present, future meet",
    "from_who": "Siegfried Sassoon",
    "creator": "Vaine0",
    "creator_uid": 6260,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594692755",
    "length": 10
  },
  {
    "id": 6380,
    "uuid": "f9953f5f-2fe8-445b-8911-5b8aa7b4be77",
    "hitokoto": "整个艺术发展史不是技术熟练程度的发展史，而是观念和要求的变化史。",
    "type": "d",
    "from": "艺术的故事",
    "from_who": "贡布里希",
    "creator": "kuzan",
    "creator_uid": 6749,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1595233477",
    "length": 32
  },
  {
    "id": 6387,
    "uuid": "14f927d3-568b-4cba-bc3c-105625bb4838",
    "hitokoto": "邓林之阴初见昆仑君，惊鸿一瞥，乱我心曲。",
    "type": "d",
    "from": "镇魂",
    "from_who": "priest",
    "creator": "晚宁是我的",
    "creator_uid": 6787,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595570698",
    "length": 20
  },
  {
    "id": 6388,
    "uuid": "89979a8a-9c2b-43ae-a662-44ceb3a509cf",
    "hitokoto": "人这一辈子有四件事不能太执着，一是长久，二是是非，三是善恶，四是生死。",
    "type": "d",
    "from": "镇魂",
    "from_who": "priest",
    "creator": "晚宁是我的",
    "creator_uid": 6787,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595570430",
    "length": 35
  },
  {
    "id": 6389,
    "uuid": "ebe1b139-c697-4bdb-9cbc-1cf881c2a902",
    "hitokoto": "长阶血未尽，那是他带你回家的路。",
    "type": "d",
    "from": "二哈和他的白猫师尊",
    "from_who": "肉包不吃肉",
    "creator": "晚宁是我的",
    "creator_uid": 6787,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595570500",
    "length": 16
  },
  {
    "id": 6399,
    "uuid": "e3f8e4de-a64e-4f25-b3b7-1766cfbb6e62",
    "hitokoto": "为你，千千万万遍。",
    "type": "d",
    "from": "追风筝的人",
    "from_who": "卡勒德·胡塞尼",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596109296",
    "length": 9
  },
  {
    "id": 6400,
    "uuid": "00414789-20bf-4f77-8e0e-c26fa0f1d12a",
    "hitokoto": "深情隐现眉宇间，他人已知我相思。",
    "type": "d",
    "from": "阴阳师",
    "from_who": "梦枕貘",
    "creator": "thyhates",
    "creator_uid": 6218,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596182635",
    "length": 16
  },
  {
    "id": 6402,
    "uuid": "51815f10-0f7e-476e-b329-3f889e1b8738",
    "hitokoto": "我们的征途是星辰大海。",
    "type": "d",
    "from": "银河英雄传说",
    "from_who": "莱因哈特",
    "creator": "eric_xing_chen",
    "creator_uid": 3454,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596542720",
    "length": 11
  },
  {
    "id": 6405,
    "uuid": "13423b72-680a-4535-bb38-a35d01c959bc",
    "hitokoto": "你一世，我一世，要久要久，不要离！",
    "type": "d",
    "from": "田所浩二",
    "from_who": "田所浩二",
    "creator": "DeemoMisaka",
    "creator_uid": 6718,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595225113",
    "length": 17
  },
  {
    "id": 6407,
    "uuid": "e38c7d70-6b65-4ab7-a982-0fac2f9b9748",
    "hitokoto": "人类的悲欢并不相通，我只觉得他们吵闹。",
    "type": "d",
    "from": "而已集",
    "from_who": "鲁迅",
    "creator": "辞许丶",
    "creator_uid": 6782,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595558924",
    "length": 19
  },
  {
    "id": 6410,
    "uuid": "e4978b5b-1eab-4fb4-bc1a-c54f7e312dc4",
    "hitokoto": "凡前呼后拥才敢说话的人，心底必然藏着怯弱。",
    "type": "d",
    "from": "龙族",
    "from_who": "江南",
    "creator": "白玉楼的白麻薯",
    "creator_uid": 5325,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595608924",
    "length": 21
  },
  {
    "id": 6417,
    "uuid": "44ed309f-1019-4a1d-8096-5c3dfcda972f",
    "hitokoto": "我会捧着鲜花去见你，在花谢的时节。",
    "type": "d",
    "from": "我在天兵天将旁看你",
    "from_who": "祁连山",
    "creator": "诗人祁连山",
    "creator_uid": 6862,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596340215",
    "length": 17
  },
  {
    "id": 6420,
    "uuid": "3ce7c2fa-91e4-4a50-9a63-bc46eec1e1de",
    "hitokoto": "我想我不会放弃那些有你的记忆，即使年华渐渐老去。我想我更加珍惜拥在怀里的亲情，因为幸福稍纵即逝去。",
    "type": "d",
    "from": "口白",
    "from_who": "张雨生",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596122328",
    "length": 49
  },
  {
    "id": 6425,
    "uuid": "3e0201e4-c1cd-4495-9638-7a998524db7c",
    "hitokoto": "我怕我的意志力配不上我所受的磨难。",
    "type": "d",
    "from": "陀斯妥耶夫斯基",
    "from_who": "陀斯妥耶夫斯基",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596107773",
    "length": 17
  },
  {
    "id": 6426,
    "uuid": "32d6970e-60e9-4a09-bb8c-d327a95ebf83",
    "hitokoto": "我富有天下名川大山，想起来也没什么稀奇的，也不过是一堆烂石头野河水，浑身上下，也就这几分真心能上秤买两斤。你要？拿去。",
    "type": "d",
    "from": "镇魂",
    "from_who": "priest",
    "creator": "晚宁是我的",
    "creator_uid": 6787,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595570656",
    "length": 59
  },
  {
    "id": 6433,
    "uuid": "23599312-7538-4237-ad86-c63d6803eb2c",
    "hitokoto": "她爱海只爱海的惊涛骇浪，爱青草仅仅爱青草遍生于废墟之间。",
    "type": "d",
    "from": "包法利夫人",
    "from_who": "福楼拜",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596765292",
    "length": 28
  },
  {
    "id": 6435,
    "uuid": "1d056977-4d0b-4070-8b49-be3e3f5bbc6b",
    "hitokoto": "掉头一去是风吹黑发，回首再来已雪满白头。",
    "type": "d",
    "from": "浪子回头",
    "from_who": "余光中",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1597022703",
    "length": 20
  },
  {
    "id": 6436,
    "uuid": "f23dbf5e-4807-4e65-9b6b-826b0ffb16af",
    "hitokoto": "人最怕的是发现了自己想要的东西。",
    "type": "d",
    "from": "皮囊",
    "from_who": "蔡崇达",
    "creator": "情绪化",
    "creator_uid": 6967,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1597544047",
    "length": 16
  },
  {
    "id": 6438,
    "uuid": "8a9e84c1-38cb-4e6c-b14d-66afe34bd770",
    "hitokoto": "人人心中所有，人人笔下所无。",
    "type": "d",
    "from": "日央",
    "from_who": "王国维",
    "creator": "日央",
    "creator_uid": 6882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596598891",
    "length": 14
  },
  {
    "id": 6439,
    "uuid": "66b7ae9d-e436-4512-aa8d-f2813a8ebedd",
    "hitokoto": "酒可以不飲，醉豈能不醉？",
    "type": "d",
    "from": "当你途径我的盛放",
    "from_who": "扎西拉姆多多",
    "creator": "日央",
    "creator_uid": 6882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596599044",
    "length": 12
  },
  {
    "id": 6441,
    "uuid": "f35ffd38-85b7-45ae-b993-088c435198e9",
    "hitokoto": "滴不尽相思血泪抛红豆，开不完春柳春花满画楼。",
    "type": "d",
    "from": "红豆词",
    "from_who": "曹雪芹",
    "creator": "日央",
    "creator_uid": 6882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596599124",
    "length": 22
  },
  {
    "id": 6445,
    "uuid": "74d3b74a-0d59-4742-a29b-68ec90948911",
    "hitokoto": "霜雪吹满头，也算是白首。",
    "type": "d",
    "from": "好梦如旧",
    "from_who": "并瓦",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596764214",
    "length": 12
  },
  {
    "id": 6449,
    "uuid": "c2d8007d-0b16-4b6d-b47e-1166485508b2",
    "hitokoto": "世间情动，不过盛夏白瓷梅子汤，碎冰碰壁当啷响。世间情劫，不过三九黑瓦黄连鲜，糖心落低苦作言。世间执念，不过隆冬弱水千层冰，斧砸锹凿不能移。",
    "type": "d",
    "from": "穆玄英挂帅",
    "from_who": "玄衣朱裳",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1597022030",
    "length": 69
  },
  {
    "id": 6451,
    "uuid": "333b292c-ff63-443e-b525-a0a894714003",
    "hitokoto": "一面镜子永远等候她，让她坐到镜中常坐的地方。望着窗外，只要想起一生中后悔的事，梅花便落满了南山。",
    "type": "d",
    "from": "镜中",
    "from_who": "张枣",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1597022380",
    "length": 48
  },
  {
    "id": 6452,
    "uuid": "130fd58e-c662-48c4-8f34-80b6c7cc0145",
    "hitokoto": "我们嘲笑过少年的无知，也嘲笑过岁月的苍老。我们行走在路上，理想宏大，眼窝却浅显。",
    "type": "d",
    "from": "你的孤独，虽败犹荣",
    "from_who": "刘同",
    "creator": "alterem",
    "creator_uid": 4351,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1598236096",
    "length": 40
  },
  {
    "id": 6454,
    "uuid": "fec32abd-6474-4c49-9444-66478246c730",
    "hitokoto": "屋外是一排排常绿不拘秋夏冬、居安镇守的香樟树；屋内是年少不更事、兵荒马乱的芳心暗渡 。",
    "type": "d",
    "from": "暗格里的秘密",
    "from_who": "耳东兔子",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1597026744",
    "length": 43
  },
  {
    "id": 6471,
    "uuid": "ac0749b3-2119-4984-8ece-6ceb47f0f540",
    "hitokoto": "千秋无绝色，悦目为佳人。",
    "type": "d",
    "from": "神游",
    "from_who": "徐公子胜治",
    "creator": "句芒",
    "creator_uid": 7498,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603162511",
    "length": 12
  },
  {
    "id": 6475,
    "uuid": "e9282f1e-1301-4ea2-8ac1-316050bab8a3",
    "hitokoto": "三十年河东，三十年河西",
    "type": "d",
    "from": "儒林外史",
    "from_who": null,
    "creator": "奈奈子",
    "creator_uid": 7435,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602560595",
    "length": 11
  },
  {
    "id": 6478,
    "uuid": "b7cf4092-cd26-4863-84f6-06adf92b258b",
    "hitokoto": "长恨此身非我有，何时忘却营营。",
    "type": "d",
    "from": "临江仙•夜归临皋",
    "from_who": "苏轼",
    "creator": "Gilleece",
    "creator_uid": 7474,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602942223",
    "length": 15
  },
  {
    "id": 6482,
    "uuid": "5a7e8957-c87c-4921-9c4d-4635ceda2976",
    "hitokoto": "小舟从此逝，江海寄余生。",
    "type": "d",
    "from": "临江仙•夜归临皋",
    "from_who": "苏轼",
    "creator": "Gilleece",
    "creator_uid": 7474,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602942008",
    "length": 12
  },
  {
    "id": 6484,
    "uuid": "a5666678-b832-4065-a0c8-7c10b9e31835",
    "hitokoto": "我决起而飞，抢榆枋而止。",
    "type": "d",
    "from": "庄子·内篇·逍遥游",
    "from_who": null,
    "creator": "Gilleece",
    "creator_uid": 7474,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602940535",
    "length": 12
  },
  {
    "id": 6488,
    "uuid": "95fc9069-a44f-45ca-abc6-fe6ddfbf4e15",
    "hitokoto": "世界脱节了，这是怎样一个被诅咒的因果啊，竟是因为纠正它而生!",
    "type": "d",
    "from": "哈姆雷特",
    "from_who": "威廉·莎士比亚",
    "creator": "Diving_lin",
    "creator_uid": 4593,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597719580",
    "length": 30
  },
  {
    "id": 6494,
    "uuid": "39139a0a-a824-4170-8e31-26a7cff60efd",
    "hitokoto": "生命中所有的绚烂，原来终究，都要用寂寞来偿还。",
    "type": "d",
    "from": "百年孤独",
    "from_who": "加夫列尔·加西亚·马尔克斯",
    "creator": "浮生若梦",
    "creator_uid": 6985,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597716523",
    "length": 23
  },
  {
    "id": 6497,
    "uuid": "0e1cf0ab-eff7-4e1f-b8ef-7ec498f532ad",
    "hitokoto": "唯有信仰与日月亘古不灭。",
    "type": "d",
    "from": "第一序列",
    "from_who": "会说话的肘子",
    "creator": "永远少年",
    "creator_uid": 7050,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598423801",
    "length": 12
  },
  {
    "id": 6498,
    "uuid": "d8575323-d5ce-4610-beb1-439d961597ec",
    "hitokoto": "芙蓉塘外有轻雷。",
    "type": "d",
    "from": "无题",
    "from_who": "李商隐",
    "creator": "Coral",
    "creator_uid": 5360,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601787355",
    "length": 8
  },
  {
    "id": 6500,
    "uuid": "d053a5dc-67b4-4233-9045-ff14b3da7380",
    "hitokoto": "永远相信美好的事情即将发生",
    "type": "d",
    "from": "永远相信美好的事情即将发生",
    "from_who": "凌小汐",
    "creator": "Jeremy Wu",
    "creator_uid": 7318,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601627227",
    "length": 13
  },
  {
    "id": 6505,
    "uuid": "8efa3983-1724-461c-9c3b-ebacc65f3592",
    "hitokoto": "仰天大笑出门去，我辈岂是蓬蒿人。",
    "type": "d",
    "from": "南陵别儿童入京",
    "from_who": "李白",
    "creator": "Chukaland",
    "creator_uid": 4959,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598328873",
    "length": 16
  },
  {
    "id": 6507,
    "uuid": "53a53b99-9a99-4eb5-9606-5c0f8e155494",
    "hitokoto": "风乍起。合当奋意向人生。",
    "type": "d",
    "from": "起风了",
    "from_who": "堀辰雄",
    "creator": "losting",
    "creator_uid": 4867,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597944502",
    "length": 12
  },
  {
    "id": 6509,
    "uuid": "2e28437d-5940-4aec-8796-7ce31f04b22f",
    "hitokoto": "有人住高楼，有人在深沟；有人光万丈，有人一身锈；世人万千种，浮云莫去求；斯人若彩虹，遇上方知有。",
    "type": "d",
    "from": "怦然心动",
    "from_who": "文德琳・范・德拉安南",
    "creator": "会是你",
    "creator_uid": 7001,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597892096",
    "length": 48
  },
  {
    "id": 6515,
    "uuid": "e6d2d92f-06c3-43e5-a7c4-acaec9340f1d",
    "hitokoto": "别问我的心里有没有你，我余光中都是你。",
    "type": "d",
    "from": "乡愁",
    "from_who": "余光中",
    "creator": "然々\" ʀ.ǫᴏᴍɪ",
    "creator_uid": 7027,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598154495",
    "length": 19
  },
  {
    "id": 6517,
    "uuid": "17b71c4c-eed9-433f-9835-671b6e4c748a",
    "hitokoto": "见过银河，只想要你这颗星。",
    "type": "d",
    "from": "我已见过银河，却仍只爱你这一颗星",
    "from_who": "徐琳媛",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598580130",
    "length": 13
  },
  {
    "id": 6518,
    "uuid": "cd531db6-43e7-420f-a3e9-f72c65c822c9",
    "hitokoto": "被污浊了的悲伤中，今日细雪，悬而欲降。",
    "type": "d",
    "from": "被污浊了的悲伤",
    "from_who": "中原中也",
    "creator": "小甜酿",
    "creator_uid": 7062,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598511488",
    "length": 19
  },
  {
    "id": 6519,
    "uuid": "d5af849a-90bf-4763-bff0-8e753f16f7ae",
    "hitokoto": "在各种孤独之间，人最怕精神上的孤独。",
    "type": "d",
    "from": "人间喜剧",
    "from_who": "巴尔扎克",
    "creator": "Miko",
    "creator_uid": 5305,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599273613",
    "length": 18
  },
  {
    "id": 6520,
    "uuid": "7010e72f-8c53-4561-a0a1-72e082f07dc1",
    "hitokoto": "满纸荒唐言，一把辛酸泪，都云作者痴，谁解其中味。",
    "type": "d",
    "from": "红楼梦",
    "from_who": "曹雪芹",
    "creator": "drinktoomuchsks",
    "creator_uid": 7127,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599368910",
    "length": 24
  },
  {
    "id": 6522,
    "uuid": "1d561545-7872-4172-9401-4f7650d15bee",
    "hitokoto": "只恐双溪舴艋舟，载不动许多愁。",
    "type": "d",
    "from": "武陵春·春晚",
    "from_who": "李清照",
    "creator": "Coral",
    "creator_uid": 5360,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601787412",
    "length": 15
  },
  {
    "id": 6524,
    "uuid": "35ff445e-4935-4acc-955a-35dabfbada84",
    "hitokoto": "时光一逝永不回, 往事只能回味。",
    "type": "d",
    "from": "往事只能回味",
    "from_who": "林煌坤",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1600172678",
    "length": 16
  },
  {
    "id": 6528,
    "uuid": "aabd9121-254d-4d58-9431-04044c348136",
    "hitokoto": "自律，说起来简单，落下去复杂；听起来像感觉，做起来是原则。",
    "type": "d",
    "from": "来来往往",
    "from_who": "池莉",
    "creator": "悟空",
    "creator_uid": 7256,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601175239",
    "length": 29
  },
  {
    "id": 6529,
    "uuid": "d55380c7-734e-49c0-97e8-f7b5c1f00e05",
    "hitokoto": "忆童年时竹马青梅, 两小无猜日夜相随。",
    "type": "d",
    "from": "往事只能回味",
    "from_who": "林煌坤",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1600172709",
    "length": 19
  },
  {
    "id": 6533,
    "uuid": "8cf63f8b-c23f-4c5a-ad7f-a958fdb35b9b",
    "hitokoto": "我们执着于寻找对方缺少的品质，真是太傻了。",
    "type": "d",
    "from": "面纱",
    "from_who": "Walter",
    "creator": "见你时澜青，不见时生春",
    "creator_uid": 7133,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599382758",
    "length": 21
  },
  {
    "id": 6536,
    "uuid": "d633f486-1798-46c8-a927-3485c8f41dfb",
    "hitokoto": "时光是见证与检测一切成败的机器，凡膨胀欲望者，必定消失，那些保持欲望者，总能走到最后。",
    "type": "d",
    "from": "哈斯特鹰的悲剧",
    "from_who": "沈厢",
    "creator": "Miko",
    "creator_uid": 5305,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599274440",
    "length": 43
  },
  {
    "id": 6538,
    "uuid": "b1977244-b05d-4b98-8a52-09132ca5d786",
    "hitokoto": "君今在罗网，何以有羽翼。",
    "type": "d",
    "from": "梦李白二首",
    "from_who": "杜甫",
    "creator": "见你时澜青，不见时生春",
    "creator_uid": 7133,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599382873",
    "length": 12
  },
  {
    "id": 6547,
    "uuid": "cc173456-256b-43ac-9bc7-173f30790f60",
    "hitokoto": "曾记否，到中流击水，浪遏飞舟。",
    "type": "d",
    "from": "沁园春.长沙",
    "from_who": "毛泽东",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599805313",
    "length": 15
  },
  {
    "id": 6552,
    "uuid": "dd975ce9-618a-40c8-ae5d-0d7c8dc19bb7",
    "hitokoto": "世人皆说爱与孤独，皆因晦涩成为罪恶。",
    "type": "d",
    "from": "妄想症Paranoia",
    "from_who": "雨狸",
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598855437",
    "length": 18
  },
  {
    "id": 6562,
    "uuid": "61e2dab9-a9cc-4762-960d-a74dea2e014b",
    "hitokoto": "我不去想，是否能够成功 ，既然选择了远方 ，便只顾风雨兼程。",
    "type": "d",
    "from": "热爱生命",
    "from_who": "汪国真",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598692940",
    "length": 30
  },
  {
    "id": 6571,
    "uuid": "88a7ff51-981d-49ed-979f-bcd1504c0b26",
    "hitokoto": "逝者已矣，生者如斯。",
    "type": "d",
    "from": "石壕吏",
    "from_who": "杜甫",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387972",
    "length": 10
  },
  {
    "id": 6585,
    "uuid": "2294885a-f073-446b-83c0-815f2e27dcbc",
    "hitokoto": "让我怎样感谢你，当我走向你的时候，我原想收获一缕春风，你却给了我整个春天。",
    "type": "d",
    "from": "感谢",
    "from_who": "汪国真",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598692375",
    "length": 37
  },
  {
    "id": 6588,
    "uuid": "1e057936-d947-4f4b-a8ea-3173c6829486",
    "hitokoto": "你在桥上看风景，看风景人在楼上看你。 明月装饰了你的窗子，你装饰了别人的梦。",
    "type": "d",
    "from": "断章",
    "from_who": "卞之琳",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598692815",
    "length": 38
  },
  {
    "id": 6590,
    "uuid": "1385ff7a-4372-4810-b793-6ca54ea24313",
    "hitokoto": "喜欢就会放肆，但爱就是克制。",
    "type": "d",
    "from": "后会无期",
    "from_who": "韩寒",
    "creator": "秋山sama",
    "creator_uid": 7513,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603252332",
    "length": 14
  },
  {
    "id": 6591,
    "uuid": "70235b6b-64e8-488f-b60d-a735df5cb781",
    "hitokoto": "朝闻道，夕死可矣。",
    "type": "d",
    "from": "论语",
    "from_who": "孔子",
    "creator": "秋山sama",
    "creator_uid": 7513,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603252197",
    "length": 9
  },
  {
    "id": 6592,
    "uuid": "7ff589fc-42c2-4826-ac7b-6e21022d5778",
    "hitokoto": "然则天下之事，但知其一，不知其二者多矣，可据理臆断欤？",
    "type": "d",
    "from": "河中石兽",
    "from_who": "纪昀",
    "creator": "Gilleece",
    "creator_uid": 7474,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603289151",
    "length": 27
  },
  {
    "id": 6595,
    "uuid": "d6cee05c-37d1-4147-b0b8-b3390f97d89c",
    "hitokoto": "尔辈不能究物理。",
    "type": "d",
    "from": "河中石兽",
    "from_who": "纪昀",
    "creator": "Gilleece",
    "creator_uid": 7474,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603288996",
    "length": 8
  },
  {
    "id": 6601,
    "uuid": "1351dede-c48a-4f75-8486-64369284f83a",
    "hitokoto": "哪样比较孤独，是活在自己的世界里，谁也不爱。还是心里爱着一个人，却始终无法向爱靠近。",
    "type": "d",
    "from": "质数的孤独",
    "from_who": "[意] 保罗·乔尔达诺",
    "creator": "Inzam_Z",
    "creator_uid": 7525,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603353350",
    "length": 42
  },
  {
    "id": 6604,
    "uuid": "bb6f728d-1145-4883-956d-d9b2c4cbbe30",
    "hitokoto": "鹰击长空，鱼翔浅底，万类霜天竞自由。",
    "type": "d",
    "from": "沁园春·长沙",
    "from_who": null,
    "creator": "1sdaxf",
    "creator_uid": 7504,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603369570",
    "length": 18
  },
  {
    "id": 6605,
    "uuid": "1fec1bf5-2a86-466a-a891-cf354deaffc5",
    "hitokoto": "离人灯长明，他死在一场风雪中。",
    "type": "d",
    "from": "穿成高危职业之师尊",
    "from_who": null,
    "creator": "人间富婆",
    "creator_uid": 7529,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603412751",
    "length": 15
  },
  {
    "id": 6606,
    "uuid": "6349a88b-f505-4aca-8b0f-44b430a163ea",
    "hitokoto": "假如对大海万般期待，务必晚两年再去看海。看到海，就会失去海。",
    "type": "d",
    "from": "看海",
    "from_who": null,
    "creator": "傅里叶今天不想展开",
    "creator_uid": 7533,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603436698",
    "length": 30
  },
  {
    "id": 6613,
    "uuid": "3836a2b0-13a8-47d8-9bb8-734968af25fa",
    "hitokoto": "这个世界没有什么好畏惧的，反正我们只来一次。",
    "type": "d",
    "from": "=",
    "from_who": "朱德庸",
    "creator": "Seddy",
    "creator_uid": 7542,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603552728",
    "length": 22
  },
  {
    "id": 6617,
    "uuid": "7e8dae48-2086-45ca-9534-0ccbebf6722c",
    "hitokoto": "宇宙以其不息的欲望将一个歌舞炼为永恒。这欲望有怎样一个人间的姓名，大可忽略不计。",
    "type": "d",
    "from": "我与地坛",
    "from_who": "史铁生",
    "creator": "YulinZYQ",
    "creator_uid": 7609,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604126760",
    "length": 40
  },
  {
    "id": 6621,
    "uuid": "327712a3-5a06-43ca-9faf-2deb4f364551",
    "hitokoto": "若我与你重逢，事隔经年。我将何以贺你？以眼泪，以沉默。",
    "type": "d",
    "from": "春逝",
    "from_who": "拜伦",
    "creator": "莳昇",
    "creator_uid": 5608,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604133839",
    "length": 27
  },
  {
    "id": 6623,
    "uuid": "c8507824-d8fd-4311-b8a6-e322e7fc5196",
    "hitokoto": "绘梨衣：\"我们都是小怪兽，有一天会被正义的奥特曼杀死。\"",
    "type": "d",
    "from": "龙族",
    "from_who": null,
    "creator": "寸惑",
    "creator_uid": 7579,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604286132",
    "length": 28
  },
  {
    "id": 6624,
    "uuid": "5e814cca-3fd9-4637-afde-4513fc9c52cc",
    "hitokoto": "我急切地盼望着可以经历一场放纵的快乐，纵使巨大的悲哀将接踵而至，我也在所不惜。",
    "type": "d",
    "from": "人间失格",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1607219776",
    "length": 39
  },
  {
    "id": 6625,
    "uuid": "26a5b884-6a3d-4f97-9e0b-45958447392b",
    "hitokoto": "有人认为爱是性，是婚姻，是清晨六点的吻，是一堆孩子，也许真是这样的，莱斯特小姐。但你知道我怎么想吗，我觉得爱是想触碰又收回手。",
    "type": "d",
    "from": "破碎故事之心",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266469",
    "length": 63
  },
  {
    "id": 6627,
    "uuid": "a73402f3-fc73-469d-b7fc-ac4df843e8ae",
    "hitokoto": "我始终认为一个人可以很天真简单的活下去，必是身边无数人用更大的代价守护而来的。",
    "type": "d",
    "from": "小王子",
    "from_who": "安东尼·德·圣-埃克苏佩里",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1607266525",
    "length": 39
  },
  {
    "id": 6662,
    "uuid": "73810fa7-124f-4112-a7ad-cbc85a87a88c",
    "hitokoto": "到头来，我们记住的，不是敌人的攻击，而是朋友的沉默。",
    "type": "d",
    "from": "马丁·路德·金",
    "from_who": null,
    "creator": "小忧忧",
    "creator_uid": 4701,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1603932024",
    "length": 26
  },
  {
    "id": 6663,
    "uuid": "02095beb-fbb8-4c1a-8111-b1ac53219f79",
    "hitokoto": "但使文章有风骨，岂凭时间庸人辱。",
    "type": "d",
    "from": "知乎",
    "from_who": "如琢",
    "creator": "Oreo_King",
    "creator_uid": 7347,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604192774",
    "length": 16
  },
  {
    "id": 6664,
    "uuid": "17b33949-91ea-4f75-9fba-705a17352beb",
    "hitokoto": "现实尚未支离破碎，是因为梦想还在苦苦支撑。",
    "type": "d",
    "from": "半泽直树",
    "from_who": "池井户润",
    "creator": "机智的狐狸菌",
    "creator_uid": 5198,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604570873",
    "length": 21
  },
  {
    "id": 6669,
    "uuid": "6951101c-0c35-4a0c-9312-7c94657dc39d",
    "hitokoto": "hell is empty，the devil is in the world。",
    "type": "d",
    "from": "暴风雨",
    "from_who": "莎士比亚",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604752551",
    "length": 40
  },
  {
    "id": 6672,
    "uuid": "e6211642-58e4-4350-8365-3afaa8a14c89",
    "hitokoto": "曾经拥有的东西失去了，并不代表会回到原来没有那种东西的时候。",
    "type": "d",
    "from": "白夜行",
    "from_who": "东野圭吾",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753021",
    "length": 30
  },
  {
    "id": 6673,
    "uuid": "8f8939f9-e5c1-4251-940d-2994e4c5d583",
    "hitokoto": "人的一生是短暂的，但如果卑鄙地过这短暂的一生，那就太长了。",
    "type": "d",
    "from": "莎士比亚",
    "from_who": "莎士比亚",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753243",
    "length": 29
  },
  {
    "id": 6676,
    "uuid": "938d6b7a-f4fe-42e9-9f32-55719670749b",
    "hitokoto": "一个能辨真话假话的扇子，可以锦上添花，却不能雪中送炭。",
    "type": "d",
    "from": "哑舍",
    "from_who": "玄色",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753465",
    "length": 27
  },
  {
    "id": 6677,
    "uuid": "f7755b77-1a8d-4792-9c34-e169459b12ea",
    "hitokoto": "快乐的时候不要想以后，痛苦的时候多想想将来。",
    "type": "d",
    "from": "琦殿",
    "from_who": null,
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753654",
    "length": 22
  },
  {
    "id": 6680,
    "uuid": "f6d68b52-24b3-44a8-89f1-eddbd3457198",
    "hitokoto": "别师犹染凡心，剑端新雪霁，独恨无留迹。",
    "type": "d",
    "from": "魔道祖师",
    "from_who": "墨香铜臭",
    "creator": "YSH",
    "creator_uid": 7248,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604756024",
    "length": 19
  },
  {
    "id": 6682,
    "uuid": "ba35ee53-0bbf-4d1f-9b39-f66094fe45b8",
    "hitokoto": "成功的花，人们只羡慕她现时的明艳。而当初的芽，却浸透了奋斗的泪泉，洒满了牺牲的血雨！",
    "type": "d",
    "from": "成功的花",
    "from_who": "冰心",
    "creator": "Misaka-h",
    "creator_uid": 7622,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604797299",
    "length": 42
  },
  {
    "id": 6683,
    "uuid": "640ee5d9-1b39-4ae3-978e-8586c349f0a8",
    "hitokoto": "要永远宽恕一切人，要无数次地宽恕别人，因为世界上没有一个人是无罪的，没有一个人不需要宽恕，因此也就没有一个人有权力去惩罚或者纠正别人。",
    "type": "d",
    "from": "复活",
    "from_who": "列夫·托尔斯泰",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604798308",
    "length": 67
  },
  {
    "id": 6684,
    "uuid": "5ab5c1d9-dc0d-42a4-a591-06f8b6cb66b6",
    "hitokoto": "说来奇怪，这种承认自己卑鄙的心情，固然不免使人痛苦，同时却又使人快乐而心安。",
    "type": "d",
    "from": "复活",
    "from_who": "列夫·托尔斯泰",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604798351",
    "length": 38
  },
  {
    "id": 6685,
    "uuid": "563b5978-0de0-48bc-8025-324cf8845887",
    "hitokoto": "人好比河流，所有河里的水都一样，到处的水都一样，可是每一条河里的水都是有的地方狭窄，有的地方宽阔；有的地方湍急，有的地方平坦。每个人都具有各种各样的本性的胚芽，有的时候表现出这样一种本性，有的时候表现出那样一种本性，有时变得面目全非，其实还是原来那个人。",
    "type": "d",
    "from": "复活",
    "from_who": "列夫·托尔斯泰",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604798396",
    "length": 127
  },
  {
    "id": 6690,
    "uuid": "4df223c1-6258-4bf1-91c9-02cfb8d995e7",
    "hitokoto": "没有谁的生活会一直完美，但无论什么时候，都要看着前方，满怀希望就会所向披靡。",
    "type": "d",
    "from": "撒野",
    "from_who": "巫哲",
    "creator": "凤雏",
    "creator_uid": 7748,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605342704",
    "length": 38
  },
  {
    "id": 6691,
    "uuid": "21a63187-f6b7-454a-b886-20bb78236f46",
    "hitokoto": "几乎所有人对高三一整年的印象，是做不完的模拟卷，是朗朗读书声、整间教室里粉尘飞扬。闲着没事把用光的笔芯一根根收集起来，最后毕业收成了一大捆。其他印象就是睡觉。撑不住就往桌上一趴，头顶是晃晃悠悠的吊扇，发出嘎吱声响，连带着吹起试卷边角。又好像真的是睡了一觉。",
    "type": "d",
    "from": "伪装学渣",
    "from_who": "木瓜黄",
    "creator": "凤雏",
    "creator_uid": 7748,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605342821",
    "length": 128
  },
  {
    "id": 6692,
    "uuid": "bb73fe86-a94a-4f34-a609-f404ef99ab00",
    "hitokoto": "那个夏天的蝉鸣比哪一年都聒噪，教室窗外枝桠疯长，却总也挡不住烈阳。",
    "type": "d",
    "from": "某某",
    "from_who": "木苏里",
    "creator": "凤雏",
    "creator_uid": 7748,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605342906",
    "length": 33
  },
  {
    "id": 6693,
    "uuid": "eceafd52-1c25-4bcb-ab43-c890622bb0ec",
    "hitokoto": "不是每一次出走，都能再回去的。",
    "type": "d",
    "from": "残次品",
    "from_who": "priest",
    "creator": "凤雏",
    "creator_uid": 7748,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605342955",
    "length": 15
  },
  {
    "id": 6694,
    "uuid": "c3c4256e-b1fe-4ece-99b6-4ce404df9546",
    "hitokoto": "星空彼岸的光芒，幻想触及的地方，我到了淤泥深处，捡到了一颗星星。",
    "type": "d",
    "from": "残次品",
    "from_who": "priest",
    "creator": "凤雏",
    "creator_uid": 7748,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605343056",
    "length": 32
  },
  {
    "id": 6696,
    "uuid": "37a664f1-2b4f-471f-a0e6-f04e82716ccc",
    "hitokoto": "你说你喜欢雨，但是你在下雨的时候打伞，你说你喜欢太阳，但是你在阳光明媚的时候躲在阴凉的地方，你说你喜欢风，但是在刮风的时候你却关上窗户，这就是为什么我害怕你说你也喜欢我。",
    "type": "d",
    "from": "存疑",
    "from_who": "莎士比亚",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604800608",
    "length": 85
  },
  {
    "id": 6698,
    "uuid": "5b6911fb-a10f-4d8b-815f-51ca8e8a429b",
    "hitokoto": "一个人的意义不在于他的成就，而在于他所企求成就的东西。",
    "type": "d",
    "from": "沙与沫",
    "from_who": "纪伯伦",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604800763",
    "length": 27
  },
  {
    "id": 6700,
    "uuid": "150344e1-b1a2-40f2-80a8-cbbc42ece4d5",
    "hitokoto": "谢谢火焰给你光明，但是不要忘了那执灯的人，他是坚忍地站在黑暗当中呢。",
    "type": "d",
    "from": "飞鸟集",
    "from_who": "泰戈尔",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604801281",
    "length": 34
  },
  {
    "id": 6708,
    "uuid": "75123bc2-b76f-41a8-a320-863dccce67d7",
    "hitokoto": "让时光静静悄悄的流，把所有遗憾和失落都带走。",
    "type": "d",
    "from": "bilibili",
    "from_who": "乌贼酱",
    "creator": "Eason.J",
    "creator_uid": 7702,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605009019",
    "length": 22
  },
  {
    "id": 6709,
    "uuid": "cede02fa-5170-4e00-aeaa-dc03e5f7fee5",
    "hitokoto": "自然选择号，前进四。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "Eason.J",
    "creator_uid": 7702,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605009158",
    "length": 10
  },
  {
    "id": 6710,
    "uuid": "b4761194-1fb1-4833-bd75-f8a5e93f55f9",
    "hitokoto": "死亡是我最后的情人。",
    "type": "d",
    "from": "一个人的村庄",
    "from_who": "刘亮程",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605011387",
    "length": 10
  },
  {
    "id": 6711,
    "uuid": "1d092242-2773-4cc3-87d6-83d98da05b24",
    "hitokoto": "当一个民族没有退路的时候，它的唯一的退路就是退回自己的内心。",
    "type": "d",
    "from": "德国文化史",
    "from_who": "李伯杰",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605011426",
    "length": 30
  },
  {
    "id": 6712,
    "uuid": "e762c7e7-387c-411f-b0df-17346a9fee64",
    "hitokoto": "我因为后来离开村子，在远处看见这一村庄人的火焰。看见他们比熄灭还要寂静的那一场燃烧。我像一根逃出火堆的干柴，幸运而孤独地站在远处。",
    "type": "d",
    "from": "一个人的村庄",
    "from_who": "刘亮程",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605011544",
    "length": 65
  },
  {
    "id": 6713,
    "uuid": "1b3cf077-0511-49e7-a376-071e09aeb854",
    "hitokoto": "不论斟满的是什么，都要——干杯！",
    "type": "d",
    "from": "干杯",
    "from_who": "吉皮乌斯诗",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605011693",
    "length": 16
  },
  {
    "id": 6715,
    "uuid": "e2fa9d25-d4d5-44cc-9cbb-7c8c1d31f75f",
    "hitokoto": "少年郎就应当肩上挑着草长莺飞和杨柳依依，想什么家仇国恨道德文章？少年郎眼眸里就应当流淌着哗啦啦的溪涧，开心时有声响，不开心时也有。",
    "type": "d",
    "from": "剑来",
    "from_who": "烽火戏诸侯",
    "creator": "笤帚",
    "creator_uid": 7705,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605012522",
    "length": 65
  },
  {
    "id": 6723,
    "uuid": "7baeb774-a325-465c-b0ba-61e0d35f5992",
    "hitokoto": "在这熙熙尘世间所求不过如此，债必偿，恩必报，诺必践，情必守。风调雨顺，山河长安。此生便算是了无遗憾了。",
    "type": "d",
    "from": "铜钱龛世",
    "from_who": "木苏里",
    "creator": "凤雏",
    "creator_uid": 7748,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605343136",
    "length": 51
  },
  {
    "id": 6725,
    "uuid": "5a0d6cb2-809e-49c7-824c-83d8a89b4455",
    "hitokoto": "我们把世界看错，反说它欺骗了我们。",
    "type": "d",
    "from": "飞鸟集",
    "from_who": "泰戈尔",
    "creator": "铃声一遍遍",
    "creator_uid": 7753,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605365056",
    "length": 17
  },
  {
    "id": 6726,
    "uuid": "50b9346f-ef85-4a68-876a-a1197efec4c3",
    "hitokoto": "当我痛苦地站在你的面前，你不能说我一无所有，你不能说我两手空空。",
    "type": "d",
    "from": "答复",
    "from_who": "海子",
    "creator": "铃声一遍遍",
    "creator_uid": 7753,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605365158",
    "length": 32
  },
  {
    "id": 6727,
    "uuid": "4cee081b-b881-4016-ab7c-68df7c46ce55",
    "hitokoto": "秋天深了，神的家中鹰在集合。神的故乡鹰在言语。秋天深了，王在写诗。",
    "type": "d",
    "from": "秋",
    "from_who": "海子",
    "creator": "铃声一遍遍",
    "creator_uid": 7753,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605365283",
    "length": 33
  },
  {
    "id": 6730,
    "uuid": "5da17cc3-2efe-4256-a76b-1dcd00c6982d",
    "hitokoto": "凡是过去，皆为序章。",
    "type": "d",
    "from": "戏剧《暴风雨》",
    "from_who": "莎士比亚",
    "creator": "幻煞白",
    "creator_uid": 7766,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605488241",
    "length": 10
  },
  {
    "id": 6747,
    "uuid": "4a3df6d6-5c9e-4273-a8ea-e23dc5018c9c",
    "hitokoto": "救救孩子……",
    "type": "d",
    "from": "狂人日记",
    "from_who": "鲁迅",
    "creator": "胡金大圣",
    "creator_uid": 7833,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606131983",
    "length": 6
  },
  {
    "id": 6748,
    "uuid": "7c09c080-d96d-4ed4-b2ec-3da3a772da76",
    "hitokoto": "“奥雷里亚诺”，他悲伤的敲下发报键，“马孔多在下雨”。",
    "type": "d",
    "from": "百年孤独",
    "from_who": "马尔克斯",
    "creator": "TuTu",
    "creator_uid": 7853,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606292384",
    "length": 27
  },
  {
    "id": 6756,
    "uuid": "2238c298-0e53-440b-83c0-1b8743a0ea9a",
    "hitokoto": "茶，是为了友谊而存在世间的；最好的茶，则是为了知味的人存在世间；我们到处找茶品茶，不也是渴望着与知味的人对饮吗？",
    "type": "d",
    "from": "龙井问茶",
    "from_who": "林清玄",
    "creator": "pro_hjc",
    "creator_uid": 7821,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606313380",
    "length": 56
  },
  {
    "id": 6768,
    "uuid": "a807de9e-1cd9-4df1-acf5-5ec0a8ed2320",
    "hitokoto": "现代社会以海德格尔的一句“一切实践传统都已经瓦解完了”为嚆矢。滥觞于家庭与社会传统的期望正失去它们的借鉴意义。但面对看似无垠的未来天空，我想循卡尔维诺“树上的男爵”的生活好过过早地振翮。",
    "type": "d",
    "from": "生活在树上",
    "from_who": "2020浙江高考一考生",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606403443",
    "length": 93
  },
  {
    "id": 6769,
    "uuid": "6efada3e-4646-476a-a6b9-59b3fec101fa",
    "hitokoto": "用在树上的生活方式体现个体的超越性，保持婞直却又不拘泥于所谓“遗世独立”的单向度形象。这便是卡尔维诺为我们提供的理想期望范式。生活在树上——始终热爱大地——升上天空。",
    "type": "d",
    "from": "生活在树上",
    "from_who": "2020浙江高考一考生",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606403466",
    "length": 83
  },
  {
    "id": 6770,
    "uuid": "c7b72bd4-c26d-4ef5-bea4-38aabc1da37d",
    "hitokoto": "海纳百川，有容乃大；壁立千仞，无欲则刚。",
    "type": "d",
    "from": "越华书院对联",
    "from_who": "林则徐",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606403600",
    "length": 20
  },
  {
    "id": 6773,
    "uuid": "f54a3530-cd33-4e34-8dd9-53547bccc113",
    "hitokoto": "一尺之锤，日取其半，万世不竭。",
    "type": "d",
    "from": "庄子",
    "from_who": null,
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606404255",
    "length": 15
  },
  {
    "id": 6788,
    "uuid": "542502a2-93cb-4c1e-9d26-e90ec75ca711",
    "hitokoto": "语言的隔阂，本质上是一个人——信息，知识，视野，圈子的隔阂。",
    "type": "d",
    "from": "网络",
    "from_who": null,
    "creator": "笑靥1",
    "creator_uid": 7874,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606484918",
    "length": 30
  },
  {
    "id": 6796,
    "uuid": "f35b1a29-0ffd-4fd4-b187-aad78f56e77d",
    "hitokoto": "​​爱情的枯汁早尝，壮年中年时代可以比较冷静。心酸的眼泪是培养你心灵的酒浆。不经历尖锐的痛苦的人，不会有深厚博大的同情心。",
    "type": "d",
    "from": "傅雷家书",
    "from_who": "傅雷",
    "creator": "LittleTurtle",
    "creator_uid": 7896,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606636528",
    "length": 61
  },
  {
    "id": 6797,
    "uuid": "54478975-8924-4b70-b725-592feac82909",
    "hitokoto": "对于爱情来说，有一个很无奈的结局，叫“有名无实”。对于婚姻来说，有一个很悲剧的状态，叫“有实无名”。",
    "type": "d",
    "from": "历史的温度",
    "from_who": "张玮",
    "creator": "LittleTurtle",
    "creator_uid": 7896,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606636666",
    "length": 50
  },
  {
    "id": 6798,
    "uuid": "2f61c8e0-3a35-4511-bd9c-b7a707ef5d24",
    "hitokoto": "酋长露出一副令人惊异的鄙夷神情，观望着这一场发疯似的争吵生活在天涯海角的每一个自然之子都会对这些文明人感到诧异。一小撮黄色的金属，在这些文明人看来，竟比他们的文明所取得的一切精神上和技术上的成就还要有价值。",
    "type": "d",
    "from": "人类的群星闪耀时",
    "from_who": "斯蒂芬·茨威格",
    "creator": "愚者",
    "creator_uid": 7900,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606664021",
    "length": 103
  },
  {
    "id": 6799,
    "uuid": "bdf314ad-8c98-4a67-8a93-f7f44d4c9cf3",
    "hitokoto": "理解别人远比审判别人更为快乐。",
    "type": "d",
    "from": "象棋的故事",
    "from_who": "斯蒂芬·茨威格",
    "creator": "愚者",
    "creator_uid": 7900,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606664110",
    "length": 15
  },
  {
    "id": 6800,
    "uuid": "f9bb014f-38bb-4d47-b44e-3a72f0e58ee4",
    "hitokoto": "莫道儒冠误此生，从来诗书不负人。",
    "type": "d",
    "from": "神童诗",
    "from_who": "汪洙",
    "creator": "渊鱼",
    "creator_uid": 7901,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606664866",
    "length": 16
  },
  {
    "id": 6801,
    "uuid": "fb474508-ec9d-4fce-a369-8cf835419bfc",
    "hitokoto": "不必担心失去的东西，因为你最终拥有的会遇见你，即使那不是你等待的。",
    "type": "d",
    "from": "此间的少年",
    "from_who": "江南",
    "creator": "渊鱼",
    "creator_uid": 7901,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606665116",
    "length": 33
  },
  {
    "id": 6803,
    "uuid": "7f3343c8-8b33-4186-9674-66ca2aa129b0",
    "hitokoto": "星影落九天， 鱼雁舞千弦。但为君沉吟，孤鸿醉尘烟。",
    "type": "d",
    "from": "还·潮连汐静",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606906855",
    "length": 25
  },
  {
    "id": 6804,
    "uuid": "0d9e3eaf-c9f2-4b77-9add-8fd8d56f292a",
    "hitokoto": "我的灵魂被惯有的坏脾气所淹没，我感到疲惫，不是对工作或者休闲疲惫，而是对自己感到疲惫。",
    "type": "d",
    "from": "惶然录",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219628",
    "length": 43
  },
  {
    "id": 6806,
    "uuid": "6968dfd3-b177-46a5-9105-23877fc91234",
    "hitokoto": "我曾听说住在罗生门的恶鬼，是因为害怕人性的残忍而逃走的。",
    "type": "d",
    "from": "《罗生门》",
    "from_who": "芥川龙之介",
    "creator": "qiokio",
    "creator_uid": 8506,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1613298068",
    "length": 28
  },
  {
    "id": 6807,
    "uuid": "3ec8d882-4c9e-4942-a6c7-617156abec9c",
    "hitokoto": "臣鞠躬尽瘁，死而后已。",
    "type": "d",
    "from": "后出师表",
    "from_who": "诸葛亮",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1613567748",
    "length": 11
  },
  {
    "id": 6808,
    "uuid": "c13912d3-6d3a-46a4-be73-c31b6300f745",
    "hitokoto": "他强任他强，清风拂山岗。他横任他横，明月照大江。",
    "type": "d",
    "from": "倚天屠龙记",
    "from_who": "金庸",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1616846761",
    "length": 24
  },
  {
    "id": 6812,
    "uuid": "d265984b-c2d3-43a8-a217-b04f56ba752d",
    "hitokoto": "再小的个子，也能给沙漠留下长长的身影；再小的人物，也能让历史吐出重重的叹息。",
    "type": "d",
    "from": "《文化苦旅》",
    "from_who": "余秋雨",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1615031351",
    "length": 38
  },
  {
    "id": 6813,
    "uuid": "89411d43-1cb3-44c7-9ffd-9386e2759f09",
    "hitokoto": "一个笑就击败了一辈子，一滴泪就还清了一个人，一人花开，一人花落，这些从头到尾，无人问询。",
    "type": "d",
    "from": "《何以笙箫默》",
    "from_who": "顾漫",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1615031157",
    "length": 44
  },
  {
    "id": 6814,
    "uuid": "04d55e32-cbaf-49f2-baae-828644050e60",
    "hitokoto": "没有人愿意承认自己是孤独的，孤独很可耻。",
    "type": "d",
    "from": "此间的少年",
    "from_who": "江南",
    "creator": "渊鱼",
    "creator_uid": 7901,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606665189",
    "length": 20
  },
  {
    "id": 6816,
    "uuid": "58e5cc75-5410-4e41-a912-d8f4ea068769",
    "hitokoto": "如同这雨，生于天，死于地，这中间的便是人生。",
    "type": "d",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "渊鱼",
    "creator_uid": 7901,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606665479",
    "length": 22
  },
  {
    "id": 6823,
    "uuid": "d8e938c8-7240-4e8e-a5a0-02eb0071a9ba",
    "hitokoto": "星球鳞片闪闪的躯体形成蜿蜒的宇宙之蛇。",
    "type": "d",
    "from": "另一个人",
    "from_who": "雨果",
    "creator": "Enderfga",
    "creator_uid": 7920,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606924048",
    "length": 19
  },
  {
    "id": 6826,
    "uuid": "15d9ca56-ca48-44bf-ba6f-f11243596b23",
    "hitokoto": "世界是那么阒寂，而昨天的我已离我远去。",
    "type": "d",
    "from": "人间失格·皮肤与心",
    "from_who": "太宰治",
    "creator": "a117xxs",
    "creator_uid": 7938,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607211721",
    "length": 19
  },
  {
    "id": 6827,
    "uuid": "b5074943-a003-4d54-b87d-a87b2f7efaa9",
    "hitokoto": "男人只有不幸，总是与恐惧搏斗。女人没有幸福，也没有不幸。",
    "type": "d",
    "from": "人间失格·维庸之妻",
    "from_who": "太宰治",
    "creator": "a117xxs",
    "creator_uid": 7938,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607212014",
    "length": 28
  },
  {
    "id": 6828,
    "uuid": "65254f1e-05fc-4265-b927-cf93bd2767c1",
    "hitokoto": "他们的胜利也必定会给我明日的出发带来光亮。",
    "type": "d",
    "from": "黄金风景",
    "from_who": "太宰治",
    "creator": "a117xxs",
    "creator_uid": 7938,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607212085",
    "length": 21
  },
  {
    "id": 6829,
    "uuid": "d2c219ad-fde3-4e3b-a03f-0e91006a8a55",
    "hitokoto": "唯有再见方为人生。",
    "type": "d",
    "from": "人间失格·Goodbye",
    "from_who": "太宰治",
    "creator": "a117xxs",
    "creator_uid": 7938,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607212138",
    "length": 9
  },
  {
    "id": 6830,
    "uuid": "3b30225a-5235-4286-bfe1-e9c7d78f1546",
    "hitokoto": "我也想过，或许在这个世界上，你是对的，而我是错的，但我却怎么也闹不明白：我究竟错在哪里，又怎么错了？",
    "type": "d",
    "from": "人间失格·蟋蟀",
    "from_who": "太宰治",
    "creator": "a117xxs",
    "creator_uid": 7938,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607211826",
    "length": 50
  },
  {
    "id": 6832,
    "uuid": "dd4f1c96-b165-4e0f-9f83-7672b8ff7524",
    "hitokoto": "生而为人，我很抱歉。",
    "type": "d",
    "from": "人间失格·二十世纪旗手",
    "from_who": "太宰治",
    "creator": "a117xxs",
    "creator_uid": 7938,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607212296",
    "length": 10
  },
  {
    "id": 6836,
    "uuid": "ee2a6606-ef87-41b4-a666-114a5c08a5dd",
    "hitokoto": "我设想所有迷人的人都是被溺爱的，这是他们吸引力的秘密。",
    "type": "d",
    "from": "王尔德",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219246",
    "length": 27
  },
  {
    "id": 6837,
    "uuid": "ae55eb6b-226f-433c-a155-dbc87fe38e93",
    "hitokoto": "如果我能使一颗心免于哀伤，我就不虚此生。",
    "type": "d",
    "from": "如果我能使一颗心免于哀伤",
    "from_who": "艾米莉·迪金森",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219353",
    "length": 20
  },
  {
    "id": 6838,
    "uuid": "6f832ab8-e761-4f25-9851-298b00df5977",
    "hitokoto": "如果自己不想积极认真地生活，不管得到什么样的回答都没用。",
    "type": "d",
    "from": "解忧杂货店",
    "from_who": "东野圭吾",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219440",
    "length": 28
  },
  {
    "id": 6839,
    "uuid": "f358eab7-50e3-4f3a-946b-b6601cf44627",
    "hitokoto": "如果痛恨所处的黑暗，请你成为你想要的光。",
    "type": "d",
    "from": "塞尔维亚的天空",
    "from_who": "顾城",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219512",
    "length": 20
  },
  {
    "id": 6841,
    "uuid": "87bb5a15-862c-4627-a15f-aaf17b8ba8c6",
    "hitokoto": "少年就是少年，他们看春风不喜，看夏蝉不烦，看秋风不悲，看冬雪不叹，看满身富贵懒察觉，看不公不允敢面对，只因他们是少年。",
    "type": "d",
    "from": "少年",
    "from_who": "陀思妥耶夫斯基",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219597",
    "length": 59
  },
  {
    "id": 6842,
    "uuid": "3e123e2e-da47-43d9-872e-9a3fb07917b1",
    "hitokoto": "我确实喜欢坐进我的小车里的感觉，我心里知道接下来的几个小时，我只有前面的大路、头顶无垠的天空以及白日梦与我为伴。",
    "type": "d",
    "from": "石黑一雄",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219659",
    "length": 56
  },
  {
    "id": 6844,
    "uuid": "b7d83d57-b92d-47f0-91c7-ca042a6bfbb6",
    "hitokoto": "我从来不相信什么懒洋洋的自由，我向往的自由是通过勤奋和努力实现的更广阔的人生，那样的自由才是珍贵的、有价值的；我相信一万小时定律，我从来不相信天上掉馅饼的灵感和坐等的成就。做一个自由又自律的人，靠势必实现的决心认真地活着。",
    "type": "d",
    "from": "山本耀司",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219744",
    "length": 111
  },
  {
    "id": 6845,
    "uuid": "acaafc35-de07-4371-883e-45c5f80549db",
    "hitokoto": "所有漂泊的人生都梦想着平静、童年、杜鹃花，正如所有平静的人生都幻想伏特加、乐队和醉生梦死。",
    "type": "d",
    "from": "弗朗索瓦丝·萨冈",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219802",
    "length": 45
  },
  {
    "id": 6846,
    "uuid": "0882df04-1bf5-40f9-ad34-0b0b0fdfd413",
    "hitokoto": "在所谓“人世间 ”摸爬滚打至今，我唯一愿意视为真理的，就只有这一句话：一切都会过去的。",
    "type": "d",
    "from": "人间失格",
    "from_who": "太宰治",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219828",
    "length": 43
  },
  {
    "id": 6847,
    "uuid": "8facdc83-2dee-43e6-9fca-64e38ddbe1c2",
    "hitokoto": "大多数人过着一种平静的绝望生活，他们心中的歌和他们一起埋入坟墓。",
    "type": "d",
    "from": "梭罗",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219859",
    "length": 32
  },
  {
    "id": 6848,
    "uuid": "1562570b-2c56-41e3-952f-42219e48e387",
    "hitokoto": "如果自己不想积极认真地生活，不管得到什么样的回答都没用。",
    "type": "d",
    "from": "解忧杂货店》 ​​​",
    "from_who": "东野圭吾",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219930",
    "length": 28
  },
  {
    "id": 6849,
    "uuid": "2f386f41-e97f-4d57-978f-82dab831abcd",
    "hitokoto": "在这一生中，你得成为自己的英雄。 我的意思是说，你得用自己的力量和自己的方式去赢，无论对你来说有多困难。",
    "type": "d",
    "from": "珍妮特·温特森",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219952",
    "length": 52
  },
  {
    "id": 6851,
    "uuid": "017b8d73-8094-45d9-9512-0be7f0f9cc68",
    "hitokoto": "“自己”这个东西是看不见的，撞上一些别的什么，反弹回来，才会了解“自己”。 所以，跟很强的东西、可怕的东西、水准很高的东西相碰撞，然后才知道“自己”是什么，这才是自我。",
    "type": "d",
    "from": "山本耀司",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607220007",
    "length": 84
  },
  {
    "id": 6854,
    "uuid": "9ffa2f96-db18-4995-a4a3-dd9b28fb6af6",
    "hitokoto": "我深怕自己本非美玉，故而不敢加以刻苦琢磨，却又半信自己是块美玉，故又不肯庸庸碌碌，与瓦砾为伍。",
    "type": "d",
    "from": "山月记",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607257318",
    "length": 47
  },
  {
    "id": 6855,
    "uuid": "44f01b48-e704-40a9-bf6a-5d71900d7835",
    "hitokoto": "我经常有那种感觉，如果这个事情来了，你却没有勇敢地去解决掉，它一定会再来。生活真是这样，它会一次次地让你去做这个功课直到你学会为止。",
    "type": "d",
    "from": "像我这样笨拙地生活",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266017",
    "length": 66
  },
  {
    "id": 6857,
    "uuid": "4fcf0b8c-7ec5-49ae-8448-b4916c8d02b3",
    "hitokoto": "有什么胜利可言，挺住意味着一切。",
    "type": "d",
    "from": "里尔克",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266053",
    "length": 16
  },
  {
    "id": 6858,
    "uuid": "0449559a-b998-417e-859a-6b303e3e473c",
    "hitokoto": "我什么也没忘，但是有些事只适合收藏。不能说也不能想，却又不能忘。",
    "type": "d",
    "from": "我与地坛",
    "from_who": "史铁生",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266069",
    "length": 32
  },
  {
    "id": 6859,
    "uuid": "40213f1e-3824-42b8-aa8f-4abe99732c77",
    "hitokoto": "你不能把这个世界，让给你所鄙视的人。",
    "type": "d",
    "from": "源泉",
    "from_who": "安·兰德",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266101",
    "length": 18
  },
  {
    "id": 6861,
    "uuid": "385ed437-04ef-409a-b28d-5b642f95f5d5",
    "hitokoto": "一切都明明白白， 但我们仍匆匆错过， 因为你相信命运， 因为我怀疑生活。",
    "type": "d",
    "from": "错过",
    "from_who": "顾城",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266136",
    "length": 36
  },
  {
    "id": 6862,
    "uuid": "0441fb00-1f92-44f4-8d03-1fa31fa1638e",
    "hitokoto": "令她反感的，远不是世界的丑陋，而是这个世界所戴的漂亮面具。",
    "type": "d",
    "from": "不可承受的生命之轻",
    "from_who": "米兰·昆德拉",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266156",
    "length": 29
  },
  {
    "id": 6863,
    "uuid": "f8f616e2-3b3c-43f9-906c-84c688511031",
    "hitokoto": "把人分成好的与坏的是荒谬的，人要么迷人，要么乏味。",
    "type": "d",
    "from": "奥斯卡·王尔德",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266176",
    "length": 25
  },
  {
    "id": 6864,
    "uuid": "87700214-e154-4420-8f49-bad40939af4b",
    "hitokoto": "你知道，故事的结尾并不重要，生活唯一确保我们的就是死亡。 所以我们最好不要让那结尾，夺走了故事的光芒。",
    "type": "d",
    "from": "漫长的告别",
    "from_who": "村上春树",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266191",
    "length": 51
  },
  {
    "id": 6865,
    "uuid": "5d813ece-ca67-4138-9137-3bbea9f8055e",
    "hitokoto": "你要克服的是你的虚荣心， 是你的炫耀欲， 你要对付的是你时刻想要冲出来想要出风头的小聪明。",
    "type": "d",
    "from": "月亮和六便士",
    "from_who": "毛姆",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266207",
    "length": 45
  },
  {
    "id": 6868,
    "uuid": "0aeb9e00-0335-4bed-878b-a31790d7251e",
    "hitokoto": "生活不可能像你想象得那么好，但也不会像你想象得那么糟。 我觉得人的脆弱和坚强都超乎自己的想象。 有时，我可能脆弱得一句话就泪流满面；有时，也发现自己咬着牙走了很长的路。",
    "type": "d",
    "from": "莫泊桑",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266258",
    "length": 84
  },
  {
    "id": 6869,
    "uuid": "34272309-9c1e-44fd-b63b-843091769634",
    "hitokoto": "有一个夜晚我烧毁了所有的记忆，从此我的梦就透明了；有一个早晨我扔掉了所有的昨天，从此我的脚步就轻盈了。",
    "type": "d",
    "from": "泰戈尔",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266280",
    "length": 51
  },
  {
    "id": 6870,
    "uuid": "3cb59a9c-433f-4fb5-b2f5-069109714ba0",
    "hitokoto": "那时我们有梦， 关于文学， 关于爱情， 关于穿越世界的旅行。 如今我们深夜饮酒，杯子碰到一起， 都是梦破碎的声音。",
    "type": "d",
    "from": "波兰来客",
    "from_who": "北岛",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266363",
    "length": 57
  },
  {
    "id": 6871,
    "uuid": "7cf3343a-8f70-44d6-997f-ca47f6c5ecf5",
    "hitokoto": "努力想得到什么东西，其实只要沉着镇静、实事求是，就可以轻易地、神不知鬼不觉地达到目的。而如果过于使劲，闹得太凶，太幼稚，太没有经验，就哭啊，抓啊，拉啊，像一个小孩扯桌布，结果却是一无所获，只不过把桌上的好东西都扯到地上，永远也得不到了。",
    "type": "d",
    "from": "卡夫卡",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266394",
    "length": 118
  },
  {
    "id": 6872,
    "uuid": "909b39e2-d2ac-499b-bc36-fefb0176039d",
    "hitokoto": "一个人只有在痛苦之中才能明白什么是真正属于自己的……只有在破碎之中，人才能认识自己。",
    "type": "d",
    "from": "贝内迪克特·韦尔斯",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266415",
    "length": 42
  },
  {
    "id": 6873,
    "uuid": "919490e0-3bc0-418b-98fd-72d4cd14f945",
    "hitokoto": "不相信世界就是这样，在明知道有的时候必须低头，有的人必将失去，有的东西命中注定不能长久的时候，依然要说，在第一千个选择之外，还有第一千零一个可能，有一扇窗等着我打开，然后有光透进来。",
    "type": "d",
    "from": "王小波 ​​​​ ​​​​",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266436",
    "length": 91
  },
  {
    "id": 6874,
    "uuid": "3108a0dd-a7e0-42ef-913f-b3d9a37def0e",
    "hitokoto": "我告诫自己：你的话说得太多，你听别人倾诉得太多，你喝咖啡喝得太多，你在陌生的房间里坐的时间太长，你的睡眠质量太差，你醒着的时间太长，你平庸的事想得太多，你希望过多，你安慰自己太频繁。",
    "type": "d",
    "from": "威廉·格纳齐诺",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266539",
    "length": 91
  },
  {
    "id": 6876,
    "uuid": "b16d964b-d4ff-4c21-bf7d-92cdd910d1a7",
    "hitokoto": "有多少人把性格交给星座，把努力交给鸡汤，把考试交给锦鲤，然后对自己说“听过很多道理，依然过不好这一生。",
    "type": "d",
    "from": "你一年的8760小时",
    "from_who": "艾力",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266647",
    "length": 51
  },
  {
    "id": 6877,
    "uuid": "e9290e0b-eb48-4992-87c3-451661b3ca3a",
    "hitokoto": "也许我爱的已不是你，而是对你付出的热情。就像一座神庙，即使荒芜，仍然是祭坛。一座雕像，即使坍塌，仍然是神。",
    "type": "d",
    "from": "莱蒙托夫",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266659",
    "length": 53
  },
  {
    "id": 6879,
    "uuid": "44565c95-c2c4-4ac0-8642-b751b484bc24",
    "hitokoto": "要逃避痛苦，最常见的，就是躲进未来。在时间的轨道上人们想象有一条线，超脱了这条线，当前的痛苦遍不复存在。",
    "type": "d",
    "from": "不能承受的生命之轻",
    "from_who": "米兰·昆德拉",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266694",
    "length": 52
  },
  {
    "id": 6880,
    "uuid": "9871ab24-acaf-4d26-9bb9-a11a099adb51",
    "hitokoto": "要快乐地面对一切挑战，哪怕恐惧渗入骨髓，因为就算我们是凡人，趁着还活在人世，就该绽放光彩。",
    "type": "d",
    "from": "被掩埋的巨人",
    "from_who": "石黑一雄",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266709",
    "length": 45
  },
  {
    "id": 6881,
    "uuid": "3fbd4752-14cf-4764-ba6f-fdf02978b4c2",
    "hitokoto": "目的虽有，却无路可循；我们称之为路的，无非是踌躇。",
    "type": "d",
    "from": "误入世界",
    "from_who": "卡夫卡",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266725",
    "length": 25
  },
  {
    "id": 6882,
    "uuid": "a4de328e-0645-446a-8ec6-aeeea7cc5d45",
    "hitokoto": "去看生活，去看世界； 去目击伟大的历史事件； 去看穷人的面孔和骄傲者的姿态； 去看不同寻常的事物——机器、军队、群众、以及丛林中和月球上的阴影； 去看人类的杰作——绘画、建筑和发明； 去看千里之外的世界，去看隐藏在高墙和房间内的事物，以及难以接近的危险事件； 去看那些被男人所爱着的女人们还有孩子；去看并且享受愉悦； 去看并被感动； 去看并被教育……",
    "type": "d",
    "from": "《LIFE》创刊词",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266760",
    "length": 175
  },
  {
    "id": 6883,
    "uuid": "c027e89a-4298-45df-b773-127952a0f194",
    "hitokoto": "于千万人之中遇见你所要遇见的人，于千万年之中，时间的无涯的荒野里，没有早一步，也没有晚一步，刚巧赶上了，那也没有别的话可说，惟有轻轻地问一声：“噢，你也在这里吗？”。",
    "type": "d",
    "from": "爱",
    "from_who": "张爱玲",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266778",
    "length": 83
  },
  {
    "id": 6884,
    "uuid": "71aa23b0-4ac7-424d-8cfe-3f10ddc9b39a",
    "hitokoto": "我们就是梦幻所用的材料，一场睡梦环抱了短促的人生。",
    "type": "d",
    "from": "莎士比亚",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266791",
    "length": 25
  },
  {
    "id": 6885,
    "uuid": "d6532fdb-dc50-4f75-b338-3ddbdce49d1a",
    "hitokoto": "少为纨绔子弟，极爱繁华，好精舍，好美婢，好娈童，好鲜衣，好美食，好骏马，好华灯，好烟火，好梨园，好鼓吹，好古董，好花鸟，兼以茶淫橘虐，书蠹诗魔，劳碌半生，皆成梦幻。年至五十，国破家亡，避迹山居。所存者，破床碎几，折鼎病琴，与残书数帙，缺砚一方而已。布衣疏莨，常至断炊。回首二十年前，真如隔世。",
    "type": "d",
    "from": "自为墓志铭",
    "from_who": "张岱",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266809",
    "length": 146
  },
  {
    "id": 6886,
    "uuid": "00d92ad6-0580-4fa0-96d5-7e936cc5bd00",
    "hitokoto": "一个人爱你的最高形式是/接得住你所有的负面情绪/因为说我爱你很容易 买一两次东西也很容易/接吻很容易/拥抱很容易/但在面对你一次又一次负面情绪的时候/不是不耐烦/也不是表面礼貌/是很难的/就像你皱眉的时候 我会觉得心疼/总觉得这个世界给你的不够",
    "type": "d",
    "from": "半句再见（歌曲）",
    "from_who": "吴子云",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266832",
    "length": 122
  },
  {
    "id": 6887,
    "uuid": "a0a394fd-0191-4871-8177-830437be03f6",
    "hitokoto": "他有属于他自己的孤独，所谓的心心相通， 都只是一场误会。",
    "type": "d",
    "from": "心是孤独的猎手",
    "from_who": "卡森·麦卡勒斯",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266856",
    "length": 28
  },
  {
    "id": 6888,
    "uuid": "8bd20fa4-514e-49b7-bc44-52db19226b82",
    "hitokoto": "恨台上卿卿，或台下我我，不是我跟你；俗尘渺渺，天意茫茫，将你我分开；断肠字点点，风雨声连连，似是故人来。",
    "type": "d",
    "from": "似是故人来",
    "from_who": "梅艳芳",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266868",
    "length": 52
  },
  {
    "id": 6890,
    "uuid": "50f7a395-ed36-461b-963f-f0cd9c04ca40",
    "hitokoto": "“你最可爱”，我说时来不及思索，而思索之后，还是这样说。",
    "type": "d",
    "from": "你多么可爱",
    "from_who": "普希金",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266901",
    "length": 28
  },
  {
    "id": 6895,
    "uuid": "9cf7468e-93c2-4286-99c9-f4a8cbf172c2",
    "hitokoto": "The best way to predict your future is to create it.",
    "type": "d",
    "from": "Abraham Lincol",
    "from_who": null,
    "creator": "Spectre",
    "creator_uid": 7965,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607507734",
    "length": 52
  },
  {
    "id": 6913,
    "uuid": "499af7a7-0e04-4151-aaad-bf25f47a3865",
    "hitokoto": "所谓无底深渊，下去，也是前程万里。",
    "type": "d",
    "from": "素履之往",
    "from_who": "木心",
    "creator": "SquareBlock",
    "creator_uid": 7985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608429507",
    "length": 17
  },
  {
    "id": 6924,
    "uuid": "17090894-67b6-47bf-b7a8-dbf5d5042496",
    "hitokoto": "当我沉默的时候，我觉得很充实，当我开口说话，就感到了空虚。",
    "type": "d",
    "from": "野草・题辞",
    "from_who": "鲁迅",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609720944",
    "length": 29
  },
  {
    "id": 6925,
    "uuid": "3bf6c843-a3c0-4236-884e-3266dc783acf",
    "hitokoto": "我寄你的信，总要送往邮局，不喜欢放在街边的绿色邮筒中，我总疑心那里会慢一点。",
    "type": "d",
    "from": "两地书",
    "from_who": "鲁迅",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609721093",
    "length": 38
  },
  {
    "id": 6926,
    "uuid": "ccd285bc-28ab-40b0-b0cf-df3cd27674c2",
    "hitokoto": "人生有时难免会陷入困境，但人的高贵在于，困境中依然保持操守，决不能放纵自我，任错误的欲望泛滥。",
    "type": "d",
    "from": "朝花夕拾",
    "from_who": "鲁迅",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609721132",
    "length": 47
  },
  {
    "id": 6927,
    "uuid": "b6968d93-0fdd-47ec-8f21-b10fae5ca8f9",
    "hitokoto": "当我沉默着的时候，我觉得充实，我将开口，同时感到空虚。",
    "type": "d",
    "from": "野草・题辞",
    "from_who": "鲁迅",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609721167",
    "length": 27
  },
  {
    "id": 6928,
    "uuid": "0826cddc-2b2a-4733-b1f2-a869337b5073",
    "hitokoto": "心似已灰之木，身如不系之舟。问汝平生功业，黄州惠州儋州。",
    "type": "d",
    "from": "自题金山画像",
    "from_who": "苏轼",
    "creator": "Cat",
    "creator_uid": 5756,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609761977",
    "length": 28
  },
  {
    "id": 6935,
    "uuid": "f5deb979-0cde-4641-84ae-a70ce4c8976f",
    "hitokoto": "钟表走着同样的节拍，夜晚缀着同一簇星星。",
    "type": "d",
    "from": "情歌",
    "from_who": "加西亚·洛尔迦",
    "creator": "Cat",
    "creator_uid": 5756,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610360428",
    "length": 20
  },
  {
    "id": 6937,
    "uuid": "998877d7-a441-45a0-9987-083374234cd1",
    "hitokoto": "我相信群众的革命意识最终会将革命之火带回。",
    "type": "d",
    "from": "萨布林写给他父母的告别信",
    "from_who": "瓦列里•萨布林",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610465292",
    "length": 21
  },
  {
    "id": 6938,
    "uuid": "e08d2eb9-c79d-4822-86c0-fb3c35686754",
    "hitokoto": "群体只会干两件事，锦上添花或者落井下石。",
    "type": "d",
    "from": "乌合之众",
    "from_who": "古斯塔夫·勒庞",
    "creator": "人间富婆",
    "creator_uid": 7529,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610672672",
    "length": 20
  },
  {
    "id": 6942,
    "uuid": "a05e295e-c394-4aa8-8596-abc0453bb557",
    "hitokoto": "所言是，虽盗跋之语不可为非；所言非，虽尧舜之语不可为是。",
    "type": "d",
    "from": "庄子·外篇· 箧第十",
    "from_who": "庄子",
    "creator": "Clementine2019",
    "creator_uid": 8137,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610877046",
    "length": 28
  },
  {
    "id": 6951,
    "uuid": "2a040392-200f-4a70-91f7-d88f4903bf8b",
    "hitokoto": "无论对谁太过热情，就增加了不被珍惜的概率。倘若没有过度的欢喜，便不会有极度的悲伤。",
    "type": "d",
    "from": "人间失格",
    "from_who": "太宰治",
    "creator": "epicmo",
    "creator_uid": 6557,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611386107",
    "length": 41
  },
  {
    "id": 6971,
    "uuid": "f7c9715d-38d6-4aff-8bec-ef22f09353c4",
    "hitokoto": "落霞与孤鹜齐飞，秋水共长天一色。",
    "type": "d",
    "from": "滕王阁序",
    "from_who": "王勃",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613568199",
    "length": 16
  },
  {
    "id": 6972,
    "uuid": "85f95c52-2d6b-4814-9fe5-3d76b718b9fd",
    "hitokoto": "今南方已定，兵甲已足，当奖率三军，北定中原，庶竭驽钝，攘除奸凶，兴复汉室，还于旧都。此臣所以报先帝而忠陛下之职分也。",
    "type": "d",
    "from": "前出师表",
    "from_who": "诸葛亮",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613568353",
    "length": 58
  },
  {
    "id": 6973,
    "uuid": "e472f82c-63b6-4a91-8718-8c391330b595",
    "hitokoto": "醉翁之意不在酒，在乎山水之间也。",
    "type": "d",
    "from": "醉翁亭记",
    "from_who": "欧阳修",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613570482",
    "length": 16
  },
  {
    "id": 6974,
    "uuid": "a628aed0-5fca-4629-8d99-290df7803ce9",
    "hitokoto": "宁教我负天下人，休教天下人负我。",
    "type": "d",
    "from": "三国演义",
    "from_who": "曹操",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613570544",
    "length": 16
  },
  {
    "id": 6975,
    "uuid": "142f44cd-3dd8-47db-8188-54f53c3b5526",
    "hitokoto": "月出于东山之上，徘徊于斗牛之间。",
    "type": "d",
    "from": "前赤壁赋",
    "from_who": "苏轼",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613570569",
    "length": 16
  },
  {
    "id": 6989,
    "uuid": "3479e221-297f-429f-bada-b7e4bcb2e535",
    "hitokoto": "很多人在喧嚣声中登场，也有少数人在静默中退出。",
    "type": "d",
    "from": "单独中的洞见2，作家出版社",
    "from_who": "张方宇",
    "creator": "南婷婷",
    "creator_uid": 8367,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611846976",
    "length": 23
  },
  {
    "id": 6993,
    "uuid": "d5a3132a-1503-4aaf-a5a8-9b4fcff57c5e",
    "hitokoto": "如果有来生，希望每次相遇，都能化为永恒。",
    "type": "d",
    "from": "如果有来生",
    "from_who": "三毛",
    "creator": "莳昇",
    "creator_uid": 5608,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612143437",
    "length": 20
  },
  {
    "id": 6997,
    "uuid": "0b3b002a-2fc9-473c-8894-13bb69d3734f",
    "hitokoto": "恐惧意味着“软弱”。",
    "type": "d",
    "from": "秒速5厘米",
    "from_who": "新海诚",
    "creator": "麻婆豆腐",
    "creator_uid": 8368,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1612192869",
    "length": 10
  },
  {
    "id": 6998,
    "uuid": "4f115cdd-6110-4059-8d8d-ebaddbad89f5",
    "hitokoto": "忍无可忍意味着自暴自弃。",
    "type": "d",
    "from": "秒速5厘米",
    "from_who": "新海诚",
    "creator": "麻婆豆腐",
    "creator_uid": 8368,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1612192913",
    "length": 12
  },
  {
    "id": 6999,
    "uuid": "aa803308-d5e8-4138-9f5f-a023170ee5d8",
    "hitokoto": "如期待奇迹发生，那唯有不停伸手去抓紧，去把握才行。",
    "type": "d",
    "from": "秒速5厘米",
    "from_who": "新海诚",
    "creator": "麻婆豆腐",
    "creator_uid": 8368,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1612193022",
    "length": 25
  },
  {
    "id": 7009,
    "uuid": "9133e1b0-ddf3-429d-af44-9414dd6d0e68",
    "hitokoto": "我本可以忍受黑暗，如果我不曾见过光明。",
    "type": "d",
    "from": "如果我不曾见过太阳",
    "from_who": "艾米莉·狄金森",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612286206",
    "length": 19
  },
  {
    "id": 7013,
    "uuid": "b9328d5f-73eb-492e-bbfb-7c18b4672f0c",
    "hitokoto": "因为从心底害怕自己不值得被爱，我们独来独往，……，然而就是因为独来独往，才让我们以为自己不值得被爱。有一天你不知道是什么时候，你会驱车上路。有一天，你不知道是什么时候，你会遇到他（她）。你会被爱，因为你今生第一次真正不再孤单。你会选择不再孤单下去。",
    "type": "d",
    "from": "島上書店",
    "from_who": "嘉布莉·丽文",
    "creator": "零貳",
    "creator_uid": 8421,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612354458",
    "length": 124
  },
  {
    "id": 7022,
    "uuid": "6e4578ad-48c3-486e-9e4f-2af551744fbe",
    "hitokoto": "人类一思考，上帝就发笑。",
    "type": "d",
    "from": "生命中不可承受之轻",
    "from_who": "米兰·昆德拉",
    "creator": "286799714",
    "creator_uid": 8426,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612663507",
    "length": 12
  },
  {
    "id": 7025,
    "uuid": "90ba8260-ca2d-43ef-b8bd-aed5273e280e",
    "hitokoto": "心之所向，素履以往。",
    "type": "d",
    "from": "尘曲",
    "from_who": "七堇年",
    "creator": "dfxlm",
    "creator_uid": 8553,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613811981",
    "length": 10
  },
  {
    "id": 7030,
    "uuid": "25dc5139-7851-4e7b-a75d-e88182a76e2d",
    "hitokoto": "生有八苦，死历九相。世上哪有什么最苦的事情？卵巢彩票抽中了为人，悲欣交集，懵懂仓促地过了一生。",
    "type": "d",
    "from": "童童",
    "from_who": null,
    "creator": "卖破烂大户",
    "creator_uid": 8103,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613444830",
    "length": 47
  },
  {
    "id": 7031,
    "uuid": "694a443f-788c-4738-9cb4-9e8d494a010e",
    "hitokoto": "诚如是，则霸业可成，汉室可兴矣！",
    "type": "d",
    "from": "三国志·蜀志·诸葛亮传",
    "from_who": "陈寿",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613568155",
    "length": 16
  },
  {
    "id": 7042,
    "uuid": "29fbb5fa-7f8b-476f-8b4e-77d8343f5afc",
    "hitokoto": "亮，再不能临阵讨贼矣。悠悠苍天，何薄于我！",
    "type": "d",
    "from": "三国演义",
    "from_who": "诸葛亮",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613570600",
    "length": 21
  },
  {
    "id": 7043,
    "uuid": "513371d0-b180-4478-a942-f0b8d3d7f6fe",
    "hitokoto": "活在这珍贵的人间，太阳强烈，水波温柔。",
    "type": "d",
    "from": "活在这珍贵的人间",
    "from_who": "海子",
    "creator": "luo",
    "creator_uid": 8515,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613621820",
    "length": 19
  },
  {
    "id": 7044,
    "uuid": "f1a61de7-9e79-4f97-9e03-bd06f38262e4",
    "hitokoto": "浮世三千，吾有三爱，日月与卿，日为朝，月为暮，卿为朝朝暮暮。",
    "type": "d",
    "from": "飞鸟集",
    "from_who": "泰戈尔",
    "creator": "oxyde",
    "creator_uid": 8531,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613587338",
    "length": 30
  },
  {
    "id": 7045,
    "uuid": "7f1ef15a-efc2-454b-8334-60dc2f38806c",
    "hitokoto": "对未来的真正慷慨，是把一切献给现在。",
    "type": "d",
    "from": "反抗者",
    "from_who": "加缪",
    "creator": "luo",
    "creator_uid": 8515,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613621941",
    "length": 18
  },
  {
    "id": 7049,
    "uuid": "2bc8b2d1-a3e1-4a26-8853-9c80fcb35126",
    "hitokoto": "明明会让人联想到生命、升腾和创造的火焰，其实是痛苦凝结成的实质。 火焰，即痛苦。",
    "type": "d",
    "from": "寂静王冠",
    "from_who": "夏尔",
    "creator": "CBS",
    "creator_uid": 8538,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613697549",
    "length": 40
  },
  {
    "id": 7050,
    "uuid": "15fbd704-36ba-428d-843b-61047026d024",
    "hitokoto": "恰当的礼仪、端正的面貌与自由的意志，乃是人性的精髓。",
    "type": "d",
    "from": "寂静王冠",
    "from_who": "麦克斯韦",
    "creator": "CBS",
    "creator_uid": 8538,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613698863",
    "length": 26
  },
  {
    "id": 7051,
    "uuid": "704fcbc6-5bfa-4ccc-b542-00e298793b5b",
    "hitokoto": "就是错误，哪怕是为了所谓顾全大局，错误必须迎来清算，否则正确便没有存在的意义。",
    "type": "d",
    "from": "寂静王冠",
    "from_who": "麦克斯韦",
    "creator": "CBS",
    "creator_uid": 8538,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613699016",
    "length": 39
  },
  {
    "id": 7052,
    "uuid": "7a0ff1d0-c3eb-4b0c-9b2b-748774bbabdf",
    "hitokoto": "陛下，愿您逝去的魂灵驰骋于星空之中，如您驰骋于这地上……可惜，再无家火可供您栖息。",
    "type": "d",
    "from": "寂静王冠",
    "from_who": "卡古里拉",
    "creator": "CBS",
    "creator_uid": 8538,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613699822",
    "length": 41
  },
  {
    "id": 7054,
    "uuid": "9ff0eef3-c441-4bb9-9cdc-0b3ab154bd1d",
    "hitokoto": "生命中所有的灿烂，终究要用寂寞去偿还。",
    "type": "d",
    "from": "百年孤独",
    "from_who": "加夫列尔·加西亚·马尔克斯",
    "creator": "金yin",
    "creator_uid": 8544,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613738163",
    "length": 19
  },
  {
    "id": 7069,
    "uuid": "d1a48d5d-8e83-48c7-a24e-bbb529039ffe",
    "hitokoto": "直到这时我才聊以忘却那无法形容的疲劳和倦怠，以及那不可思议的、庸碌而无聊的人生。",
    "type": "d",
    "from": "橘子",
    "from_who": "芥川龙之介",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613910044",
    "length": 40
  },
  {
    "id": 7070,
    "uuid": "58c57cab-7c2f-432d-998b-bc95809a2ca3",
    "hitokoto": "胆小者连幸福都害怕，碰到棉花也会受伤。",
    "type": "d",
    "from": "人间失格",
    "from_who": "太宰治",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613910090",
    "length": 19
  },
  {
    "id": 7072,
    "uuid": "f6468538-1b30-4f35-ac76-68065cad19a5",
    "hitokoto": "希望和绝望本是同样的东西，都是心怀期待而无法实现，只不过从两面冠以不同的名字罢了。",
    "type": "d",
    "from": "86-不存在的战区",
    "from_who": "蕾娜",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613910459",
    "length": 41
  },
  {
    "id": 7076,
    "uuid": "02555383-202a-455b-89f4-a89ba1098c25",
    "hitokoto": "世界上只有一种英雄主义,就是看清生活的真相之后依然热爱生活。",
    "type": "d",
    "from": "名人名言",
    "from_who": "罗曼罗兰",
    "creator": "Knight-423",
    "creator_uid": 8572,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614070344",
    "length": 30
  },
  {
    "id": 7080,
    "uuid": "0c98599c-f2c2-42f7-9b94-e415948743cd",
    "hitokoto": "不能因为第一次飞翔遇到了乌云风暴，从此就怀疑有蓝天彩霞。我们应当正视现实，不必以海市蜃楼里的绿洲，去覆盖地上的沙漠。",
    "type": "d",
    "from": "西线轶事",
    "from_who": "徐怀中",
    "creator": "负雨",
    "creator_uid": 6885,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1614147398",
    "length": 58
  },
  {
    "id": 7084,
    "uuid": "cdedb62d-ef43-4391-9bed-7471882294e4",
    "hitokoto": "所有的部落都已消失，所有的长矛都已折断，在这里，我们曾经饮露餐花，而你们，却撒下一片砾石。",
    "type": "d",
    "from": "三体III: 死神永生",
    "from_who": "刘慈欣",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1620546429",
    "length": 45
  },
  {
    "id": 7097,
    "uuid": "bbb951a3-6e46-4fb6-b047-2cc0efe5623f",
    "hitokoto": "少年去游荡，中年想掘藏，老年做和尚。",
    "type": "d",
    "from": "《活着》",
    "from_who": "余华",
    "creator": "yycz",
    "creator_uid": 8451,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615695967",
    "length": 18
  },
  {
    "id": 7098,
    "uuid": "fb15d6a3-6aaf-4cf9-8068-33fbcd1feeba",
    "hitokoto": "路漫漫其修远兮，吾将上下而求索。",
    "type": "d",
    "from": "离骚",
    "from_who": "屈原",
    "creator": "Lucas",
    "creator_uid": 8756,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615951178",
    "length": 16
  },
  {
    "id": 7108,
    "uuid": "bfe01162-c0c6-47d6-9b91-52089ac8f966",
    "hitokoto": "向之所欣，俯仰之间，已为陈迹。",
    "type": "d",
    "from": "兰亭集序",
    "from_who": "王羲之",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616759745",
    "length": 15
  },
  {
    "id": 7109,
    "uuid": "c412f734-34be-41d2-b104-da00d287fe18",
    "hitokoto": "乃知一死生为虚诞，齐彭殇为妄作。",
    "type": "d",
    "from": "兰亭集序",
    "from_who": "王羲之",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616759925",
    "length": 16
  },
  {
    "id": 7119,
    "uuid": "baaf6cd0-0ba2-4128-979c-b25fbe25c1b6",
    "hitokoto": "她那时候还太年轻,不知道所有命运赠予的礼物,早已在暗中标好了价格。",
    "type": "d",
    "from": "断头皇后",
    "from_who": "茨威格",
    "creator": "Aaron-Alison",
    "creator_uid": 9054,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619082206",
    "length": 33
  },
  {
    "id": 7120,
    "uuid": "8ccea8ba-58d5-4715-8d4d-cbeb338ece5a",
    "hitokoto": "She was still too young to know that life never gives anything for nothing, and that a price is always exacted for what fate bestows.",
    "type": "d",
    "from": "Marie Antoinette: Bildnis eines mittleren",
    "from_who": "Stefan Zweig",
    "creator": "Aaron-Alison",
    "creator_uid": 9054,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619082248",
    "length": 133
  },
  {
    "id": 7128,
    "uuid": "573e7b58-d71f-42a6-811e-1bb9ff00cfb4",
    "hitokoto": "生命本没有意义，你要能给它什么意义，它就有什么意义。",
    "type": "d",
    "from": "人生有何意义",
    "from_who": "胡适",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1613910298",
    "length": 26
  },
  {
    "id": 7132,
    "uuid": "3a62e87f-e7d9-4549-9b51-4a8258b275aa",
    "hitokoto": "苟富贵，毋相忘。",
    "type": "d",
    "from": "史记",
    "from_who": "司马迁",
    "creator": "伊稚斜",
    "creator_uid": 8593,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614222878",
    "length": 8
  },
  {
    "id": 7134,
    "uuid": "70d44248-63ad-4d2b-81a0-6b95b5e09a64",
    "hitokoto": "未来是绝对不变的。再怎么挣扎，都无法改变故事最终的结局。",
    "type": "d",
    "from": "侦探已经死了",
    "from_who": "米娅·惠特洛克",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614340647",
    "length": 28
  },
  {
    "id": 7135,
    "uuid": "06e3ccb1-25d5-4938-8502-f5acf21237c2",
    "hitokoto": "悲观的面对生命，乐观的面对生活。",
    "type": "d",
    "from": "张慧腾",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614086748",
    "length": 16
  },
  {
    "id": 7140,
    "uuid": "d8dd895a-3af4-49e1-a746-de1d6df7e93e",
    "hitokoto": "这个世界上，有种名为死后文的奇迹。",
    "type": "d",
    "from": "死后文",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614341584",
    "length": 17
  },
  {
    "id": 7145,
    "uuid": "57f991d6-15f9-4a6c-b3db-25d2f939f691",
    "hitokoto": "曾经沧海难为水，除却巫山不是云。",
    "type": "d",
    "from": "离思五首·其四",
    "from_who": "元稹",
    "creator": "Hacbox",
    "creator_uid": 8608,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614353730",
    "length": 16
  },
  {
    "id": 7146,
    "uuid": "984b53b1-bfec-4752-a0ae-f4a02d1f201b",
    "hitokoto": "我所理解的生活就是和喜欢的一切在一起。",
    "type": "d",
    "from": "《我所理解的生活》",
    "from_who": "韩寒",
    "creator": "慕瑾",
    "creator_uid": 7588,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619436251",
    "length": 19
  },
  {
    "id": 7147,
    "uuid": "011d386e-a35a-4d24-bdfa-a86368743b57",
    "hitokoto": "你之所以相信一个人说的话,是因为他说了你想听的话。",
    "type": "d",
    "from": "《摆渡人》",
    "from_who": "克莱儿·麦克福尔",
    "creator": "慕瑾",
    "creator_uid": 7588,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619436362",
    "length": 25
  },
  {
    "id": 7148,
    "uuid": "6087eac0-71d7-42e3-911c-27799b84b42d",
    "hitokoto": "悲伤就如湖面上波纹，在心中扩散开来。",
    "type": "d",
    "from": "文学少女",
    "from_who": "井上心叶",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620046430",
    "length": 18
  },
  {
    "id": 7149,
    "uuid": "573fd817-7097-45ec-b273-931f53b3a1f6",
    "hitokoto": "云无心以出岫，鸟倦飞而知还。",
    "type": "d",
    "from": "归去来兮辞",
    "from_who": "陶渊明",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620047758",
    "length": 14
  },
  {
    "id": 7150,
    "uuid": "dd926c4e-a460-4859-92bf-af57e391021e",
    "hitokoto": "我也想要成为那种可以给别人带去幸福的人。",
    "type": "d",
    "from": "文学少女",
    "from_who": "朝仓美羽",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620043259",
    "length": 20
  },
  {
    "id": 7157,
    "uuid": "fa434ebd-08de-4bd3-8e2a-af5306d5cc93",
    "hitokoto": "我从不猜测，那是破坏思维的坏习惯。",
    "type": "d",
    "from": "福尔摩斯探案集",
    "from_who": "夏洛克·福尔摩斯",
    "creator": "云鹤深",
    "creator_uid": 8616,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614430319",
    "length": 17
  },
  {
    "id": 7159,
    "uuid": "77541131-2d1b-40f6-a5a7-8b7314c2d91a",
    "hitokoto": "小孩子，只要看到一点温柔的表情，很快就会亲近上。但是，一没看住，就不见了。连告别的机会都没有。",
    "type": "d",
    "from": "末日时在做什么？能不能再见一面？",
    "from_who": "费奥多尔·杰斯曼",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614513983",
    "length": 47
  },
  {
    "id": 7169,
    "uuid": "6883d72f-1d99-46a2-a565-f7fcf24faf62",
    "hitokoto": "如果说爱是谎言，那么一定是人类最温柔的发明。",
    "type": "d",
    "from": "不哭不哭，痛痛飞走吧",
    "from_who": "汤上瑞穗",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614945745",
    "length": 22
  },
  {
    "id": 7171,
    "uuid": "878321ac-f901-4b87-b536-2c121783de0f",
    "hitokoto": "这一切就是最坏的结局，因为终有一天，这里只会剩下孤独的仰望半月的夜空而独自悲叹的人。",
    "type": "d",
    "from": "仰望半月的夜空",
    "from_who": "桥本纺",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946265",
    "length": 42
  },
  {
    "id": 7176,
    "uuid": "390c03c1-bd8a-498a-af4e-0e8962894e43",
    "hitokoto": "为了和你再次相见……仅此而已！而你，你却……打算把这说成是偶然！不要小看他人的思念啊！",
    "type": "d",
    "from": "侦探已经死了",
    "from_who": "夏凪渚",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946875",
    "length": 43
  },
  {
    "id": 7177,
    "uuid": "10ad8b56-e733-4939-9aed-05588dbd7542",
    "hitokoto": "我的父亲不论是敌是友，都为他们祈祷。战争不是敌人与朋友的问题。这是超越了人的种族，身份，关于生命的问题。",
    "type": "d",
    "from": "在耶路撒冷文学奖颁奖典礼上的演讲稿",
    "from_who": "村上春树",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614947138",
    "length": 52
  },
  {
    "id": 7178,
    "uuid": "d7c292e3-89b4-4568-91ed-b1565d76dd4b",
    "hitokoto": "假如有人问我烦扰的缘故，我不敢说出你的名字。",
    "type": "d",
    "from": "烦忧",
    "from_who": "戴望舒",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615030769",
    "length": 22
  },
  {
    "id": 7180,
    "uuid": "a000d28d-bcc0-46f0-90ff-c51c6093497f",
    "hitokoto": "我们已经不在乎战争是否能够胜利，甚至希望战争失败。只是希望能能够快一点回到你的身边。",
    "type": "d",
    "from": "GOSICK",
    "from_who": "樱庭一树",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614947039",
    "length": 42
  },
  {
    "id": 7183,
    "uuid": "5aeb3ee9-6bb1-4939-b000-85a87871cfdc",
    "hitokoto": "不知为向，明明想和你说话，却骗你说，风雨正好，该去写点诗句。",
    "type": "d",
    "from": "路人",
    "from_who": "西贝",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031003",
    "length": 30
  },
  {
    "id": 7184,
    "uuid": "eb153304-346a-4db1-849f-65a98ea19630",
    "hitokoto": "于千万人中，随时间无涯的荒野，既没有早到一步，也没晚到一步，遇见了。",
    "type": "d",
    "from": "爱",
    "from_who": "张爱玲",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031046",
    "length": 34
  },
  {
    "id": 7185,
    "uuid": "bcc861ff-d619-4e61-8b6e-986328b53231",
    "hitokoto": "我娶你来不是让你来做家务事的，你就坐着呆着，不想写诗不想读书不想操琴，就听风看云晒太阳。",
    "type": "d",
    "from": "柳如是",
    "from_who": "柳如是",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031095",
    "length": 44
  },
  {
    "id": 7186,
    "uuid": "156794b8-11be-44cf-b12d-c8e0a6dbae14",
    "hitokoto": "鱼说，你看不到我眼中的泪，因为我在水中，水说，我能感觉到你的泪，因为你在我心中。",
    "type": "d",
    "from": "村上春树",
    "from_who": "村上春树",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031294",
    "length": 40
  },
  {
    "id": 7187,
    "uuid": "bc5b9bda-8828-40a3-b0da-582f43d305b3",
    "hitokoto": "即使我变得不再是我，即使我已变身为嗜血的凶徒，即使整个世界变成废墟，我仍然会用全部生命来爱你，至死不渝。",
    "type": "d",
    "from": "变身",
    "from_who": "东野圭吾",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031323",
    "length": 52
  },
  {
    "id": 7188,
    "uuid": "3e93d232-120e-43c3-b1b0-2d5f493aba36",
    "hitokoto": "孤独不是一种脾性，而是一种无奈。",
    "type": "d",
    "from": "文化苦旅",
    "from_who": "余秋雨",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031379",
    "length": 16
  },
  {
    "id": 7189,
    "uuid": "130aaeab-67dd-4f12-bbb5-f8b4a6e7b45a",
    "hitokoto": "总有一阵风会吹过我再吹过你，总有一个瞬间我们之前的距离是零。",
    "type": "d",
    "from": "我们需要的",
    "from_who": "麦克斯·埃尔曼",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031425",
    "length": 30
  },
  {
    "id": 7190,
    "uuid": "2f2a8835-48d4-4c41-935f-2ee0bf692407",
    "hitokoto": "对待自己温柔一点。你只不过是宇宙的孩子，与植物、星辰没什么两样。",
    "type": "d",
    "from": "我们需要的",
    "from_who": "麦克斯·埃尔曼",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031475",
    "length": 32
  },
  {
    "id": 7191,
    "uuid": "566fcc46-e16d-40bf-a848-ee4cd2ad6d25",
    "hitokoto": "我追索人心的深度，却看到了人心的浅薄。",
    "type": "d",
    "from": "云雀叫了一整天",
    "from_who": "木心",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031669",
    "length": 19
  },
  {
    "id": 7194,
    "uuid": "fe1445b7-496c-4357-88c0-3d33ab806c90",
    "hitokoto": "你是非常可爱的人，真应该遇到最好的人，我也真希望我就是。",
    "type": "d",
    "from": "爱你就像爱生命",
    "from_who": "王小波",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031839",
    "length": 28
  },
  {
    "id": 7195,
    "uuid": "0ff382ec-2cec-484d-a8d6-e06e6b3d12ac",
    "hitokoto": "如果有来生，要做一棵树，站成永恒，没有悲欢的姿势。",
    "type": "d",
    "from": "说给自己听",
    "from_who": "三毛",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031904",
    "length": 25
  },
  {
    "id": 7196,
    "uuid": "0a9bccd8-452d-4405-9e45-ab129507404c",
    "hitokoto": "我爱哭的时候便哭，想笑的时候便笑，只要这一切出于自然。不求深刻，只求简单。",
    "type": "d",
    "from": "流星雨",
    "from_who": "三毛",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031976",
    "length": 37
  },
  {
    "id": 7197,
    "uuid": "a54daa54-236e-4977-9e93-68ebbd41005e",
    "hitokoto": "你就这样任性的走了进来，然后又温柔的走开，留下了温度和遗憾。我做云 ，你做月亮 ，我用两只手遮盖你，我们的屋顶就是青碧的天空出处。",
    "type": "d",
    "from": "新月集",
    "from_who": "泰戈尔",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615032086",
    "length": 65
  },
  {
    "id": 7202,
    "uuid": "ba7d943f-a90f-4252-822c-61c8f5a3b24c",
    "hitokoto": "必静必清，无劳女形。无摇女精，乃可以长生。",
    "type": "d",
    "from": "庄子·在宥",
    "from_who": "庄子",
    "creator": "北落师门",
    "creator_uid": 9123,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1619423656",
    "length": 21
  },
  {
    "id": 7204,
    "uuid": "3bc87fab-6e22-4382-bf42-9ec4175cf2e1",
    "hitokoto": "谁终将声震人间，必长久独自缄默；谁终将点燃闪电，必永恒如云漂泊。",
    "type": "d",
    "from": "敌基督者",
    "from_who": "尼采",
    "creator": "白衣卿相",
    "creator_uid": 8700,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615275387",
    "length": 32
  },
  {
    "id": 7205,
    "uuid": "ca1b8fa9-824d-4579-8c38-88cca1ae0314",
    "hitokoto": "月色与雪色之间，你是第三种绝色。日月与星辉之中，你是第四种难得。",
    "type": "d",
    "from": "绝色",
    "from_who": "余光中",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615384532",
    "length": 32
  },
  {
    "id": 7215,
    "uuid": "35883de6-e6dd-4a28-b07b-3e8753bb33ba",
    "hitokoto": "全世界无产者，联合起来！！！",
    "type": "d",
    "from": "共产党宣言",
    "from_who": "马克思、恩格斯",
    "creator": "Abyss",
    "creator_uid": 8803,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616846827",
    "length": 14
  },
  {
    "id": 7216,
    "uuid": "94b1694c-d5bd-4178-9cc0-5cbc5f235c05",
    "hitokoto": "上帝是个无耻的老赌徒，他抛弃了我们！",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "dzzzb",
    "creator_uid": 8853,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617085096",
    "length": 18
  },
  {
    "id": 7217,
    "uuid": "e703c756-d4ff-4300-a67e-d82b8d73bfd2",
    "hitokoto": "你的无畏来源于无知。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "dzzzb",
    "creator_uid": 8853,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617085056",
    "length": 10
  },
  {
    "id": 7221,
    "uuid": "7faf1a36-44eb-423c-93a4-c848262f2e75",
    "hitokoto": "心里全是苦的人，只需要一点点的甜就能填满。",
    "type": "d",
    "from": "起点-末日圆环",
    "from_who": "夜影恋姬",
    "creator": "IAbu",
    "creator_uid": 5895,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617017198",
    "length": 21
  },
  {
    "id": 7222,
    "uuid": "52ee30be-3f08-41c9-8462-5c973d8473f9",
    "hitokoto": "永远不要相信苦难是值得的，苦难就是苦难，苦难不会带来成功，苦难也不值得追求，磨练意志是因为苦难无法躲开。",
    "type": "d",
    "from": "活着",
    "from_who": "余华",
    "creator": "Hacbox",
    "creator_uid": 8608,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616906471",
    "length": 52
  },
  {
    "id": 7223,
    "uuid": "29e2fa83-7259-4939-99f8-2cf894d8296d",
    "hitokoto": "她太年轻了，殊不知命运馈赠的礼物已在暗地里标明了价格。",
    "type": "d",
    "from": "断头王后",
    "from_who": "斯蒂芬·茨威格",
    "creator": "亚亚努阿",
    "creator_uid": 8848,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617029583",
    "length": 27
  },
  {
    "id": 7231,
    "uuid": "84b17863-798d-4b2f-be69-44b281ce96c2",
    "hitokoto": "无际的太空就这样在它黑暗的怀抱中哺育出了黑暗的新人类。",
    "type": "d",
    "from": "三体：黑暗森林",
    "from_who": "刘慈欣",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620393375",
    "length": 27
  },
  {
    "id": 7232,
    "uuid": "5f2abe5e-5491-4b2d-827e-628018f1ef2f",
    "hitokoto": "越透明的东西越神秘，宇宙本身就是透明的，只要目力能及，你想看多远就看多远，但越看越神秘。",
    "type": "d",
    "from": "三体：黑暗森林",
    "from_who": "刘慈欣",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620393541",
    "length": 44
  },
  {
    "id": 7233,
    "uuid": "2e2bbc12-c2be-451a-b4d8-e9f68e719b8c",
    "hitokoto": "在这片森林中，他人就是地狱，就是永恒的威胁，任何暴露自己存在的生命都将很快被消灭，这就是宇宙文明的图景，这就是对费米悖论的解释。",
    "type": "d",
    "from": "三体：黑暗森林",
    "from_who": "刘慈欣",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620393710",
    "length": 64
  },
  {
    "id": 7234,
    "uuid": "138e30a2-07af-46f3-b020-37615f7d0f5d",
    "hitokoto": "对于所有生命来说，不会死亡的绝望，是最可怕的审判。",
    "type": "d",
    "from": "文学少女",
    "from_who": "天野远子",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620479800",
    "length": 25
  },
  {
    "id": 7235,
    "uuid": "b56c29ea-1a96-4564-b6d8-e1744f066098",
    "hitokoto": "写在书上的故事不会改变，过去的事同样不会改变。不过，未来可以改变！",
    "type": "d",
    "from": "文学少女",
    "from_who": "井上心叶",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620479873",
    "length": 33
  },
  {
    "id": 7236,
    "uuid": "2bc388d5-cc5c-4256-9850-c67f60ba0b5d",
    "hitokoto": "没有什么永远。其实大家都知道这个事实。所以才祈祷着永远。比起最终要来的结束，人们总是期望着不会改变的永远。",
    "type": "d",
    "from": "文学少女",
    "from_who": "井上心叶",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620479952",
    "length": 53
  },
  {
    "id": 7237,
    "uuid": "8e8f8c3b-59cf-4d36-8767-282fb88e2be4",
    "hitokoto": "永不改变的东西和美丽的东西也是存在的。",
    "type": "d",
    "from": "文学少女",
    "from_who": "井上心叶",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620480004",
    "length": 19
  },
  {
    "id": 7248,
    "uuid": "22bcc9cd-ec9a-4517-b948-10556121e2ee",
    "hitokoto": "天雨粟，夜鬼哭。",
    "type": "d",
    "from": "淮南子",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620990214",
    "length": 8
  },
  {
    "id": 7249,
    "uuid": "dbfdd7c5-ec78-4404-a81c-599c6df978a1",
    "hitokoto": "惟江上之清风，与山间之明月，耳得之而为声，目遇之而成色，取之无禁，用之不竭，是造物者之无尽藏也。",
    "type": "d",
    "from": "前赤壁赋",
    "from_who": "苏轼",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620991745",
    "length": 48
  },
  {
    "id": 7260,
    "uuid": "80efbd81-967f-426d-9212-5e5ff3a80a36",
    "hitokoto": "客亦知夫水与月乎？逝者如斯，而未尝往也；盈虚者如彼，而卒莫消长也。",
    "type": "d",
    "from": "前赤壁赋",
    "from_who": "苏轼",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620991764",
    "length": 33
  },
  {
    "id": 7261,
    "uuid": "2587c2a1-6de2-4e30-8fd2-80f8b0bc59fc",
    "hitokoto": "哀吾生之须臾，羡长江之无穷。挟飞仙以遨游，抱明月而长终。知不可乎骤得，托遗响于悲风。",
    "type": "d",
    "from": "前赤壁赋",
    "from_who": "苏轼",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620991788",
    "length": 42
  },
  {
    "id": 7283,
    "uuid": "78f191bb-33db-4225-bc05-617ab2157496",
    "hitokoto": "随着时间流逝，很多事情最后可能都会迎刃而解。",
    "type": "d",
    "from": "偷影子的人",
    "from_who": "马克·李维",
    "creator": "imfycc",
    "creator_uid": 9162,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1621090426",
    "length": 22
  },
  {
    "id": 7284,
    "uuid": "3489e414-115a-4b5c-be6d-9674c0a0ba86",
    "hitokoto": "其实最棒的回忆就在当下，在眼前，而且这会是人生最美好的时光。",
    "type": "d",
    "from": "偷影子的人",
    "from_who": "马克·李维",
    "creator": "imfycc",
    "creator_uid": 9162,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1621090374",
    "length": 30
  },
  {
    "id": 7289,
    "uuid": "2c7aff88-6e33-4195-9053-cac2d5159570",
    "hitokoto": "游戏是儿童最正当的行为，玩具是儿童的天使。",
    "type": "d",
    "from": "风筝",
    "from_who": "鲁迅",
    "creator": "Doge",
    "creator_uid": 9186,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620138398",
    "length": 21
  },
  {
    "id": 7291,
    "uuid": "a053daa5-c98b-47fb-a80f-c3c632a2f001",
    "hitokoto": "若能避开猛烈的欢喜，自然不会有悲痛来袭。",
    "type": "d",
    "from": "《人间失格》",
    "from_who": "太宰治",
    "creator": "楚歌儿",
    "creator_uid": 8920,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617706046",
    "length": 20
  },
  {
    "id": 7294,
    "uuid": "7dc307dd-2018-4757-b2a8-0f67cac63407",
    "hitokoto": "To be or not to be,this is a question.",
    "type": "d",
    "from": "哈姆莱特",
    "from_who": "莎士比亚",
    "creator": "Voyage.",
    "creator_uid": 8919,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617704061",
    "length": 38
  },
  {
    "id": 7295,
    "uuid": "5d766c9b-69a1-43ad-96ac-c606bdbaa07c",
    "hitokoto": "一切都将逝去，只有死神永生。",
    "type": "d",
    "from": "《三体》",
    "from_who": "刘慈欣",
    "creator": "宇智波派大星",
    "creator_uid": 9077,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619176942",
    "length": 14
  },
  {
    "id": 7306,
    "uuid": "b6bc6c5f-0dbe-4e74-b2f6-f63db96c01d9",
    "hitokoto": "一定要爱着点什么，恰似草木对光阴的钟情。",
    "type": "d",
    "from": "人间草木",
    "from_who": "汪曾祺",
    "creator": "AtomAlpaca",
    "creator_uid": 8873,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617544269",
    "length": 20
  },
  {
    "id": 7313,
    "uuid": "0e42475f-ea69-4993-a5d2-733a799e80da",
    "hitokoto": "世上只有一种英雄主义，那就是认清生活然后去热爱生活。",
    "type": "d",
    "from": "米开朗基罗传",
    "from_who": "罗兰.罗曼",
    "creator": "Erwin",
    "creator_uid": 5953,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619851721",
    "length": 26
  },
  {
    "id": 7325,
    "uuid": "379b0a14-4cc7-48d8-a9b9-b856265d14ed",
    "hitokoto": "众里寻他千百度，暮然回首，那人却在灯火阑珊处。",
    "type": "d",
    "from": "青玉案·元夕",
    "from_who": "辛弃疾",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621597135",
    "length": 23
  },
  {
    "id": 7326,
    "uuid": "82f8bfd2-8f0d-4b5f-b519-f3a3c22b556b",
    "hitokoto": "年华书写着故事，故事久存于心田。",
    "type": "d",
    "from": "演讲",
    "from_who": "唐艺铭",
    "creator": "Kaitou Kid",
    "creator_uid": 9041,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621347070",
    "length": 16
  },
  {
    "id": 7327,
    "uuid": "ddb66464-2c28-4254-8d3b-3670bbc1fefb",
    "hitokoto": "人是生而自由的，但却无往不在枷锁之中。",
    "type": "d",
    "from": "社会契约论",
    "from_who": "卢梭",
    "creator": "imfycc",
    "creator_uid": 9162,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621612484",
    "length": 19
  },
  {
    "id": 7337,
    "uuid": "8fea9671-d9c8-40d9-8648-de41a6f212db",
    "hitokoto": "每个人都是月亮，总有一个阴暗面，从来不让人看见。",
    "type": "d",
    "from": "　",
    "from_who": "马克·吐温",
    "creator": "yuanshuo",
    "creator_uid": 9418,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622429085",
    "length": 24
  },
  {
    "id": 7340,
    "uuid": "f847e26d-0817-47df-854a-4613bd6fb24e",
    "hitokoto": "如果有好感，那就是喜欢，如果这种好感经得起考验，那就是爱。",
    "type": "d",
    "from": "李宫俊的诗",
    "from_who": "李宫俊",
    "creator": "jiu",
    "creator_uid": 9403,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622252220",
    "length": 29
  },
  {
    "id": 7344,
    "uuid": "e88a7762-8b99-47b9-838c-63c0033d18ed",
    "hitokoto": "我们属于大地和海洋，你们属于星空。",
    "type": "d",
    "from": "三体",
    "from_who": "章北海",
    "creator": "Forever",
    "creator_uid": 9348,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622265652",
    "length": 17
  },
  {
    "id": 7351,
    "uuid": "46df9493-f6de-42fc-a630-b3f2350119bf",
    "hitokoto": "当混浊成为一种常态，清白便成为一种罪过。",
    "type": "d",
    "from": "盲观",
    "from_who": "盲观",
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623064894",
    "length": 20
  },
  {
    "id": 7375,
    "uuid": "88ed2393-8597-4bf1-a2ff-9ce903f8ead6",
    "hitokoto": "云的一生很简单，赶往一个它不再是云的地方，或者走着走着便不再是云。",
    "type": "d",
    "from": "客途",
    "from_who": "韩金谅",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625308906",
    "length": 33
  },
  {
    "id": 7383,
    "uuid": "11808c08-c06d-4844-8682-b580e9b01d03",
    "hitokoto": "我也晓得过苦楚，却无人渡我回家。",
    "type": "d",
    "from": "沈戚年随笔",
    "from_who": "沈戚年",
    "creator": "沈戚年",
    "creator_uid": 9646,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625545281",
    "length": 16
  },
  {
    "id": 7384,
    "uuid": "9acbab58-8b64-429f-b25b-f86841f0f4bb",
    "hitokoto": "纵星河万里，亦不及你一垂眸。",
    "type": "d",
    "from": "Samsara_soul",
    "from_who": "Samsara_soul",
    "creator": "Samsara_soul",
    "creator_uid": 9625,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625549984",
    "length": 14
  },
  {
    "id": 7385,
    "uuid": "32de89a5-bc2c-4c19-9628-4123aeb83b4c",
    "hitokoto": "生命的意义这件事，想必人类自己也不明白吧。",
    "type": "d",
    "from": "雨天的艾莉丝",
    "from_who": "莉莉丝",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616848158",
    "length": 21
  },
  {
    "id": 7388,
    "uuid": "7cbdfeae-389e-4b2d-bf09-78030561a1cb",
    "hitokoto": "冀以尘雾之微补益山海，荧烛末光增辉日月，是以敢冒其丑而献其忠。",
    "type": "d",
    "from": "三国志·魏书·任城陈萧王传",
    "from_who": "曹植",
    "creator": "雄鹰展翅",
    "creator_uid": 7520,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617293266",
    "length": 31
  },
  {
    "id": 7392,
    "uuid": "f73308aa-f315-43cb-8192-a648b6c437f5",
    "hitokoto": "人不是有机体的集合，是经历的集合。",
    "type": "d",
    "from": "我只喜欢你的人设",
    "from_who": "雉楚",
    "creator": "淮子饺河",
    "creator_uid": 8889,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617460301",
    "length": 17
  },
  {
    "id": 7397,
    "uuid": "634076f6-9b1b-40bc-90d0-2592f27d3b44",
    "hitokoto": "那一年，花开的不是最好，可是还好，我遇到你；那一年，花开的好极了，好像专是为了你；那一年，花开的很迟，还好，有你。",
    "type": "d",
    "from": "人间草木",
    "from_who": "汪曾祺",
    "creator": "AtomAlpaca",
    "creator_uid": 8873,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617543888",
    "length": 57
  },
  {
    "id": 7413,
    "uuid": "31df7e96-556a-4657-8fc6-ead3702129a7",
    "hitokoto": "执笔洇墨铸流年，仗剑酌酒碎绮梦",
    "type": "d",
    "from": "绘浮生",
    "from_who": "幻梦琉影",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625754440",
    "length": 15
  },
  {
    "id": 7417,
    "uuid": "017fb4f5-8a7c-49eb-adf3-84f1526b3fcf",
    "hitokoto": "八方各异气，千里殊风雨。",
    "type": "d",
    "from": "梁甫行",
    "from_who": "曹植",
    "creator": "jigeshuohua",
    "creator_uid": 10371,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1631331223",
    "length": 12
  },
  {
    "id": 7424,
    "uuid": "f38bd593-cc2a-4bc9-a187-380b8779b091",
    "hitokoto": "挚爱之人死去的时候，我必须杀死自己，除此之外，别无他法。然若如此，罪业深重，只好继续长生下去的话，便保有一份仕奉的心情。",
    "type": "d",
    "from": "春日狂想",
    "from_who": "中原中也",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1617968635",
    "length": 60
  },
  {
    "id": 7426,
    "uuid": "e048291f-28bb-4b6d-9c75-26338f6578da",
    "hitokoto": "能够生存下来的物种，并不是那些最强壮的，也不是那些最聪明的，而是那些对变化做出快速反应的。",
    "type": "d",
    "from": "物种的起源",
    "from_who": "查尔斯·达尔文",
    "creator": "phi",
    "creator_uid": 8974,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1618116928",
    "length": 45
  },
  {
    "id": 7427,
    "uuid": "d32c6205-129c-4955-b80b-c6b2f2ca8c08",
    "hitokoto": "我本可以忍受黑暗，如果我不曾见过太阳……然而阳光已使我的荒凉，成为更新的荒凉。",
    "type": "d",
    "from": "如果我不曾见过太阳",
    "from_who": "艾米丽·狄金斯",
    "creator": "A_Pi",
    "creator_uid": 8981,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1618137917",
    "length": 39
  },
  {
    "id": 7432,
    "uuid": "f884b077-6b23-491c-92d7-77de5edf5ade",
    "hitokoto": "有时候，真希望醒来现实不过是南柯一梦，一切回归虚无。",
    "type": "d",
    "from": "笑枫尘",
    "from_who": null,
    "creator": "三千|",
    "creator_uid": 9091,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619139752",
    "length": 26
  },
  {
    "id": 7448,
    "uuid": "9c830bec-46ad-4131-8161-48322697aa9e",
    "hitokoto": "离开了对人的关怀，教育分文不值。",
    "type": "d",
    "from": "从良老师",
    "from_who": null,
    "creator": "雄鹰展翅",
    "creator_uid": 7520,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619624389",
    "length": 16
  },
  {
    "id": 7455,
    "uuid": "02090214-7ae5-4490-88a7-1bc6c2ed6728",
    "hitokoto": "成长是学着接受，一个人向前进的同时也是失去的过程。",
    "type": "d",
    "from": "《时间的答案》",
    "from_who": "卢思浩",
    "creator": "Honey",
    "creator_uid": 9639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626940233",
    "length": 25
  },
  {
    "id": 7456,
    "uuid": "02dc209f-2c12-4e69-b2a6-aa3af9ec89f6",
    "hitokoto": "我们每个人都是往事的幸存者，最终学会的，都是如何和自己相处。",
    "type": "d",
    "from": "《时间的答案》",
    "from_who": "卢思浩",
    "creator": "Honey",
    "creator_uid": 9639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626940290",
    "length": 30
  },
  {
    "id": 7471,
    "uuid": "eaf6107f-55ce-4909-a6d2-baeaf003193d",
    "hitokoto": "我想要如清泉般的爱。",
    "type": "d",
    "from": "飞鸟集",
    "from_who": "泰戈尔",
    "creator": "朱佳熠",
    "creator_uid": 9963,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627917611",
    "length": 10
  },
  {
    "id": 7476,
    "uuid": "76eb7b0f-1987-46b5-8d3f-2b8b32f4a2da",
    "hitokoto": "宇宙很大，生活更大，也许以后还有缘相见。",
    "type": "d",
    "from": "三体",
    "from_who": "刘慈欣",
    "creator": "soap",
    "creator_uid": 9980,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628052367",
    "length": 20
  },
  {
    "id": 7478,
    "uuid": "2dbe81f0-f9e0-46b9-8934-3df604b015c4",
    "hitokoto": "华枝春满，天心月圆。",
    "type": "d",
    "from": "偈语",
    "from_who": "弘一法师",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628339668",
    "length": 10
  },
  {
    "id": 7479,
    "uuid": "04dedfef-71ec-4afa-abbe-0ec6f5f137e4",
    "hitokoto": "言念君子，温其如玉。",
    "type": "d",
    "from": "《诗经·国风·秦风·小戎》",
    "from_who": "《诗经》",
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628693900",
    "length": 10
  },
  {
    "id": 7484,
    "uuid": "bdac74d1-fbe3-4718-884f-e3c12c977c04",
    "hitokoto": "人类起源于信仰，毁于信仰，人们在信仰的余烬里重生。",
    "type": "d",
    "from": "《残次品》",
    "from_who": null,
    "creator": "城",
    "creator_uid": 10085,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628835441",
    "length": 25
  },
  {
    "id": 7485,
    "uuid": "df4f8ffd-f025-40fb-9f87-c9fcefbe8757",
    "hitokoto": "先挑起清风明月，杨柳依依和草长莺飞，少年郎的肩头，本就应当满是美好的事物啊！",
    "type": "d",
    "from": "《剑来》",
    "from_who": "烽火戏诸侯",
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628694301",
    "length": 38
  },
  {
    "id": 7486,
    "uuid": "882b4169-6210-493a-8924-4dce5c4e9fbc",
    "hitokoto": "你说，如果我们这样在雪中一直走下去，是不是会走到了白头……",
    "type": "d",
    "from": "求魔",
    "from_who": "苏铭",
    "creator": "简夜",
    "creator_uid": 4167,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629013094",
    "length": 29
  },
  {
    "id": 7487,
    "uuid": "0a7120e3-9861-4b2d-8df5-2f5bf739c254",
    "hitokoto": "将自己不安急躁的一面展现给对手，你未战便已经输了三分！",
    "type": "d",
    "from": "《极品公子》",
    "from_who": "烽火戏诸侯",
    "creator": "Morning Dew",
    "creator_uid": 9775,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629181035",
    "length": 27
  },
  {
    "id": 7488,
    "uuid": "674136a6-44e9-4897-b5a4-45066eb165f3",
    "hitokoto": "所有苦难与背负的尽头，都是行云流水般的此世光阴。",
    "type": "d",
    "from": "《大哥》",
    "from_who": "Priest",
    "creator": "Morning Dew",
    "creator_uid": 9775,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629181427",
    "length": 24
  },
  {
    "id": 7496,
    "uuid": "9263d91f-ccfa-4dc0-847f-93161c8c9769",
    "hitokoto": "喜欢上你，是良性的破窗效应。",
    "type": "d",
    "from": "原创",
    "from_who": null,
    "creator": "一只漓子",
    "creator_uid": 10154,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629306389",
    "length": 14
  },
  {
    "id": 7498,
    "uuid": "78224767-827b-41ea-8bc1-cb7aeebf439a",
    "hitokoto": "我所描绘的一切或许并非真实，然而我的感受绝无虚假。",
    "type": "d",
    "from": "妄想症Paranoia",
    "from_who": "雨狸",
    "creator": "禾泱",
    "creator_uid": 10181,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629604566",
    "length": 25
  },
  {
    "id": 7499,
    "uuid": "8bb4bc1c-8ce7-4f42-8e48-1d1ac8b1ea56",
    "hitokoto": "我心里有一簇迎着烈日而生的花，比一切美酒都要芬芳，滚烫的馨香淹没过稻草人的胸膛，草扎的精神，从此万寿无疆。",
    "type": "d",
    "from": "默读",
    "from_who": "Priest",
    "creator": "禾泱",
    "creator_uid": 10181,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629606553",
    "length": 53
  },
  {
    "id": 7502,
    "uuid": "ca89edf3-d745-4b14-a6cc-abe6b80c56d7",
    "hitokoto": "所有命运的馈赠，早已暗中标注好了价码。",
    "type": "d",
    "from": "断头皇后",
    "from_who": "茨威格",
    "creator": "刘七",
    "creator_uid": 10039,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629971463",
    "length": 19
  },
  {
    "id": 7504,
    "uuid": "058256a3-49ef-454c-ad80-7e3f6940d83d",
    "hitokoto": "山川异域，风月同天。",
    "type": "d",
    "from": "唐大和上东征传",
    "from_who": "真人元开",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630166069",
    "length": 10
  },
  {
    "id": 7505,
    "uuid": "9aadb901-c0f5-42b6-b167-2513584cc438",
    "hitokoto": "欲报相思时，君已拂袖去，为伊消得人憔悴，悔恨曾今时。",
    "type": "d",
    "from": "遗忘",
    "from_who": "轮回",
    "creator": "scott",
    "creator_uid": 10246,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630205978",
    "length": 26
  },
  {
    "id": 7509,
    "uuid": "d5c01da4-b26c-4340-8a17-9a638f33bd0e",
    "hitokoto": "纵有千古，横有八荒。前途似海，来日方长。",
    "type": "d",
    "from": "少年中国说",
    "from_who": "梁启超",
    "creator": "Hacker",
    "creator_uid": 10339,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630930907",
    "length": 20
  },
  {
    "id": 7511,
    "uuid": "c518dbf6-c0a9-438a-9c0d-82d9e25eb8d0",
    "hitokoto": "遇事不决，可问春风，春风不语，遵循己心。",
    "type": "d",
    "from": "剑来",
    "from_who": "烽火戏诸侯",
    "creator": "渡鸦",
    "creator_uid": 10346,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630988286",
    "length": 20
  },
  {
    "id": 7515,
    "uuid": "b2a1a7bc-8010-42fb-92f4-19a3d689c719",
    "hitokoto": "所谓世人，不就是你吗？",
    "type": "d",
    "from": "人间失格",
    "from_who": "太宰治",
    "creator": "baresi48",
    "creator_uid": 10455,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1632362517",
    "length": 11
  }
]